var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 682,
    height: 770,
    viewBox: "0 0 682 770",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_241_232257)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 682,
    height: 770,
    fill: "#F2F9FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_241_232257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.911 643.181C133.911 643.181 57.4847 450.383 112.494 407.452C149.266 378.76 188.22 442.012 234.743 408.556C276.148 378.76 218.418 303.718 287.517 284.07C360.144 263.425 419.625 430.573 480.561 407.452C554.509 379.406 628.052 436.333 564.503 643.558L133.911 643.181Z",
    fill: "#E4F2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.772 222.728L316.234 225.743C320.086 226.416 323.884 227.735 327.548 229.646L329.03 226.954C325.07 224.882 320.948 223.455 316.772 222.728ZM303.734 222.594C299.37 223.24 295.275 224.747 291.557 227.089L293.255 229.673C296.595 227.6 300.286 226.227 304.219 225.635L303.734 222.594ZM347.483 242.512C347.267 242.242 347.052 242 346.809 241.731C345.247 239.901 343.631 238.205 342.014 236.617C341.179 235.809 340.371 235.029 339.536 234.302L337.435 236.563C338.189 237.236 338.943 237.936 339.697 238.663C341.233 240.143 342.742 241.758 344.25 243.48C344.52 243.803 344.816 244.126 345.085 244.449C345.328 244.746 345.597 245.042 345.84 245.365L348.291 243.454C348.022 243.157 347.752 242.834 347.483 242.512ZM282.021 235.702C279.57 238.743 277.28 242.323 275.232 246.387L278.061 247.733C280.028 243.857 282.183 240.439 284.499 237.586L282.021 235.702ZM360.36 261.38C358.824 258.661 357.262 256.104 355.699 253.709L354.622 254.354L353.032 255.323C353.544 256.104 354.029 256.885 354.541 257.692C355.591 259.361 356.615 261.11 357.666 262.941C358.205 263.91 358.77 264.906 359.309 265.901L362.084 264.475C361.518 263.425 360.925 262.375 360.36 261.38ZM270.357 257.961C269.063 261.622 267.851 265.659 266.774 269.912L269.818 270.666C270.895 266.467 272.081 262.537 273.32 258.957L270.357 257.961ZM367.741 275.591L364.885 276.883C366.556 280.382 368.253 284.177 369.95 288.134L372.859 286.95C371.135 282.966 369.411 279.144 367.741 275.591ZM264.08 282.078C263.352 285.927 262.652 290.045 262.005 294.325L265.103 294.755C265.723 290.503 266.423 286.438 267.151 282.643L264.08 282.078ZM381.884 309.963C380.86 307.217 379.89 304.606 378.948 302.103C378.463 300.865 378.005 299.654 377.52 298.443L375.823 299.089L374.583 299.546C375.769 302.615 376.981 305.764 378.247 309.128C378.49 309.774 378.732 310.42 378.974 311.066L381.938 310.043C381.911 310.017 381.911 309.99 381.884 309.963ZM260.389 306.598C259.931 310.474 259.527 314.619 259.123 318.926L262.248 319.195C262.625 314.915 263.056 310.797 263.514 306.948L260.389 306.598ZM531.988 318.36L531.691 321.402C535.571 321.752 539.504 322.748 543.383 324.336L544.595 321.51C540.447 319.814 536.19 318.737 531.988 318.36ZM518.949 319.787C515.124 320.998 511.218 322.936 507.366 325.574L509.171 328.077C512.78 325.628 516.39 323.797 519.919 322.694L518.949 319.787ZM388.915 329.773C387.891 326.812 386.975 324.174 386.113 321.725L383.15 322.721C384.255 325.87 385.44 329.288 386.841 333.406C386.948 333.729 387.083 334.079 387.191 334.402L390.154 333.433C389.723 332.141 389.319 330.93 388.915 329.773ZM555.856 327.808L553.997 330.284C557.149 332.518 560.274 335.183 563.291 338.197L565.527 336.071C562.402 332.922 559.142 330.15 555.856 327.808ZM123.728 336.502L123.297 339.543C126.987 340.028 130.84 341.239 134.746 343.15L136.147 340.405C131.917 338.359 127.742 337.04 123.728 336.502ZM258.126 331.253C257.857 335.102 257.561 339.14 257.291 343.608L260.416 343.796C260.685 339.355 260.955 335.344 261.224 331.495L258.126 331.253ZM497.533 333.756C494.731 336.475 491.957 339.516 489.02 343.069L491.445 344.98C494.327 341.535 497.048 338.547 499.742 335.91L497.533 333.756ZM110.582 337.525C106.648 338.709 102.742 340.701 98.9977 343.5L100.91 345.922C104.359 343.365 107.941 341.508 111.524 340.432L110.582 337.525ZM573.878 345.546L571.373 347.403C573.77 350.498 576.141 353.889 578.377 357.469L581.044 355.881C578.754 352.194 576.329 348.722 573.878 345.546ZM147.03 347.16L145.117 349.583C148.134 351.844 151.286 354.535 154.492 357.577L156.674 355.37C153.388 352.274 150.128 349.502 147.03 347.16ZM394.168 345.115L391.259 346.057L391.178 346.084V346.111C391.851 348.049 392.579 350.175 393.333 352.382C393.953 354.159 394.572 355.989 395.219 357.792L397.428 357.066L398.209 356.823C396.781 352.705 395.353 348.587 394.168 345.115ZM89.6769 352.274C87.1177 355.208 84.5854 358.627 82.107 362.368L84.747 364.01C87.1446 360.349 89.5961 357.066 92.0475 354.239L89.6769 352.274ZM481.316 352.974C479.107 355.989 476.763 359.326 474.15 363.202L476.763 364.898C479.376 361.049 481.693 357.738 483.875 354.751L481.316 352.974ZM256.591 355.935C256.375 360.107 256.16 364.171 255.944 368.263L259.069 368.424C259.285 364.333 259.5 360.242 259.716 356.097L256.591 355.935ZM165.456 364.414L163.113 366.432C165.726 369.285 168.366 372.354 171.221 375.799L173.673 373.888C170.79 370.416 168.096 367.32 165.456 364.414ZM587.267 366.701L584.465 368.101C586.297 371.6 588.075 375.341 589.772 379.163L592.654 377.952C590.957 374.049 589.125 370.281 587.267 366.701ZM402.384 368.424L399.421 369.447C401.011 373.78 402.492 377.575 403.92 381.048L406.829 379.917C405.429 376.472 403.974 372.731 402.384 368.424ZM467.254 373.565C464.91 377.091 462.62 380.59 460.384 383.901L462.997 385.569C465.233 382.259 467.55 378.733 469.867 375.207L467.254 373.565ZM75.7764 373.161C73.8368 376.822 71.978 380.536 70.2808 384.358L73.1633 385.596C74.8604 381.855 76.6653 378.168 78.578 374.588L75.7764 373.161ZM255.298 380.617C255.028 385.327 254.786 389.338 254.57 392.917L257.076 393.079L257.695 393.106C257.722 392.837 257.722 392.594 257.749 392.325C257.965 388.934 258.207 385.139 258.45 380.752L255.298 380.617ZM181.458 383.658L178.953 385.516C181.215 388.423 183.613 391.572 186.469 395.394L189.001 393.59C186.145 389.741 183.748 386.592 181.458 383.658ZM597.342 389.472L594.405 390.522C595.806 394.263 597.153 398.166 598.419 402.123L601.41 401.208C600.116 397.197 598.77 393.24 597.342 389.472ZM411.813 391.168L408.984 392.487C411.086 396.82 413.106 400.427 415.127 403.495L417.767 401.827C415.8 398.866 413.86 395.394 411.813 391.168ZM453.272 394.021C450.659 397.52 448.342 400.4 446.16 402.769C445.945 403.011 445.702 403.253 445.487 403.495L447.804 405.568C448.181 405.164 448.585 404.734 448.962 404.303C451.09 401.934 453.353 399.162 455.831 395.824L453.272 394.021ZM65.4857 395.851C64.031 399.673 62.6571 403.63 61.4179 407.614L64.4081 408.502C65.6473 404.572 66.9943 400.696 68.422 396.928L65.4857 395.851ZM436.166 410.817C432.529 412.512 429.135 412.485 425.714 410.386L424.043 412.97C426.333 414.369 428.731 415.096 431.182 415.096C433.23 415.096 435.385 414.585 437.54 413.589L436.166 410.817ZM196.463 403.576L193.931 405.38C196.221 408.448 198.861 412.001 201.42 415.338L203.952 413.508C201.393 410.171 198.753 406.618 196.463 403.576ZM253.627 405.218C253.223 409.794 252.792 413.777 252.307 417.438L252.819 417.492L255.405 417.815C255.54 416.711 255.702 415.581 255.836 414.396C256.16 411.651 256.456 408.69 256.752 405.46L253.627 405.218ZM604.912 413.104L601.868 413.885C602.918 417.734 603.915 421.744 604.858 425.782L607.929 425.109C606.986 421.045 605.962 417.007 604.912 413.104ZM58.0236 419.537C57.0268 423.494 56.1109 427.558 55.3027 431.649L58.3738 432.242C59.182 428.204 60.0979 424.194 61.0677 420.291L58.0236 419.537ZM216.209 428.904C215.859 428.473 215.482 428.043 215.105 427.612C213.973 426.266 212.788 424.84 211.549 423.306L209.07 425.19C209.932 426.266 210.768 427.289 211.603 428.285C212.007 428.769 212.384 429.227 212.788 429.685C214.35 431.515 215.832 433.211 217.26 434.745L219.604 432.699C218.526 431.515 217.395 430.25 216.209 428.904ZM251.849 429.819L250.233 429.469C250.233 429.523 250.206 429.55 250.206 429.604C249.937 430.842 249.64 432.026 249.317 433.13C249.075 433.964 248.859 434.772 248.59 435.525C247.916 437.571 247.216 439.32 246.435 440.774L249.236 442.174C249.64 441.366 250.045 440.532 250.422 439.59C251.23 437.652 251.957 435.391 252.631 432.78C252.846 431.919 253.062 431.03 253.277 430.115L251.849 429.819ZM235.821 445.646C233.423 444.757 231.214 443.25 228.466 441.151L226.473 443.519C229.598 445.915 232.103 447.584 234.878 448.58C235.982 448.983 237.114 449.279 238.353 449.468L238.676 446.426C237.68 446.238 236.737 445.996 235.821 445.646ZM610.461 437.248L607.39 437.813C608.144 441.743 608.872 445.807 609.518 449.898L612.616 449.414C611.97 445.296 611.242 441.205 610.461 437.248ZM53.1746 443.869C52.5819 447.88 52.0431 452.025 51.639 456.17L54.764 456.466C55.195 452.375 55.7068 448.283 56.2995 444.3L53.1746 443.869ZM614.394 461.661L611.269 462.037C611.781 466.021 612.266 470.139 612.67 474.23L615.795 473.934C615.391 469.789 614.906 465.671 614.394 461.661ZM50.6154 468.497C50.3729 472.535 50.2113 476.707 50.1035 480.852L53.2554 480.906C53.3362 476.787 53.4978 472.669 53.7403 468.659L50.6154 468.497ZM616.899 486.235L613.775 486.45C614.071 490.461 614.34 494.606 614.556 498.697L617.681 498.535C617.492 494.417 617.223 490.272 616.899 486.235ZM53.2284 493.179L50.1035 493.233C50.1574 497.297 50.2921 501.442 50.5076 505.587L53.6325 505.426C53.4439 501.308 53.3093 497.19 53.2284 493.179ZM618.193 510.89L615.068 510.971C615.175 515.008 615.256 519.126 615.31 523.244L618.462 523.217C618.408 519.099 618.327 514.954 618.193 510.89ZM54.4676 517.673L51.3427 517.915C51.666 521.952 52.097 526.097 52.555 530.215L55.6799 529.866C55.195 525.801 54.7909 521.683 54.4676 517.673ZM615.283 535.545C615.229 539.582 615.148 543.727 615.041 547.818L618.166 547.899C618.3 543.781 618.381 539.609 618.408 535.545H615.283ZM57.2154 542.058L54.1174 542.489C54.6831 546.526 55.3297 550.618 56.0301 554.709L59.1281 554.197C58.4277 550.16 57.8081 546.069 57.2154 542.058ZM614.556 560.119C614.367 564.156 614.125 568.301 613.855 572.393L616.98 572.581C617.25 568.463 617.492 564.318 617.681 560.254L614.556 560.119ZM61.364 566.283L58.293 566.875C59.1011 570.885 59.9362 574.95 60.8522 578.987L63.9232 578.341C63.0073 574.304 62.1452 570.266 61.364 566.283ZM615.175 584.828L612.993 584.666C612.939 585.474 612.859 586.281 612.805 587.089C612.535 590.345 612.239 593.629 611.916 596.913L615.041 597.209C615.445 593.091 615.822 588.973 616.145 584.909L615.175 584.828ZM66.7518 590.265L63.7077 590.991C64.7044 594.975 65.782 599.012 66.8865 602.969L69.9037 602.162C68.8261 598.232 67.7485 594.248 66.7518 590.265ZM610.596 609.133C610.299 611.717 610.003 614.354 609.68 616.992C609.518 618.446 609.33 619.899 609.141 621.353L612.266 621.729C612.455 620.276 612.643 618.823 612.805 617.369C613.128 614.731 613.424 612.067 613.721 609.456L610.596 609.133ZM74.4294 617.477C74.0523 616.319 73.7021 615.162 73.3519 613.978L70.3347 614.839C70.6849 615.943 71.0082 617.073 71.3584 618.177C72.2473 621.057 73.1902 623.883 74.1061 626.655L77.0964 625.713C76.2074 623.021 75.3184 620.276 74.4294 617.477Z",
    fill: "#CEE8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.117 580.28C599.351 576.501 603.561 610.594 566.845 610.594C533.272 610.594 522.534 480.754 498.101 517.871C372.897 708.122 445.584 436.971 346.012 433.515C300.982 431.95 270.98 479.405 259.923 563.436C243.883 639.396 206.686 505.508 168.398 517.952C144.071 525.861 146.869 610.594 113.296 610.594C76.5795 610.594 80.7894 576.501 55.0238 580.28C27.2865 584.356 19 644.687 19 644.687H661.114C661.141 644.687 652.854 584.329 625.117 580.28Z",
    fill: "#CEE8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.087 616.938C585.139 615.323 589.045 629.858 554.886 629.858C523.664 629.858 524.526 597.316 503.621 590.399C465.153 577.668 433.418 642.104 418.494 609.778C390.154 523.971 307.533 480.932 269.387 609.778C254.463 642.131 219.577 584.424 184.26 590.399C162.52 594.087 164.217 629.858 132.995 629.858C98.8364 629.858 102.743 615.35 78.7938 616.938C52.9863 618.661 45.2817 644.365 45.2817 644.365H642.546C642.573 644.365 634.868 618.661 609.087 616.938Z",
    fill: "#9CD0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3358 644.687C19.3358 644.687 15.4693 657.682 33.9753 661.263C82.1068 670.545 155.144 658.372 104.479 688.817C79.7603 703.669 219.648 712.898 380.896 711.492C562.942 709.901 653.739 699.187 595.928 684.362C538.117 669.537 676.271 675.557 661.952 644.687H19.3358Z",
    fill: "#CEE8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.63 294.674V638.31C492.63 644.231 487.835 648.995 481.909 648.995H217.071C211.145 649.022 206.323 644.096 206.35 638.31V294.674C206.35 288.753 211.145 283.989 217.071 283.989H481.909C487.835 283.962 492.63 288.753 492.63 294.674Z",
    fill: "#9CD0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.63 294.674V638.31C492.63 644.231 487.835 648.995 481.908 648.995H217.071C211.576 648.995 207.05 644.877 206.43 639.548L206.35 638.283C206.35 638.283 472.534 624.959 472.534 283.935H473.638C484.279 283.316 492.037 283.585 492.63 294.674Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.561 300.273H226.446V623.398H472.561V300.273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.533 300.273V623.398H273.535C350.365 595.863 467.119 518.184 472.372 300.273H472.533Z",
    fill: "#F5FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.276 466.317C405.671 465.94 405.671 433.856 427.276 433.453C448.881 433.856 448.881 465.94 427.276 466.317ZM427.276 436.117C409.146 436.44 409.146 463.356 427.276 463.679C445.406 463.356 445.406 436.413 427.276 436.117Z",
    fill: "#B1D2EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.028 457.569C427.438 458.135 419.491 448.714 418.333 447.96C415.908 445.511 419.626 441.797 422.077 444.219L429.054 451.19L444.733 435.525C447.184 433.103 450.902 436.817 448.477 439.267C447.723 439.617 429.836 458.942 429.028 457.569Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.276 533.607C405.671 533.23 405.671 501.146 427.276 500.743C448.881 501.146 448.881 533.23 427.276 533.607ZM427.276 503.407C409.146 503.73 409.146 530.646 427.276 530.969C445.406 530.646 445.406 503.73 427.276 503.407Z",
    fill: "#B1D2EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.028 524.617C427.465 525.182 419.464 515.761 418.333 515.008C415.908 512.558 419.626 508.844 422.077 511.266L429.054 518.238L444.733 502.573C447.184 500.15 450.902 503.865 448.477 506.314C447.669 506.691 429.863 525.962 429.028 524.617Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.276 600.897C405.671 600.52 405.671 568.436 427.276 568.032C448.881 568.436 448.881 600.52 427.276 600.897ZM427.276 570.697C409.146 571.02 409.146 597.936 427.276 598.259C445.406 597.936 445.406 571.02 427.276 570.697Z",
    fill: "#B1D2EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.028 591.664C427.465 592.229 419.464 582.809 418.333 582.055C415.908 579.606 419.626 575.891 422.077 578.314L429.054 585.285L444.733 569.62C447.184 567.198 450.902 570.912 448.477 573.361C447.669 573.738 429.863 593.01 429.028 591.664Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.438 277.368H398.505V260.599C398.505 256.535 395.219 253.251 391.151 253.251H307.802C303.734 253.251 300.447 256.535 300.447 260.599V277.368C263.568 279.063 263.352 268.162 264.188 305.845C264.188 309.909 267.474 313.193 271.542 313.193H427.438C431.506 313.193 434.792 309.909 434.792 305.845V284.716C434.765 280.651 431.479 277.368 427.438 277.368ZM349.476 272.657C343.173 272.55 343.173 263.183 349.476 263.075C355.78 263.183 355.78 272.55 349.476 272.657Z",
    fill: "#FAC69C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.766 284.716V305.845C434.766 309.909 431.479 313.193 427.411 313.193H271.515C267.448 313.193 264.161 309.909 264.161 305.845C264.161 305.845 391.125 312.816 391.125 253.251C395.192 253.251 398.479 256.535 398.479 260.599V277.368H427.411C431.479 277.368 434.766 280.651 434.766 284.716Z",
    fill: "#F7A96B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.477 253.251C303.869 253.251 300.448 277.368 300.448 277.368V260.599C300.448 256.535 303.734 253.251 307.802 253.251H349.477Z",
    fill: "#FBD4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.633 332.33H250.61V414.316H334.633V332.33Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.608 379.756C302.532 379.756 310.577 371.802 310.577 361.991C310.577 352.18 302.532 344.227 292.608 344.227C282.685 344.227 274.64 352.18 274.64 361.991C274.64 371.802 282.685 379.756 292.608 379.756Z",
    fill: "#E6F3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.439 409.498V414.423H265.777V409.471C265.777 394.667 277.792 382.663 292.608 382.663C300.016 382.663 306.724 385.65 311.573 390.522C316.422 395.394 319.439 402.096 319.439 409.498Z",
    fill: "#E6F3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.461 349.475H407.718C405.86 349.475 404.351 347.968 404.351 346.111C404.351 344.253 405.86 342.746 407.718 342.746H453.461C455.32 342.746 456.828 344.253 456.828 346.111C456.828 347.968 455.32 349.475 453.461 349.475Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.784 349.475H362.865C361.006 349.475 359.498 347.968 359.498 346.111C359.498 344.253 361.006 342.746 362.865 342.746H395.784C397.643 342.746 399.152 344.253 399.152 346.111C399.152 347.968 397.643 349.475 395.784 349.475Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.461 370.577H362.892C361.033 370.577 359.524 369.07 359.524 367.213C359.524 365.356 361.033 363.848 362.892 363.848H453.461C455.319 363.848 456.828 365.356 456.828 367.213C456.828 369.07 455.319 370.577 453.461 370.577Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.461 412.781H362.892C361.033 412.781 359.524 411.274 359.524 409.417C359.524 407.56 361.033 406.052 362.892 406.052H453.461C455.319 406.052 456.828 407.56 456.828 409.417C456.828 411.274 455.319 412.781 453.461 412.781Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.461 391.679H430.779C428.92 391.679 427.411 390.172 427.411 388.315C427.411 386.458 428.92 384.95 430.779 384.95H453.461C455.32 384.95 456.828 386.458 456.828 388.315C456.828 390.172 455.32 391.679 453.461 391.679Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.733 391.679H362.892C361.033 391.679 359.524 390.172 359.524 388.315C359.524 386.458 361.033 384.95 362.892 384.95H419.733C421.592 384.95 423.1 386.458 423.1 388.315C423.1 390.172 421.592 391.679 419.733 391.679Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.205 442.954H305.431C303.572 442.954 302.063 441.447 302.063 439.59C302.063 437.733 303.572 436.225 305.431 436.225H391.205C393.063 436.225 394.572 437.733 394.572 439.59C394.572 441.447 393.063 442.954 391.205 442.954Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.608 442.954H250.448C248.59 442.954 247.081 441.447 247.081 439.59C247.081 437.733 248.59 436.225 250.448 436.225H292.608C294.467 436.225 295.975 437.733 295.975 439.59C295.975 441.447 294.467 442.954 292.608 442.954Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.205 468.955H354.11C352.251 468.955 350.743 467.448 350.743 465.591C350.743 463.733 352.251 462.226 354.11 462.226H391.205C393.064 462.226 394.572 463.733 394.572 465.591C394.572 467.448 393.064 468.955 391.205 468.955Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.64 468.955H250.448C248.59 468.955 247.081 467.448 247.081 465.591C247.081 463.733 248.59 462.226 250.448 462.226H340.64C342.499 462.226 344.007 463.733 344.007 465.591C344.007 467.448 342.499 468.955 340.64 468.955Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.205 598.878H250.448C248.59 598.878 247.081 597.371 247.081 595.514C247.081 593.656 248.59 592.149 250.448 592.149H391.205C393.063 592.149 394.572 593.656 394.572 595.514C394.572 597.371 393.063 598.878 391.205 598.878Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.205 572.904H320.841C318.982 572.904 317.473 571.397 317.473 569.54C317.473 567.682 318.982 566.175 320.841 566.175H391.205C393.064 566.175 394.572 567.682 394.572 569.54C394.572 571.397 393.064 572.904 391.205 572.904Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.576 572.904H250.448C248.59 572.904 247.081 571.397 247.081 569.54C247.081 567.682 248.59 566.175 250.448 566.175H310.576C312.435 566.175 313.944 567.682 313.944 569.54C313.944 571.397 312.435 572.904 310.576 572.904Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.205 546.903H250.448C248.59 546.903 247.081 545.396 247.081 543.539C247.081 541.681 248.59 540.174 250.448 540.174H391.205C393.063 540.174 394.572 541.681 394.572 543.539C394.572 545.396 393.063 546.903 391.205 546.903Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.205 520.929H354.945C353.086 520.929 351.578 519.422 351.578 517.565C351.578 515.708 353.086 514.2 354.945 514.2H391.205C393.064 514.2 394.572 515.708 394.572 517.565C394.572 519.422 393.064 520.929 391.205 520.929Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.954 520.929H308.717C306.859 520.929 305.35 519.422 305.35 517.565C305.35 515.708 306.859 514.2 308.717 514.2H343.954C345.812 514.2 347.321 515.708 347.321 517.565C347.321 519.422 345.812 520.929 343.954 520.929Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.326 520.929H250.448C248.59 520.929 247.081 519.422 247.081 517.565C247.081 515.708 248.59 514.2 250.448 514.2H296.352C298.211 514.2 299.72 515.708 299.72 517.565C299.72 519.422 298.211 520.929 296.326 520.929Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.205 494.929H250.448C248.59 494.929 247.081 493.421 247.081 491.564C247.081 489.707 248.59 488.2 250.448 488.2H391.205C393.063 488.2 394.572 489.707 394.572 491.564C394.572 493.421 393.063 494.929 391.205 494.929Z",
    fill: "#52ADF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.008 621.73L162.466 630.773C162.035 630.935 161.577 630.719 161.416 630.289C161.658 629.777 153.092 610.29 154.843 610.398C154.87 610.344 179.438 601.381 179.492 601.327C179.923 601.166 180.381 601.381 180.542 601.812L187.493 620.707C187.654 621.11 187.439 621.595 187.008 621.73Z",
    fill: "#8A9EDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.61 602.907L156.53 611.397L162.998 628.951L186.079 620.461L179.61 602.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.304 613.412C186.765 611.932 185.661 608.944 185.122 607.464C184.853 606.656 183.667 607.464 183.209 607.572L182.455 605.499C182.347 605.203 182.024 605.068 181.728 605.176L180.623 605.58C180.219 605.687 179.707 605.93 179.896 606.441L183.991 617.557C184.179 618.069 184.745 617.934 185.095 617.746C185.526 617.503 186.846 617.396 186.55 616.615L185.795 614.543C186.2 614.327 187.627 614.193 187.304 613.412ZM185.041 610.478C185.472 610.317 185.742 611.017 185.284 611.151C184.853 611.34 184.61 610.64 185.041 610.478Z",
    fill: "#FCB4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.199 617.342C185.687 617.396 184.259 618.446 183.963 617.558L179.868 606.441C179.76 606.145 179.922 605.822 180.191 605.715C180.191 605.715 183.02 614.947 187.276 613.386C187.6 614.166 186.172 614.301 185.741 614.543L186.495 616.616C186.657 616.912 186.495 617.235 186.199 617.342Z",
    fill: "#F49F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.117 533.903C145.117 533.903 144.659 541.978 148.539 546.742C152.391 551.479 123.647 545.638 123.647 545.638L126.772 530.619L145.117 533.903Z",
    fill: "#C92828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.268 600.143C165.268 600.143 163.382 602.431 160.392 603.507C157.078 599.201 152.768 593.629 150.182 588.704C146.087 577.211 141.615 554.009 139.298 543.996C159.503 547.334 159.098 583.939 165.268 600.143Z",
    fill: "#A523A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.595 605.876C172.46 606.199 172.11 606.334 171.814 606.172C170.979 605.715 169.847 605.419 168.931 605.203L161.766 607.814C161.766 607.814 160.526 605.123 160.607 603.75C160.688 602.404 164.19 599.901 165.349 600.305C165.349 600.305 166.291 601.704 168.635 603.185C169.416 603.642 172.999 604.746 172.595 605.876Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.375 600.278C165.375 600.278 163.624 602.673 160.634 603.723C160.634 603.723 159.799 603.265 159.287 602.054C159.287 602.054 163.409 600.547 164.513 598.071C164.863 598.447 165.375 599.497 165.375 600.278Z",
    fill: "#CE4ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.098 572.554C184.098 572.554 187.357 572.096 189.405 572.204L187.088 576.834C187.088 576.834 182.508 574.654 182.293 574.142C182.077 573.631 184.098 572.554 184.098 572.554Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.078 699.328C123.889 700.082 123.216 700.701 122.381 700.701H114.057C112.871 700.701 112.036 699.49 112.36 698.413C113.006 696.26 114.488 694.106 114.191 691.792C114.138 687.243 114.218 678.091 114.191 675.131H123.593C123.405 677.688 122.543 687.781 122.273 692.115C121.896 694.752 124.132 696.798 124.078 699.328Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.228 556.728C133.992 562.272 132.537 571.155 139.137 574.25C149.131 578.207 160.715 577.587 170.925 574.627C171.491 574.438 172.083 574.25 172.622 574.062C172.649 574.062 172.703 574.035 172.703 574.035L173.807 574.008C176.501 573.819 177.579 577.722 175.208 578.96C174.912 579.095 174.427 579.418 174.158 579.552C162.332 585.797 141.454 590.426 129.628 582.405C120.01 575.811 119.094 562.488 121.923 552.152C124.967 542.382 139.487 547.065 136.228 556.728Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.066 699.328C169.012 700.055 168.393 700.701 167.558 700.701H146.734C146.518 698.574 147.219 696.636 147.111 694.321C147.219 688.158 145.953 680.675 145.495 675.104H157.456C157.321 677.472 155.597 687.404 155.57 691.657C156.836 696.448 163.759 694.967 166.938 696.825C167.908 697.363 169.12 698.144 169.066 699.328Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.174 699.328C169.147 700.055 168.555 700.701 167.746 700.701H146.734C146.492 698.574 147.03 696.475 147.111 694.322C147.138 693.783 147.138 693.245 147.111 692.707C153.9 700.889 166.076 693.245 169.04 698.709C169.12 698.897 169.174 699.113 169.174 699.328Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.105 699.328C123.944 700.109 123.216 700.701 122.381 700.701H114.057C111.633 700.539 112.198 697.875 113.168 696.367C113.168 696.367 117.829 692.599 123.27 696.367C123.728 697.229 124.24 698.278 124.105 699.328Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.198 691.172C112.198 691.172 118.96 693.676 123.674 691.63C126.53 676.342 134.827 645.523 137.656 615.727C137.656 614.516 147.003 657.608 144.606 690.661C147.596 691.711 154.088 693.326 157.105 690.823C159.288 675.265 165.106 631.177 156.082 584.451C156.082 584.451 136.874 586.873 119.876 582.432C119.876 582.432 112.468 595.217 114.326 622.564C115.889 649.103 114.704 675.507 112.198 691.172Z",
    fill: "#1D3F70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.108 547.173C244.549 550.968 240.239 556.674 237.518 560.442C231.187 569.002 226.716 576.969 215.778 580.145C209.232 582.137 202.47 581.975 196.032 580.522C192.961 579.822 189.998 578.826 187.223 577.561C185.822 576.915 185.203 575.246 185.849 573.847C186.334 572.797 187.385 572.205 188.462 572.205C198.888 572.339 211.603 571.559 217.718 561.977C218.364 560.9 218.957 559.769 219.577 558.693C224.049 551.076 229.167 543.755 235.498 537.564C242.071 530.566 252.658 539.421 247.108 547.173Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.165 689.261C115.646 676.261 118.556 648.242 117.451 630.477C116.858 612.497 119.418 603.4 119.445 603.319C119.768 602.727 126.045 599.954 128.739 593.091C128.927 592.579 129.735 592.876 129.547 593.387C127.176 599.658 121.33 603.131 120.226 603.723C116.266 618.796 120.468 672.95 114.165 689.261Z",
    fill: "#163860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.644 593.226C147.758 599.443 123.97 596.159 115.997 593.845C114.192 588.946 118.987 582.432 118.017 576.242C115.727 561.761 123.055 547.415 131.648 544.346C131.648 544.292 131.648 543.566 131.648 543.593L139.38 544.05C143.286 546.823 146.734 549.945 150.505 555.301C156.216 563.376 151.933 567.359 153.576 575.03C153.927 578.772 160.015 591.476 157.644 593.226Z",
    fill: "#CE4ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.675 544.375C131.647 544.319 131.675 544.319 131.675 544.375V544.375Z",
    fill: "#D8B09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.77 565.529C229.652 589 198.537 583.778 188.651 578.234C190.402 575.919 189.405 572.231 189.405 572.231C223.806 571.155 219.604 541.547 237.734 535.437C237.707 535.41 238.838 552.26 234.77 565.529Z",
    fill: "#1D3F70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.891 699.382L256.214 699.22C256.214 699.436 256.51 700.189 256.726 700.189L266.424 700.378C266.666 700.378 266.801 699.974 266.801 699.759L267.636 699.543C267.636 698.198 267.528 697.686 266.882 696.636C264.511 693.73 267.34 680.595 267.259 677.176C267.717 676.234 257.076 676.988 256.887 676.746C256.645 676.746 256.456 676.934 256.483 677.176C256.376 680.595 259.042 693.783 256.78 696.636C256.106 697.686 255.891 698.036 255.891 699.382Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.839 700.701H233.154C234.824 700.647 234.851 699.086 234.528 697.767C233.451 693.272 235.336 682.936 235.686 678.307C235.767 677.472 235.067 676.719 234.151 676.719C220.089 676.665 224.453 675.211 225.638 689.907C226.231 695.344 220.089 695.721 216.425 696.448C214.917 696.798 213.3 697.363 212.546 698.44C211.872 699.382 212.6 700.701 213.839 700.701Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.255 698.817C235.201 699.732 234.717 700.701 233.639 700.701H213.596C208.586 699.247 215.94 692.734 224.911 693.245C225.611 693.407 230.191 693.891 234.205 693.38C234.205 693.353 235.525 695.587 235.255 698.817Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.101 700.701H257.534C253.412 700.27 256.295 693.245 261.817 693.218C267.555 693.164 270.195 700.297 266.101 700.701Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.365 698.171C218.203 698.171 218.041 698.09 217.987 697.928C217.206 696.152 215.778 695.587 215.778 695.587C215.267 695.398 215.563 694.618 216.075 694.806C216.156 694.833 217.853 695.479 218.769 697.605C218.876 697.848 218.661 698.171 218.365 698.171Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.678 697.794C221.516 697.794 221.354 697.686 221.274 697.525C220.6 695.479 218.688 694.51 218.661 694.51C218.176 694.295 218.553 693.541 219.011 693.783C219.092 693.837 221.274 694.887 222.055 697.282C222.163 697.498 221.974 697.794 221.678 697.794Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.45 697.363C225.288 697.363 225.127 697.255 225.073 697.094C224.265 694.941 222.433 693.81 222.433 693.783C221.975 693.514 222.406 692.787 222.864 693.083C222.945 693.137 224.965 694.402 225.854 696.798C225.935 697.067 225.746 697.363 225.45 697.363Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.771 565.529C230.81 583.267 212.25 582.863 212.25 582.863C212.25 582.863 218.445 580.144 220.304 569.324C222.163 558.504 229.194 547.63 229.194 547.63L234.771 565.529Z",
    fill: "#163860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.888 695.614C261.682 693.891 258.692 696.179 258.288 695.371C258.207 695.156 258.288 694.914 258.504 694.833C258.665 694.779 262.221 693.299 265.077 694.86C265.454 695.021 265.292 695.614 264.888 695.614Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.195 698.817H235.255C235.174 699.463 234.986 700.109 234.636 700.701H213.596C212.573 700.701 211.818 699.732 212.195 698.817Z",
    fill: "#0F2E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.1 700.701H257.534C256.456 700.701 255.567 699.839 255.621 698.817H267.986C268.067 699.839 267.178 700.701 266.1 700.701Z",
    fill: "#0F2E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.605 690.473C268.605 690.473 259.473 692.545 254.759 690.311C252.307 675.938 245.519 635.914 243.148 608.514C243.067 610.102 238.084 674.592 237.141 690.311C233.881 691.334 227.362 692.545 223.698 690.096C222.055 673.542 216.775 619.038 224.722 574.519C224.722 574.519 246.488 576.78 263.487 571.989C268.147 586.066 269.414 673.516 268.605 690.473Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.201 688.669C223.887 657.178 225.746 617.208 229.356 597.72C230.433 598.151 228.09 608.137 227.416 624.852C226.015 639.548 226.877 664.23 227.201 688.669Z",
    fill: "#D1A68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.413 688.669C258.504 639.548 250.853 594.114 251.58 593.414C252.604 593.548 260.335 639.736 261.413 688.669Z",
    fill: "#D1A68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.37 534.064C240.885 529.919 241.532 523.944 242.125 521.494C242.421 520.176 243.391 519.153 244.441 518.83C247.189 517.888 250.422 520.202 249.56 523.298C249.317 523.136 248.509 531.911 249.075 534.36C256.321 536.513 234.609 543.619 241.37 534.064Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.668 522.867C249.641 523.002 249.614 523.136 249.587 523.271C249.398 523.163 248.913 528.008 248.913 531.507C245.6 533.015 241.936 532.396 241.263 532.261C241.128 527.389 240.939 519.987 244.468 518.803C247.028 517.726 250.126 520.068 249.668 522.867Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.942 598.474C264.942 598.474 265.05 600.089 264.942 601.462L268.713 602.835L270.707 602C270.707 602 270.518 600.466 271.192 598.663C271.892 596.859 264.942 598.474 264.942 598.474Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.504 596.671C265.319 597.667 263.568 598.447 261.413 599.039C249.021 602.431 223.645 599.47 221.543 595.11C219.873 591.637 219.765 580.737 222.136 569.19C225.261 553.148 230.191 541.843 241.397 534.037C241.343 534.253 239.916 540.201 249.102 534.334L251.93 534.845C252.873 550.214 273.616 589.565 266.504 596.671Z",
    fill: "#1D3F70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.114 690.311C237.141 690.284 235.929 690.715 234.286 691.011C234.286 691.011 238.865 627.005 239.566 618.473C240.239 609.94 243.122 608.487 243.122 608.487C243.122 608.487 237.033 688.938 237.114 690.311Z",
    fill: "#D1A68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.302 687.216C237.168 689.073 237.114 690.177 237.114 690.311C233.854 691.334 227.335 692.545 223.671 690.096C223.671 690.096 223.564 689.073 223.375 687.216C223.375 687.216 229.786 689.961 237.302 687.216Z",
    fill: "#D1A68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.606 690.473C268.606 690.473 259.473 692.545 254.759 690.311C254.759 690.311 254.57 689.208 254.22 687.216C254.22 687.216 260.659 688.912 268.713 687.216C268.74 689.154 268.552 690.311 268.606 690.473Z",
    fill: "#D1A68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.605 690.661C144.605 690.661 153.334 693.918 157.105 690.823C157.105 690.823 157.24 689.746 157.509 687.835C157.509 687.835 150.99 690.15 144.794 686.812C144.74 688.104 144.686 689.369 144.605 690.661Z",
    fill: "#163860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.198 691.172C112.198 691.172 118.96 693.675 123.674 691.63C123.674 691.63 123.944 690.284 124.402 687.915C124.402 687.915 120.172 690.122 112.791 687.377C112.602 688.884 112.387 690.149 112.198 691.172Z",
    fill: "#163860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.794 686.812C144.74 688.104 144.686 689.369 144.606 690.661C144.606 690.661 145.575 691.011 147.003 691.388C146.976 668.429 147.003 631.366 137.655 615.727C137.655 615.727 146.141 650.799 144.794 686.812Z",
    fill: "#163860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.655 616.158C136.551 616.104 138.329 612.766 138.975 608.568C139.083 608.029 139.918 608.191 139.81 608.729C138.733 613.036 138.463 615.862 137.655 616.158Z",
    fill: "#163860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.595 574.088C176.232 572.204 180.03 572.608 185.715 574.654C187.681 574.896 189.001 578.583 185.849 579.175C181.216 580.064 175.262 578.825 175.262 578.825L172.595 574.088Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.495 574.923C180.219 573.281 182.644 572.446 185.041 572.527C186.55 572.5 187.573 574.734 186.065 574.734C184.179 574.411 181.189 574.788 179.572 575.865C178.872 576.565 177.795 575.649 178.495 574.923Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.192 579.229C179.464 580.521 177.929 579.633 178.683 578.341C179.384 577.049 180.946 577.937 180.192 579.229Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.727 579.364C181 580.656 179.465 579.767 180.219 578.475C180.919 577.21 182.482 578.099 181.727 579.364Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.29 579.525C182.563 580.817 181.027 579.929 181.781 578.637C182.509 577.372 184.044 578.26 183.29 579.525Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.879 579.525C184.152 580.817 182.616 579.929 183.371 578.637C184.098 577.372 185.634 578.26 184.879 579.525Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.93 534.845C251.984 538.344 242.987 541.44 242.475 541.44L241.397 538.237C240.023 538.586 238.784 540.524 238.784 540.524C234.824 536.595 238.434 533.499 241.397 534.038C241.343 534.253 240.724 539.475 249.075 534.145C250.126 533.661 251.93 534.845 251.93 534.845Z",
    fill: "#F4D4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.258 611.724L245.622 617.87L250.107 648.933L292.743 642.787L288.258 611.724Z",
    fill: "#8C4225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.072 648.888L247.62 647.488L243.122 616.427L245.6 617.854L250.072 648.888Z",
    fill: "#7F341C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.122 616.427L285.793 610.29L288.244 611.69L245.6 617.854L243.122 616.427Z",
    fill: "#7F341C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.044 611.851C270.869 603.292 260.066 605.714 257.642 614.354C257.588 615.054 258.073 615.7 258.692 615.592C259.42 615.458 259.528 614.57 259.824 614.031C261.575 610.075 266.316 607.518 270.276 609.806C271.488 610.452 272.593 611.555 273.347 612.766C273.994 613.816 275.233 612.874 275.044 611.851Z",
    fill: "#8C4225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.6 617.854L269.145 630.289L288.245 611.69L245.6 617.854Z",
    fill: "#99452B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.764 632.953C268.794 633.249 267.663 632.765 267.501 631.688C267.367 630.396 266.531 627.947 268.498 627.651C269.468 627.355 270.599 627.839 270.761 628.916C270.922 630.208 271.758 632.657 269.764 632.953Z",
    fill: "#F4D4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.942 601.462C264.942 601.462 262.976 605.687 262.976 610.236L269.468 610.613C271.569 607.572 270.734 602 270.734 602L264.942 601.462Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.505 596.671C265.319 597.666 263.568 598.447 261.413 599.039C261.925 592.849 260.901 583.024 256.537 571.962C252.173 560.899 252.362 549.541 252.362 549.541L255.567 549.783C261.251 565.637 271.677 592.256 266.505 596.671Z",
    fill: "#163860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.93 534.845C275.556 540.067 282.156 577.211 270.734 602C270.734 602 268.201 602.834 264.969 601.462C264.969 601.462 264.861 583.751 257.695 569.459C250.502 555.193 251.93 534.845 251.93 534.845Z",
    fill: "#1D3F70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.105 699.328C123.943 700.109 123.216 700.701 122.381 700.701H114.057C113.222 700.701 112.494 700.109 112.333 699.328H124.105Z",
    fill: "#CE3932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.174 699.328C169.147 700.055 168.555 700.701 167.746 700.701H146.734C146.653 700.243 146.626 699.812 146.653 699.328H169.174Z",
    fill: "#CE3932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.302 580.979C156.458 593.064 127.283 595.164 118.097 577.184C109.638 560.496 117.451 543.97 131.675 544.373C131.675 544.373 134.449 554.278 134.072 562.084L134.126 565.045C134.18 568.786 136.416 572.177 139.864 573.604C148.457 577.211 163.382 576.134 169.793 574.869C172.864 577.937 171.302 580.979 171.302 580.979Z",
    fill: "#A523A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.868 580.683C171.113 581.571 169.659 582.244 169.659 582.244C170.359 577.184 167.746 575.246 167.746 575.246C168.878 574.708 170.144 574.896 170.144 574.896C172.595 577.265 171.868 580.683 171.868 580.683Z",
    fill: "#CE4ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.553 576.161C183.667 576.107 180.866 576.134 181.755 575.649C181.782 575.649 185.176 575.972 187.358 575.757C188.193 576.242 185.849 576.134 185.553 576.161Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.879 577.507C184.826 577.507 180.865 577.507 181.889 576.969C185.203 577.48 187.681 576.969 187.708 576.969C188.489 577.345 186.684 577.48 184.879 577.507Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.672 610.613C263.972 611.932 262.409 611.071 263.137 609.779C263.837 608.46 265.4 609.321 264.672 610.613Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.235 610.721C265.534 612.04 263.972 611.178 264.699 609.886C265.373 608.568 266.935 609.429 266.235 610.721Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.797 610.828C267.097 612.147 265.534 611.286 266.262 609.994C266.935 608.675 268.525 609.536 267.797 610.828Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.387 610.775C268.686 612.093 267.124 611.232 267.851 609.94C268.552 608.648 270.114 609.483 269.387 610.775Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.238 545.423C140.861 549.837 133.103 546.93 132.753 546.365C132.645 546.069 131.486 543.916 131.675 543.62L139.406 544.077C139.406 544.077 140.107 544.535 141.238 545.423Z",
    fill: "#A523A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.19 512.72C140.672 511.24 149.939 523.029 144.552 533.66L131.19 512.72Z",
    fill: "#C92828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.407 544.077C139.891 539.932 139.245 533.957 138.652 531.508C137.548 526.663 129.978 528.493 131.19 533.311C131.433 533.149 131.675 543.62 131.675 543.62C132.914 545.585 139.407 547.253 139.407 544.077Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.621 541.655C134.935 543.162 138.868 542.355 139.541 542.22C140.619 525.855 132.429 523.675 131.594 540.067L131.621 541.655Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.91 529.677C126.476 533.123 127.634 536.998 130.355 539.286C131.459 540.201 132.806 540.767 134.207 541.063C142.235 543.297 151.691 533.957 145.387 527.174C143.097 525.075 142.612 521.333 140.807 519.234C138.167 515.385 132.348 515.6 129.223 518.723C126.395 521.522 125.425 525.425 125.91 529.677Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.083 527.551C139.406 526.959 138.464 526.474 138.14 527.066C137.817 527.658 138.787 528.143 139.083 527.551Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.447 526.797C143.77 526.205 142.827 525.721 142.504 526.313C142.208 526.932 143.151 527.416 143.447 526.797Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.804 531.346C141.562 531.319 141.05 531.373 141.104 531.023C141.131 530.915 141.238 530.861 141.346 530.888C142.02 531.131 143.609 530.673 142.855 530.189C141.723 529.596 140.996 527.47 140.942 527.389C140.861 527.147 141.238 527.012 141.319 527.255C141.319 527.282 142.046 529.327 143.043 529.839C144.229 530.7 142.747 531.319 141.804 531.346Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.91 529.677C126.476 533.122 127.634 536.998 130.355 539.286C128.847 537.402 127.904 533.23 127.904 533.23L128.604 531.373C140.565 527.524 139.568 517.888 139.568 517.888C137.79 516.327 135.339 516.031 133.049 516.596C127.473 518.05 125.21 524.106 125.91 529.677Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.329 516.946C137.736 516.542 131.783 513.016 131.19 512.747C131.19 512.747 126.422 515.95 126.853 516.65C123.755 519.288 122.677 524.294 124.698 528.305L128.55 530.431C139.272 526.501 138.329 516.946 138.329 516.946Z",
    fill: "#C92828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.807 549.945C140.834 551.022 139.137 551.022 139.164 549.945C139.137 548.868 140.807 548.868 140.807 549.945Z",
    fill: "#A523A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.45 553.498C142.477 554.575 140.78 554.575 140.807 553.498C140.78 552.421 142.477 552.421 142.45 553.498Z",
    fill: "#A523A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.094 557.32C144.121 558.397 142.424 558.397 142.451 557.32C142.424 556.243 144.121 556.243 144.094 557.32Z",
    fill: "#A523A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.538 610.963C264.161 610.936 264.645 608.971 264.942 607.599C264.969 607.518 265.05 607.464 265.13 607.491C265.211 607.518 265.265 607.599 265.238 607.68C264.78 609.133 264.888 610.883 264.538 610.963Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.1 610.963C265.696 610.936 266.262 609.106 266.558 607.733C266.585 607.653 266.666 607.599 266.747 607.626C266.827 607.653 266.881 607.733 266.854 607.814C266.396 609.241 266.423 610.883 266.1 610.963Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.798 610.99C267.367 610.909 268.148 609.348 268.094 607.787C268.094 607.706 268.175 607.625 268.256 607.625C268.337 607.625 268.417 607.706 268.417 607.787C268.39 609.187 267.959 610.802 267.959 610.855C267.932 610.936 267.879 610.99 267.798 610.99Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.951 513.824C137.951 513.824 131.001 507.795 123.674 512.962C115.592 518.669 119.283 528.439 115.619 532.772C110.366 538.963 110.986 545.638 115.969 547.818C119.714 549.46 126.206 550.16 131.648 549.137C133.372 548.814 135.15 547.738 133.129 545.1C131.028 542.381 127.903 537.806 127.338 533.634L128.577 530.377L137.951 513.824Z",
    fill: "#C92828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.728 531.4C124.617 535.33 129.331 534.334 128.55 530.377C127.661 526.474 122.947 527.47 123.728 531.4Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.967 532.207C124.887 532.207 124.806 532.154 124.779 532.073C123.89 529.57 125.237 528.547 126.88 529.22C127.123 529.3 126.961 529.677 126.745 529.597C125.291 529.031 124.429 529.866 125.156 531.965C125.21 532.073 125.102 532.207 124.967 532.207Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 531.938C126.476 531.884 126.26 530.458 124.752 530.296C124.644 530.296 124.563 530.188 124.563 530.081C124.563 529.973 124.671 529.892 124.779 529.892C126.26 530 127.419 531.884 126.826 531.938Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.883 533.203C125.883 533.768 126.772 533.768 126.772 533.203C126.772 532.638 125.883 532.638 125.883 533.203Z",
    fill: "#F4D4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.33 513.528C237.33 513.528 235.821 507.31 241.209 504.914L244.873 507.31L237.33 513.528Z",
    fill: "#163260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.217 518.803C254.867 522.356 253.924 526.393 251.284 528.896C251.176 529.004 251.068 529.085 250.961 529.193C247.055 532.18 241.37 532.18 237.141 529.139C233.774 526.366 232.508 522.437 234.016 519.261C234.986 517.376 236.926 515.654 237.33 513.554C239.835 500.742 256.591 505.049 255.217 518.803Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.667 517.457C241.317 516.865 242.233 516.327 242.583 516.919C242.933 517.511 242.017 518.05 241.667 517.457Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.141 516.973C236.791 516.381 237.707 515.842 238.057 516.434C238.434 517.027 237.491 517.592 237.141 516.973Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.217 518.803C254.867 522.356 253.924 526.394 251.284 528.897C251.176 529.004 251.069 529.085 250.961 529.193C254.328 523.917 253.709 522.706 252.846 518.696C249.048 515.358 249.614 511.401 245.788 510.998C241.936 510.594 238.73 509.76 238.73 509.76C244.011 501.012 256.456 507.66 255.217 518.803Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.677 521.495C237.815 521.387 236.737 520.849 237.761 520.041C238.731 519.422 239.35 517.296 239.35 517.296C240.32 516.569 239.081 519.718 237.976 520.391C237.222 520.93 238.892 521.279 239.566 521.01C240.455 521.253 239.054 521.656 238.677 521.495Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.348 514.066C256.214 503.784 249.883 503.434 249.883 503.434C245.222 495.682 232.804 497.997 236.979 506.637C239.296 511.913 247.162 507.122 250.799 513.958C252.253 516.704 253.169 518.399 256.025 520.041C255.998 520.014 256.725 516.892 256.348 514.066Z",
    fill: "#163260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.561 520.418C257.022 524.456 251.931 523.702 252.577 519.691C253.143 515.681 258.207 516.408 257.561 520.418Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.321 521.333C256.213 521.333 256.106 521.198 256.133 521.091C256.429 519.88 256.348 519.072 255.944 518.722C255.136 518.13 254.382 519.045 254.085 518.641C253.977 518.211 255.324 517.834 256.186 518.399C256.671 518.668 257.102 520.445 256.321 521.333Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.515 524.402C237.787 524.402 237.168 523.971 237.841 523.863C237.922 523.89 239.835 524.59 242.098 522.921C242.178 522.867 242.313 522.867 242.367 522.975C241.613 524.402 239.107 524.455 238.515 524.402Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.172 516.327C244.118 516.327 244.037 516.3 244.01 516.246C243.068 514.954 241.478 514.873 241.478 514.873C241.37 514.873 241.29 514.766 241.29 514.658C241.29 514.55 241.397 514.47 241.505 514.47C241.586 514.47 243.283 514.55 244.361 516.004C244.414 516.085 244.414 516.219 244.307 516.273C244.253 516.327 244.226 516.327 244.172 516.327Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.249 515.035C237.195 515.035 237.114 515.008 237.087 514.954C237.033 514.874 237.06 514.739 237.141 514.685C237.195 514.658 238.299 513.958 239.566 514.308C239.673 514.335 239.727 514.443 239.7 514.551C239.673 514.658 239.565 514.712 239.458 514.685C238.353 514.389 237.357 515.008 237.357 515.008C237.33 515.008 237.303 515.035 237.249 515.035Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.22 521.091C254.193 521.091 254.166 521.091 254.166 521.091C254.059 521.064 254.005 520.956 254.032 520.849C254.059 520.768 254.571 519.18 256.429 519.045C256.537 519.045 256.645 519.126 256.645 519.234C256.645 519.342 256.564 519.449 256.456 519.449C254.867 519.584 254.409 520.983 254.409 520.983C254.382 521.037 254.301 521.091 254.22 521.091Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.632 526.959C136.605 526.959 136.551 526.959 136.524 526.932C136.443 526.878 136.416 526.77 136.47 526.69C136.524 526.609 137.601 524.994 139.541 524.913C139.649 524.913 139.73 524.994 139.73 525.075C139.73 525.182 139.649 525.263 139.568 525.263C137.79 525.344 136.793 526.851 136.793 526.878C136.739 526.932 136.685 526.959 136.632 526.959Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.474 524.967C143.447 524.967 143.42 524.967 143.393 524.94C142.235 524.321 141.023 524.94 140.996 524.94C140.915 524.994 140.807 524.94 140.753 524.859C140.699 524.779 140.753 524.671 140.834 524.617C140.888 524.59 142.208 523.89 143.555 524.617C143.636 524.671 143.663 524.779 143.636 524.859C143.609 524.94 143.555 524.967 143.474 524.967Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.484 535.006C140.053 535.006 139.595 534.791 139.272 534.36C138.787 533.714 138.814 532.853 139.38 532.422C139.918 532.019 140.78 532.207 141.265 532.853C141.75 533.499 141.723 534.36 141.158 534.791C140.969 534.926 140.727 535.006 140.484 535.006ZM140.053 532.611C139.891 532.611 139.73 532.665 139.622 532.745C139.245 533.015 139.245 533.634 139.595 534.118C139.945 534.603 140.538 534.737 140.915 534.468C141.292 534.199 141.292 533.58 140.942 533.095C140.7 532.772 140.376 532.611 140.053 532.611Z",
    fill: "#C16256"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_241_232257)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_241_232257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2257 31.0051L65.2232 31.0052C64.1346 31.0528 63.0348 31.1646 61.9439 31.3081L61.8788 30.8131L61.9439 31.3081C57.5793 31.8821 53.2905 33.0999 49.3816 35.1035C44.4774 37.6174 39.9197 41.786 38.9955 47.2974C38.8631 48.0868 38.8355 48.8988 38.8713 49.7158C38.9152 50.7183 39.0972 51.7301 39.4084 52.6848C39.8554 54.0562 40.5211 55.3341 41.3558 56.523L41.3558 56.523C42.4582 58.0934 43.8814 59.4916 45.4278 60.6515C48.8756 63.2373 52.8989 64.9673 57.0919 66.0156C62.4958 67.3666 68.1481 67.6411 73.6736 66.9537C76.1659 66.6435 78.6347 66.0925 81.028 65.3277L81.028 65.3276C82.5009 64.8572 83.9634 64.3208 85.327 63.6391C87.8034 62.4007 90.218 60.9891 92.1456 59.0624C93.4893 57.7192 94.6732 56.2824 95.5092 54.6147C96.0815 53.4728 96.4865 52.2718 96.7043 51.017L97.197 51.1026L96.7043 51.017C97.5005 46.4322 95.2135 41.8634 91.742 38.8184L91.742 38.8184C90.703 37.9067 89.6256 37.0658 88.4678 36.3327L88.7353 35.9103L88.4678 36.3327C85.4431 34.417 82.05 33.0906 78.5635 32.219C76.8465 31.7897 75.1004 31.4494 73.3512 31.262C71.8253 31.0985 70.3154 30.9871 68.7874 30.9496C68.3976 30.9401 68.0064 30.9362 67.614 30.9362C67.5173 30.9362 67.4406 30.9337 67.3747 30.9316C67.2623 30.9279 67.1814 30.9253 67.0863 30.9378L65.2257 31.0051ZM65.2257 31.0051L66.3537 30.9501C66.3541 30.95 66.3545 30.95 66.3549 30.95M65.2257 31.0051L66.3549 30.95M66.3549 30.95C66.4267 30.9469 66.497 30.9489 66.5869 30.9515C66.6113 30.9522 66.6371 30.9529 66.6648 30.9536C66.7836 30.9565 66.9319 30.9581 67.0862 30.9378L66.3549 30.95Z",
    stroke: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0845 33.2947C69.0783 33.3009 69.0928 33.3 69.0935 33.2993C69.0997 33.2931 69.0852 33.294 69.0845 33.2947Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1534 33.2947C69.1472 33.3009 69.1617 33.3 69.1624 33.2993C69.1686 33.2931 69.1541 33.294 69.1534 33.2947Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8917 33.3085C68.8855 33.3147 68.9 33.3138 68.9006 33.3131C68.9068 33.3069 68.8924 33.3078 68.8917 33.3085Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9238 33.3039V33.3177H68.9652C68.948 33.3083 68.9438 33.3073 68.9238 33.3039Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4412 33.359C67.9866 33.5032 67.5471 33.6073 67.1179 33.8266C66.8299 33.9737 66.5686 34.2113 66.2767 34.3379C66.2481 34.4295 66.0883 34.5047 66.0178 34.5706C65.8036 34.7706 65.5967 34.9818 65.4145 35.2122C64.9549 35.7941 64.5866 36.5093 64.4127 37.2326C63.9503 39.1548 64.4084 41.0172 64.9804 42.8581C65.2641 43.7711 65.5422 44.6862 65.8179 45.6016C65.9418 46.0132 66.0978 46.4235 66.194 46.8424C65.9696 46.8957 65.7468 47.0175 65.546 47.1277C64.686 47.6 63.9348 48.495 64.2304 49.5309C64.2771 49.6941 64.3476 49.8561 64.4389 49.9996C64.9669 50.8306 65.9441 51.2925 66.8833 51.4803C67.1356 51.5308 67.3974 51.5851 67.6554 51.5851C67.7057 51.9258 67.8632 52.2751 67.9625 52.6053C68.1968 53.3829 68.4343 54.1598 68.6752 54.9353C69.0739 56.2185 69.4783 57.5029 69.8416 58.7956C69.9645 59.2331 70.0493 59.6867 70.1877 60.1191C70.4165 60.8348 70.5585 61.7857 70.2313 62.4904C70.1185 62.7332 69.9317 63.0503 69.6682 63.1522C69.6562 63.2449 69.3908 63.3237 69.3098 63.3547C68.9796 63.4817 68.5774 63.5592 68.2344 63.429C68.1589 63.4005 68.0505 63.4116 68 63.3452C67.7777 63.3356 67.5118 63.1325 67.3343 63.0117C66.8545 62.6853 66.4378 62.2833 65.9458 61.9729C65.7537 61.8516 65.4659 61.6836 65.2289 61.7046C65.1879 61.6579 65.0943 61.6768 65.0359 61.677C64.8317 61.6774 64.6302 61.7552 64.4711 61.8824C64.0277 62.2371 63.9045 62.8977 64.0712 63.4141C64.2964 64.1121 64.9607 64.4971 65.6011 64.7471C65.7655 64.8113 65.9412 64.8647 66.1112 64.9102C66.1859 64.93 66.27 64.9214 66.3318 64.972C66.49 64.9634 66.6477 65.0131 66.8046 65.025C67.1551 65.0517 67.5294 65.046 67.876 64.9815C68.257 64.9107 68.6708 64.7951 69.0166 64.6167C69.2407 64.5011 69.4633 64.3523 69.6958 64.2551L69.682 64.2276C69.8719 64.1671 70.0391 63.9859 70.1921 63.8636C70.2475 63.8193 70.3303 63.7757 70.3438 63.7037C70.5265 63.6258 70.6306 63.4081 70.785 63.2901C70.8048 63.1787 70.9768 63.031 71.0452 62.9375C71.2289 62.686 71.3947 62.4118 71.5308 62.132C71.9465 61.2772 72.155 60.2387 72.1152 59.286C72.0334 57.3231 71.3494 55.46 70.7708 53.598L70.3021 52.0676C70.224 51.8164 70.0815 51.5165 70.0681 51.2542C70.3221 51.2104 70.5964 51.036 70.8125 50.9016C71.659 50.3746 72.3472 49.3849 71.8836 48.3728C71.4924 47.5183 70.6083 47.0067 69.7372 46.7518C69.4799 46.6767 69.2171 46.6169 68.9513 46.5805C68.8655 46.5688 68.6794 46.5815 68.6163 46.5176C68.5791 46.4795 68.5718 46.4089 68.556 46.3599L68.4312 45.9601L68.008 44.5676C67.6922 43.489 67.3545 42.415 67.0208 41.3415C66.8547 40.8069 66.6727 40.2718 66.54 39.7285C66.2805 38.6648 65.796 37.5629 65.9281 36.4472C65.9844 35.9717 66.2253 35.3384 66.7179 35.1513L66.7041 35.1237C66.8692 35.0724 67.0203 34.9738 67.1866 34.9217C67.4923 34.8258 67.8072 34.8456 68.1131 34.9195C68.2416 34.9507 68.4302 34.9828 68.5239 35.0823C68.7078 35.0902 68.9343 35.2843 69.0794 35.3888C69.459 35.6622 69.809 35.9732 70.1883 36.2479C70.3469 36.363 70.5964 36.5525 70.7987 36.5575C70.8551 36.6399 70.9864 36.6084 71.0607 36.6678C71.2849 36.6533 71.4712 36.6702 71.6811 36.5689C71.8793 36.4731 72.0032 36.3019 72.1097 36.1187C72.5743 35.32 72.1847 34.4776 71.4822 33.9761C70.9466 33.5938 70.1671 33.3616 69.5149 33.3214C69.256 33.3054 69.0023 33.3078 68.7445 33.3338C68.6616 33.342 68.5139 33.3988 68.4412 33.359Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1582 33.3039V33.3177H69.1996C69.1823 33.3083 69.1782 33.3073 69.1582 33.3039Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2227 33.3085C69.2165 33.3147 69.231 33.3138 69.2317 33.3131C69.2379 33.3069 69.2234 33.3078 69.2227 33.3085Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2544 33.3039V33.3177H69.2958C69.2785 33.3083 69.2744 33.3073 69.2544 33.3039Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3189 33.3085C69.3127 33.3147 69.3272 33.3138 69.3279 33.3131C69.3341 33.3069 69.3196 33.3078 69.3189 33.3085Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3468 33.3085C69.3406 33.3147 69.355 33.3138 69.3557 33.3131C69.3619 33.3069 69.3474 33.3078 69.3468 33.3085Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4571 33.3085C69.4509 33.3147 69.4654 33.3138 69.4661 33.3131C69.4723 33.3069 69.4578 33.3078 69.4571 33.3085Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.795 33.3222C68.7888 33.3284 68.8033 33.3276 68.804 33.3269C68.8102 33.3207 68.7957 33.3215 68.795 33.3222Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.567 33.3222C69.5608 33.3284 69.5752 33.3276 69.5759 33.3269C69.5821 33.3207 69.5677 33.3215 69.567 33.3222Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6573 33.336C68.6511 33.3422 68.6656 33.3414 68.6663 33.3407C68.6725 33.3345 68.658 33.3353 68.6573 33.336Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6085 33.336C69.6023 33.3422 69.6167 33.3414 69.6174 33.3407C69.6236 33.3345 69.6092 33.3353 69.6085 33.336Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.65 33.336C69.6438 33.3422 69.6583 33.3414 69.6589 33.3407C69.6651 33.3345 69.6507 33.3353 69.65 33.336Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4366 33.3498C68.4304 33.356 68.4449 33.3552 68.4456 33.3545C68.4518 33.3483 68.4373 33.3491 68.4366 33.3498Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7188 33.3498C69.7126 33.356 69.7271 33.3552 69.7278 33.3545C69.734 33.3483 69.7195 33.3491 69.7188 33.3498Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8887 33.359V33.3728H69.9301C69.9128 33.3634 69.9087 33.3625 69.8887 33.359Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3262 33.3774C68.32 33.3836 68.3345 33.3827 68.3352 33.382C68.3414 33.3758 68.3269 33.3767 68.3262 33.3774Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2852 33.3912C68.279 33.3974 68.2935 33.3965 68.2942 33.3958C68.3004 33.3896 68.2859 33.3905 68.2852 33.3912Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9717 33.3866V33.4004H70.0268C70.006 33.391 69.9949 33.3889 69.9717 33.3866Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0772 33.4049C70.071 33.4112 70.0855 33.4103 70.0862 33.4096C70.0924 33.4034 70.0779 33.4043 70.0772 33.4049Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1367 33.4142V33.428H70.1781C70.1608 33.4186 70.1567 33.4176 70.1367 33.4142Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1967 33.4234C70.196 33.4241 70.1953 33.4387 70.2016 33.4325C70.2022 33.4318 70.2029 33.4172 70.1967 33.4234Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2291 33.4325C70.2229 33.4387 70.2374 33.4379 70.238 33.4372C70.2442 33.431 70.2298 33.4318 70.2291 33.4325Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0367 33.4601C68.0305 33.4663 68.045 33.4654 68.0457 33.4648C68.0519 33.4585 68.0374 33.4594 68.0367 33.4601Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2471 33.4555V33.4693H70.2884C70.2712 33.4599 70.2671 33.459 70.2471 33.4555Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3164 33.4693V33.4831H70.3578C70.3405 33.4737 70.3364 33.4727 70.3164 33.4693Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8666 33.5061C67.866 33.5068 67.8653 33.5214 67.8715 33.5152C67.8722 33.5145 67.8729 33.4999 67.8666 33.5061Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.399 33.4969V33.5107H70.4403C70.4231 33.5013 70.4189 33.5003 70.399 33.4969Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4814 33.5107V33.5245H70.5228C70.5056 33.5151 70.5014 33.5141 70.4814 33.5107Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7793 33.552C67.801 33.5427 67.8038 33.541 67.8207 33.5245C67.7989 33.5339 67.7962 33.5355 67.7793 33.552Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5186 33.529C70.5124 33.5352 70.5269 33.5344 70.5276 33.5337C70.5338 33.5275 70.5193 33.5283 70.5186 33.529Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.546 33.5428C70.5398 33.549 70.5542 33.5482 70.5549 33.5475C70.5611 33.5413 70.5467 33.5421 70.546 33.5428Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5645 33.5383V33.5521H70.6058C70.5886 33.5427 70.5844 33.5417 70.5645 33.5383Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6012 33.5566C70.5949 33.5628 70.6094 33.5619 70.6101 33.5612C70.6163 33.555 70.6018 33.5559 70.6012 33.5566Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7158 33.5934V33.6072H70.7572C70.7399 33.5977 70.7358 33.5968 70.7158 33.5934Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7667 33.6255C70.7605 33.6317 70.775 33.6309 70.7756 33.6302C70.7818 33.624 70.7674 33.6248 70.7667 33.6255Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7895 33.6302C70.7888 33.6309 70.7881 33.6455 70.7943 33.6393C70.795 33.6386 70.7957 33.624 70.7895 33.6302Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.822 33.6393C70.8158 33.6455 70.8303 33.6447 70.831 33.644C70.8372 33.6378 70.8227 33.6386 70.822 33.6393Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8398 33.6486V33.6623H70.8812C70.864 33.653 70.8598 33.652 70.8398 33.6486Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8857 33.6578C70.885 33.6585 70.8843 33.6731 70.8905 33.6669C70.8912 33.6662 70.8919 33.6516 70.8857 33.6578Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4072 33.6624V33.7037H67.421C67.4176 33.6837 67.4165 33.6796 67.4072 33.6624Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4303 33.6669C67.424 33.6731 67.4385 33.6722 67.4392 33.6715C67.4454 33.6653 67.4309 33.6662 67.4303 33.6669Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.955 33.6854C70.9543 33.6861 70.9536 33.7007 70.9599 33.6945C70.9605 33.6938 70.9612 33.6792 70.955 33.6854Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0375 33.7267C71.0369 33.7274 71.0362 33.742 71.0424 33.7358C71.0431 33.7351 71.0437 33.7205 71.0375 33.7267Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1157 33.7589C71.1233 33.7815 71.1207 33.7788 71.1433 33.7864V33.7589H71.1157Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2769 33.8461C71.2707 33.8523 71.2852 33.8515 71.2859 33.8508C71.2921 33.8446 71.2776 33.8454 71.2769 33.8461Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3321 33.8737C71.3259 33.8799 71.3404 33.8791 71.3411 33.8784C71.3473 33.8722 71.3328 33.873 71.3321 33.8737Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9565 33.906C66.9558 33.9066 66.9551 33.9213 66.9613 33.9151C66.962 33.9144 66.9627 33.8998 66.9565 33.906Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3873 33.915C71.3811 33.9212 71.3956 33.9204 71.3962 33.9197C71.4024 33.9135 71.388 33.9143 71.3873 33.915Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4511 33.9473C71.4504 33.948 71.4497 33.9626 71.4559 33.9564C71.4566 33.9557 71.4573 33.9411 71.4511 33.9473Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8188 33.9749C66.8181 33.9755 66.8174 33.9902 66.8236 33.984C66.8243 33.9833 66.825 33.9687 66.8188 33.9749Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5063 33.9887C71.5056 33.9893 71.5049 34.004 71.5111 33.9978C71.5118 33.9971 71.5125 33.9824 71.5063 33.9887Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7271 34.0253C66.7209 34.0315 66.7354 34.0307 66.7361 34.03C66.7423 34.0238 66.7278 34.0246 66.7271 34.0253Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5615 34.03C71.5608 34.0307 71.5601 34.0453 71.5663 34.0391C71.567 34.0384 71.5677 34.0238 71.5615 34.03Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5801 34.1173V34.1311H66.6214C66.6042 34.1216 66.6001 34.1207 66.5801 34.1173Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7042 34.1494C71.698 34.1556 71.7125 34.1548 71.7131 34.1541C71.7193 34.1479 71.7049 34.1487 71.7042 34.1494Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7594 34.1908C71.7532 34.197 71.7676 34.1962 71.7683 34.1955C71.7745 34.1893 71.76 34.1901 71.7594 34.1908Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8009 34.2322C71.7947 34.2384 71.8091 34.2375 71.8098 34.2368C71.816 34.2306 71.8015 34.2315 71.8009 34.2322Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3824 34.2597C66.3762 34.2659 66.3907 34.2651 66.3914 34.2644C66.3976 34.2582 66.3831 34.259 66.3824 34.2597Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8373 34.2644C71.8367 34.2651 71.836 34.2797 71.8422 34.2735C71.8429 34.2728 71.8436 34.2582 71.8373 34.2644Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8784 34.3057C71.8777 34.3064 71.877 34.321 71.8832 34.3148C71.8839 34.3141 71.8846 34.2995 71.8784 34.3057Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9477 34.3885C71.947 34.3892 71.9463 34.4038 71.9525 34.3976C71.9532 34.3969 71.9539 34.3823 71.9477 34.3885Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2124 34.4023C66.2117 34.403 66.211 34.4176 66.2172 34.4114C66.2179 34.4107 66.2186 34.3961 66.2124 34.4023Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9801 34.4389C71.9739 34.4452 71.9883 34.4443 71.989 34.4436C71.9952 34.4374 71.9807 34.4383 71.9801 34.4389Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1435 34.4574C66.1428 34.4581 66.1421 34.4727 66.1483 34.4665C66.149 34.4658 66.1497 34.4512 66.1435 34.4574Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1293 34.4712C66.1287 34.4719 66.128 34.4865 66.1342 34.4803C66.1349 34.4796 66.1355 34.465 66.1293 34.4712Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0929 34.4941C66.0866 34.5003 66.1011 34.4995 66.1018 34.4988C66.108 34.4926 66.0935 34.4934 66.0929 34.4941Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0283 34.5309V34.5447H66.0697C66.0524 34.5353 66.0483 34.5343 66.0283 34.5309Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0672 34.5447V34.586H72.081C72.0775 34.566 72.0765 34.5619 72.0672 34.5447ZM66.0103 34.563C66.0041 34.5692 66.0186 34.5684 66.0193 34.5677C66.0255 34.5615 66.011 34.5623 66.0103 34.563Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1269 34.6505C72.1262 34.6511 72.1255 34.6658 72.1317 34.6596C72.1324 34.6589 72.1331 34.6443 72.1269 34.6505Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8907 34.6688L65.877 34.6963H65.9045C65.9045 34.6708 65.9087 34.6777 65.8907 34.6688Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8448 34.7284C65.8386 34.7346 65.8531 34.7338 65.8538 34.7331C65.86 34.7269 65.8455 34.7277 65.8448 34.7284Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7388 34.8066V34.848H65.7526C65.7491 34.828 65.7481 34.8239 65.7388 34.8066Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2094 34.8297C72.2087 34.8303 72.208 34.845 72.2142 34.8388C72.2149 34.8381 72.2156 34.8235 72.2094 34.8297Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5728 34.848V34.8755C67.5953 34.8681 67.5929 34.8704 67.6003 34.848H67.5728Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6279 34.848C67.6355 34.8706 67.6329 34.868 67.6555 34.8755C67.6479 34.8529 67.6505 34.8555 67.6279 34.848Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4303 34.8663C67.424 34.8725 67.4385 34.8717 67.4392 34.871C67.4454 34.8648 67.4309 34.8656 67.4303 34.8663Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6783 34.8663C67.6721 34.8725 67.6866 34.8717 67.6873 34.871C67.6935 34.8648 67.679 34.8656 67.6783 34.8663Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7335 34.8663C67.7273 34.8725 67.7417 34.8717 67.7424 34.871C67.7486 34.8648 67.7342 34.8656 67.7335 34.8663Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7613 34.8663C67.7551 34.8725 67.7696 34.8717 67.7703 34.871C67.7765 34.8648 67.762 34.8656 67.7613 34.8663Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7887 34.8663C67.7824 34.8725 67.7969 34.8717 67.7976 34.871C67.8038 34.8648 67.7893 34.8656 67.7887 34.8663Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8208 34.8618V34.8755H67.8622C67.8449 34.8662 67.8408 34.8652 67.8208 34.8618Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3614 34.8801C67.3552 34.8863 67.3697 34.8855 67.3704 34.8848C67.3766 34.8786 67.3621 34.8794 67.3614 34.8801Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8575 34.8801C67.8513 34.8863 67.8658 34.8855 67.8665 34.8848C67.8727 34.8786 67.8582 34.8794 67.8575 34.8801Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8896 34.8755V34.8893H67.9862C67.9541 34.8758 67.9246 34.8758 67.8896 34.8755Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0043 34.8848C68.0037 34.8855 68.003 34.9001 68.0092 34.8939C68.0099 34.8932 68.0105 34.8786 68.0043 34.8848Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6793 34.8939C65.6731 34.9001 65.6875 34.8993 65.6882 34.8986C65.6944 34.8924 65.68 34.8932 65.6793 34.8939Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2232 34.9077C67.217 34.9139 67.2315 34.9131 67.2322 34.9124C67.2384 34.9062 67.2239 34.907 67.2232 34.9077Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2647 34.9077C67.2585 34.9139 67.273 34.9131 67.2737 34.9124C67.2799 34.9062 67.2654 34.907 67.2647 34.9077Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0509 34.9077C68.0447 34.9139 68.0591 34.9131 68.0598 34.9124C68.066 34.9062 68.0515 34.907 68.0509 34.9077Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.106 34.9215C68.0998 34.9277 68.1143 34.9269 68.115 34.9262C68.1212 34.92 68.1067 34.9208 68.106 34.9215Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6378 34.9353C65.6316 34.9415 65.646 34.9406 65.6467 34.94C65.6529 34.9338 65.6385 34.9346 65.6378 34.9353Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1377 34.9307V34.9445H68.1791C68.1618 34.9351 68.1577 34.9342 68.1377 34.9307Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0947 34.9537C67.094 34.9544 67.0933 34.969 67.0995 34.9628C67.1002 34.9622 67.1009 34.9475 67.0947 34.9537Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2159 34.9491C68.2097 34.9553 68.2242 34.9545 68.2249 34.9538C68.2311 34.9476 68.2166 34.9484 68.2159 34.9491Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2529 34.9537C68.2522 34.9544 68.2515 34.969 68.2577 34.9628C68.2584 34.9622 68.2591 34.9475 68.2529 34.9537Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6012 34.972L65.5874 34.9996C65.6048 34.9862 65.6065 34.9901 65.6012 34.972Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3076 34.9813C68.3069 34.982 68.3062 34.9966 68.3124 34.9904C68.3131 34.9897 68.3138 34.9751 68.3076 34.9813Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5009 35.0502C68.5002 35.0509 68.4995 35.0655 68.5058 35.0593C68.5064 35.0586 68.5071 35.044 68.5009 35.0502Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8188 35.0778C66.8181 35.0785 66.8174 35.0931 66.8236 35.0869C66.8243 35.0862 66.825 35.0716 66.8188 35.0778Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5606 35.0869C68.5544 35.0931 68.5689 35.0923 68.5696 35.0916C68.5758 35.0854 68.5613 35.0862 68.5606 35.0869Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5791 35.0961V35.1099H68.6205C68.6032 35.1005 68.5991 35.0996 68.5791 35.0961Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6523 35.1192C68.6516 35.1199 68.6509 35.1345 68.6571 35.1283C68.6578 35.1276 68.6585 35.113 68.6523 35.1192Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7127 35.1559C68.7065 35.1621 68.7209 35.1612 68.7216 35.1606C68.7278 35.1543 68.7134 35.1552 68.7127 35.1559ZM65.4404 35.1743C65.4397 35.175 65.439 35.1896 65.4452 35.1834C65.4459 35.1827 65.4466 35.1681 65.4404 35.1743Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6123 35.2019C66.6116 35.2026 66.6109 35.2172 66.6171 35.211C66.6178 35.2103 66.6185 35.1957 66.6123 35.2019Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7677 35.1972C68.7615 35.2034 68.7759 35.2026 68.7766 35.2019C68.7828 35.1957 68.7684 35.1965 68.7677 35.1972ZM65.3989 35.2157C65.3982 35.2163 65.3975 35.231 65.4037 35.2248C65.4044 35.2241 65.4051 35.2095 65.3989 35.2157Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8228 35.2248C68.8166 35.231 68.8311 35.2302 68.8318 35.2295C68.838 35.2233 68.8235 35.2241 68.8228 35.2248Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.371 35.257C65.3704 35.2577 65.3697 35.2723 65.3759 35.2661C65.3766 35.2654 65.3772 35.2508 65.371 35.257Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3153 35.2616V35.303H72.3291C72.3257 35.283 72.3246 35.2788 72.3153 35.2616Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9697 35.3122C68.969 35.3129 68.9683 35.3275 68.9745 35.3213C68.9752 35.3206 68.9759 35.306 68.9697 35.3122Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.33 35.326C65.3293 35.3267 65.3286 35.3413 65.3349 35.3351C65.3355 35.3344 65.3362 35.3198 65.33 35.326Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3159 35.3398C65.3152 35.3405 65.3145 35.3551 65.3207 35.3489C65.3214 35.3482 65.3221 35.3336 65.3159 35.3398Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2794 35.3764C65.2732 35.3826 65.2876 35.3818 65.2883 35.3811C65.2945 35.3749 65.2801 35.3757 65.2794 35.3764Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3334 35.3811C72.3328 35.3818 72.3321 35.3964 72.3383 35.3902C72.339 35.3895 72.3396 35.3749 72.3334 35.3811Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2749 35.3949C65.2742 35.3956 65.2735 35.4102 65.2797 35.404C65.2804 35.4033 65.2811 35.3887 65.2749 35.3949Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.373 35.3857V35.427H66.3868C66.3834 35.4071 66.3825 35.4029 66.373 35.3857Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0709 35.3902C69.0647 35.3964 69.0792 35.3956 69.0798 35.3949C69.086 35.3887 69.0716 35.3896 69.0709 35.3902Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.121 35.4225C69.1204 35.4232 69.1197 35.4378 69.1259 35.4316C69.1266 35.4309 69.1272 35.4163 69.121 35.4225Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3334 35.4501C72.3328 35.4508 72.3321 35.4654 72.3383 35.4592C72.339 35.4585 72.3396 35.4439 72.3334 35.4501Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1812 35.4591C69.175 35.4654 69.1895 35.4645 69.1902 35.4638C69.1964 35.4576 69.1819 35.4585 69.1812 35.4591Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2086 35.4729C69.2024 35.4791 69.2169 35.4783 69.2176 35.4776C69.2238 35.4714 69.2093 35.4722 69.2086 35.4729Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.206 35.4914C65.2053 35.4921 65.2046 35.5067 65.2108 35.5005C65.2115 35.4998 65.2122 35.4852 65.206 35.4914Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3334 35.4914C72.3328 35.4921 72.3321 35.5067 72.3383 35.5005C72.339 35.4998 72.3396 35.4852 72.3334 35.4914Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2315 35.5052C69.2308 35.5059 69.2301 35.5205 69.2363 35.5143C69.237 35.5136 69.2377 35.499 69.2315 35.5052Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3198 35.5052C72.3191 35.5059 72.3184 35.5205 72.3246 35.5143C72.3253 35.5136 72.326 35.499 72.3198 35.5052Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2857 35.5143C66.2795 35.5205 66.294 35.5197 66.2947 35.519C66.3009 35.5128 66.2864 35.5136 66.2857 35.5143Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3198 35.5328C72.3191 35.5335 72.3184 35.5481 72.3246 35.5419C72.3253 35.5412 72.326 35.5266 72.3198 35.5328Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2866 35.5466C69.2859 35.5473 69.2852 35.5619 69.2914 35.5557C69.2921 35.555 69.2928 35.5404 69.2866 35.5466Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3013 35.5787V35.62H72.3151C72.3116 35.6 72.3107 35.5959 72.3013 35.5787Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.123 35.6155C65.1223 35.6162 65.1216 35.6308 65.1278 35.6246C65.1285 35.6239 65.1292 35.6093 65.123 35.6155Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3832 35.6293C69.3826 35.63 69.3819 35.6446 69.3881 35.6384C69.3888 35.6377 69.3895 35.6231 69.3832 35.6293Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0957 35.6431C65.095 35.6438 65.0943 35.6584 65.1005 35.6522C65.1012 35.6515 65.1019 35.6369 65.0957 35.6431Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3061 35.6431C72.3054 35.6438 72.3047 35.6584 72.3109 35.6522C72.3116 35.6515 72.3123 35.6369 72.3061 35.6431Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4336 35.6476V35.689H69.4474C69.4439 35.669 69.4431 35.6649 69.4336 35.6476Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2919 35.6707C72.2913 35.6713 72.2906 35.686 72.2968 35.6798C72.2975 35.6791 72.2981 35.6645 72.2919 35.6707Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0865 35.6797C65.0803 35.6859 65.0948 35.6851 65.0955 35.6844C65.1017 35.6782 65.0872 35.679 65.0865 35.6797Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1572 35.6982C66.1565 35.6989 66.1558 35.7136 66.162 35.7073C66.1627 35.7067 66.1634 35.692 66.1572 35.6982Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.045 35.7349C65.0388 35.7411 65.0533 35.7403 65.054 35.7396C65.0602 35.7334 65.0457 35.7342 65.045 35.7349Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5123 35.7349C69.5061 35.7411 69.5206 35.7403 69.5212 35.7396C69.5274 35.7334 69.513 35.7342 69.5123 35.7349Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1293 35.7534C66.1287 35.7541 66.128 35.7687 66.1342 35.7625C66.1349 35.7618 66.1355 35.7472 66.1293 35.7534Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2645 35.7534C72.2638 35.7541 72.2632 35.7687 72.2694 35.7625C72.27 35.7618 72.2707 35.7472 72.2645 35.7534Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5581 35.7717V35.7855H69.5995C69.5822 35.7761 69.5781 35.7752 69.5581 35.7717ZM65.004 35.7901C64.9978 35.7963 65.0123 35.7954 65.0129 35.7948C65.0191 35.7885 65.0047 35.7894 65.004 35.7901Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2554 35.79C72.2492 35.7962 72.2637 35.7954 72.2644 35.7947C72.2706 35.7885 72.2561 35.7893 72.2554 35.79Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6221 35.8176C69.6159 35.8238 69.6304 35.823 69.6311 35.8223C69.6373 35.8161 69.6228 35.8169 69.6221 35.8176Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9805 35.8268V35.8682H64.9943C64.9908 35.8482 64.9898 35.8441 64.9805 35.8268Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6363 35.8314C69.6301 35.8376 69.6446 35.8368 69.6453 35.8361C69.6515 35.8299 69.637 35.8307 69.6363 35.8314Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0883 35.8499C66.0876 35.8506 66.0869 35.8652 66.0932 35.859C66.0938 35.8583 66.0945 35.8437 66.0883 35.8499Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6637 35.859C69.6574 35.8652 69.6719 35.8644 69.6726 35.8637C69.6788 35.8575 69.6643 35.8583 69.6637 35.859Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6819 35.8682C69.6895 35.8908 69.6869 35.8884 69.7094 35.8958C69.702 35.8733 69.7043 35.8757 69.6819 35.8682Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2232 35.8774C72.2225 35.8781 72.2219 35.8927 72.2281 35.8865C72.2287 35.8859 72.2294 35.8712 72.2232 35.8774Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9438 35.905C64.9431 35.9057 64.9424 35.9203 64.9486 35.9141C64.9493 35.9134 64.95 35.8988 64.9438 35.905Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0605 35.905C66.0598 35.9057 66.0591 35.9203 66.0653 35.9141C66.066 35.9134 66.0667 35.8988 66.0605 35.905Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7188 35.9003C69.7126 35.9065 69.7271 35.9057 69.7278 35.905C69.734 35.8988 69.7195 35.8996 69.7188 35.9003Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.769 35.9464C69.7683 35.947 69.7676 35.9617 69.7738 35.9555C69.7745 35.9548 69.7752 35.9402 69.769 35.9464Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1957 35.9464C72.1951 35.947 72.1944 35.9617 72.2006 35.9555C72.2013 35.9548 72.202 35.9402 72.1957 35.9464Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0332 35.9877C66.0325 35.9884 66.0318 36.003 66.038 35.9968C66.0387 35.9961 66.0394 35.9815 66.0332 35.9877Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1821 35.9877C72.1814 35.9884 72.1807 36.003 72.1869 35.9968C72.1876 35.9961 72.1883 35.9815 72.1821 35.9877Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8936 35.9969C64.8874 36.0031 64.9019 36.0022 64.9026 36.0016C64.9088 35.9954 64.8943 35.9962 64.8936 35.9969Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.024 36.0106C66.0178 36.0168 66.0323 36.016 66.033 36.0153C66.0392 36.0091 66.0247 36.0099 66.024 36.0106Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8886 36.0291C64.8879 36.0298 64.8872 36.0444 64.8934 36.0382C64.8941 36.0375 64.8948 36.0229 64.8886 36.0291Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1593 36.0382C72.1531 36.0444 72.1675 36.0436 72.1682 36.0429C72.1744 36.0367 72.1599 36.0375 72.1593 36.0382Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8564 36.0474V36.075C64.8788 36.0676 64.8764 36.07 64.884 36.0474H64.8564Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.976 36.098C69.9753 36.0987 69.9746 36.1133 69.9808 36.1071C69.9815 36.1064 69.9822 36.0918 69.976 36.098Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8334 36.1118C64.8328 36.1125 64.8321 36.1271 64.8383 36.1209C64.839 36.1202 64.8396 36.1056 64.8334 36.1118Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0312 36.1394C70.0305 36.1401 70.0298 36.1547 70.036 36.1485C70.0367 36.1478 70.0374 36.1332 70.0312 36.1394Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0854 36.1532C72.0847 36.1539 72.084 36.1685 72.0902 36.1623C72.0909 36.1616 72.0916 36.147 72.0854 36.1532Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9638 36.2083C65.9631 36.209 65.9624 36.2236 65.9686 36.2174C65.9693 36.2167 65.97 36.2021 65.9638 36.2083Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1415 36.2221C70.1409 36.2228 70.1402 36.2374 70.1464 36.2312C70.1471 36.2305 70.1478 36.2159 70.1415 36.2221Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0439 36.2359C72.0432 36.2366 72.0425 36.2512 72.0487 36.245C72.0494 36.2443 72.0501 36.2297 72.0439 36.2359Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1966 36.2497C70.1959 36.2504 70.1952 36.265 70.2014 36.2588C70.2021 36.2581 70.2028 36.2435 70.1966 36.2497ZM64.7646 36.2635C64.7639 36.2642 64.7632 36.2788 64.7694 36.2726C64.7701 36.2719 64.7708 36.2573 64.7646 36.2635Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9458 36.2542V36.2956H65.9596C65.9561 36.2756 65.9553 36.2714 65.9458 36.2542Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2377 36.2911C70.2371 36.2918 70.2364 36.3064 70.2426 36.3002C70.2433 36.2995 70.2439 36.2849 70.2377 36.2911Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9501 36.3048C65.9495 36.3055 65.9488 36.3201 65.955 36.3139C65.9557 36.3132 65.9563 36.2986 65.9501 36.3048Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9614 36.3324C71.9607 36.3331 71.96 36.3477 71.9662 36.3415C71.9669 36.3408 71.9676 36.3262 71.9614 36.3324Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9365 36.3462C65.9358 36.3469 65.9351 36.3615 65.9413 36.3553C65.942 36.3546 65.9427 36.34 65.9365 36.3462Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3253 36.3415C70.3191 36.3477 70.3335 36.3469 70.3342 36.3462C70.3404 36.34 70.326 36.3408 70.3253 36.3415Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7144 36.3553C64.7082 36.3615 64.7227 36.3606 64.7234 36.36C64.7296 36.3538 64.7151 36.3546 64.7144 36.3553Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9321 36.3783V36.4197H65.9459C65.9425 36.3997 65.9414 36.3955 65.9321 36.3783Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6914 36.3921V36.4335H64.7052C64.7017 36.4135 64.7007 36.4093 64.6914 36.3921Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9249 36.3966C71.9187 36.4029 71.9332 36.402 71.9338 36.4013C71.94 36.3951 71.9256 36.396 71.9249 36.3966Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4448 36.4151C70.4441 36.4158 70.4434 36.4304 70.4496 36.4242C70.4503 36.4235 70.451 36.4089 70.4448 36.4151Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9365 36.4428C65.9358 36.4435 65.9351 36.4579 65.9413 36.4517C65.942 36.451 65.9427 36.4366 65.9365 36.4428Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4999 36.4428C70.4993 36.4435 70.4986 36.4579 70.5048 36.4517C70.5055 36.451 70.5062 36.4366 70.4999 36.4428Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5093 36.4473V36.4611H70.5506C70.5334 36.4516 70.5293 36.4507 70.5093 36.4473Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8419 36.4655C71.8357 36.4717 71.8501 36.471 71.8508 36.4703C71.857 36.4641 71.8426 36.4648 71.8419 36.4655Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9228 36.4842C65.9221 36.4848 65.9214 36.4993 65.9276 36.4931C65.9283 36.4924 65.929 36.478 65.9228 36.4842Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9365 36.4979C65.9358 36.4986 65.9351 36.5131 65.9413 36.5069C65.942 36.5062 65.9427 36.4917 65.9365 36.4979Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6451 36.5069C64.6389 36.5131 64.6534 36.5124 64.6541 36.5117C64.6603 36.5055 64.6458 36.5062 64.6451 36.5069Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.918 36.5024V36.5437H65.9318C65.9283 36.5238 65.9273 36.5196 65.918 36.5024Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6148 36.5069C70.6086 36.5131 70.6231 36.5124 70.6238 36.5117C70.63 36.5055 70.6155 36.5062 70.6148 36.5069Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6513 36.5255C70.6506 36.5262 70.6499 36.5406 70.6561 36.5344C70.6568 36.5337 70.6575 36.5193 70.6513 36.5255Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7115 36.5482C70.7053 36.5544 70.7198 36.5537 70.7205 36.5531C70.7267 36.5468 70.7122 36.5475 70.7115 36.5482Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.748 36.5531C70.7473 36.5537 70.7466 36.5682 70.7528 36.562C70.7535 36.5613 70.7542 36.5469 70.748 36.5531Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6763 36.5758C71.6701 36.582 71.6846 36.5813 71.6853 36.5806C71.6915 36.5744 71.677 36.5751 71.6763 36.5758Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8082 36.5896C70.802 36.5958 70.8165 36.5951 70.8171 36.5944C70.8233 36.5882 70.8089 36.5889 70.8082 36.5896ZM71.6216 36.5896C71.6154 36.5958 71.6299 36.5951 71.6306 36.5944C71.6368 36.5882 71.6223 36.5889 71.6216 36.5896Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9091 36.6082C65.9084 36.6089 65.9077 36.6234 65.914 36.6172C65.9146 36.6165 65.9153 36.602 65.9091 36.6082Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8262 36.5989V36.6127H70.8675C70.8503 36.6034 70.8462 36.6024 70.8262 36.5989Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6127 36.622C64.6121 36.6227 64.6114 36.6372 64.6176 36.631C64.6183 36.6303 64.6189 36.6158 64.6127 36.622Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9092 36.6127V36.6265L70.9505 36.6402C70.9371 36.6158 70.938 36.6184 70.9092 36.6127Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9091 36.6358C65.9084 36.6365 65.9077 36.651 65.914 36.6448C65.9146 36.6441 65.9153 36.6296 65.9091 36.6358Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9917 36.6403V36.654H71.0331C71.0158 36.6447 71.0117 36.6437 70.9917 36.6403Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0332 36.6403C71.0408 36.6628 71.0382 36.6602 71.0608 36.6678C71.0534 36.6454 71.0558 36.6478 71.0332 36.6403Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4561 36.6447C71.4499 36.6509 71.4644 36.6502 71.4651 36.6495C71.4713 36.6433 71.4568 36.644 71.4561 36.6447Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5854 36.6633C64.5847 36.664 64.584 36.6785 64.5902 36.6723C64.5909 36.6716 64.5916 36.6571 64.5854 36.6633Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4698 36.6585C71.4636 36.6647 71.4781 36.664 71.4788 36.6633C71.485 36.6571 71.4705 36.6578 71.4698 36.6585Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0884 36.6678V36.6816H71.1297C71.1125 36.6723 71.1084 36.6713 71.0884 36.6678Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1529 36.6723C71.1467 36.6785 71.1612 36.6778 71.1619 36.6771C71.1681 36.6709 71.1536 36.6716 71.1529 36.6723Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1846 36.6678V36.6816H71.2259C71.2087 36.6723 71.2046 36.6713 71.1846 36.6678Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2769 36.6723C71.2707 36.6785 71.2852 36.6778 71.2859 36.6771C71.2921 36.6709 71.2776 36.6716 71.2769 36.6723Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3321 36.6723C71.3259 36.6785 71.3404 36.6778 71.3411 36.6771C71.3473 36.6709 71.3328 36.6716 71.3321 36.6723Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5762 36.6999C64.57 36.7061 64.5845 36.7054 64.5852 36.7047C64.5914 36.6985 64.5769 36.6992 64.5762 36.6999Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9091 36.7185C65.9084 36.7192 65.9077 36.7337 65.914 36.7275C65.9146 36.7268 65.9153 36.7123 65.9091 36.7185Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5489 36.7964C64.5427 36.8026 64.5572 36.8019 64.5579 36.8012C64.5641 36.795 64.5496 36.7957 64.5489 36.7964Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.909 36.8288C65.9083 36.8295 65.9077 36.844 65.9139 36.8378C65.9146 36.8371 65.9152 36.8226 65.909 36.8288Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5118 36.8608L64.498 36.9022C64.5225 36.8888 64.5251 36.8853 64.5118 36.8608Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9043 36.8608V36.9436H65.9181C65.9174 36.9125 65.9164 36.8891 65.9043 36.8608Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9091 36.9805C65.9084 36.9812 65.9077 36.9957 65.914 36.9894C65.9146 36.9888 65.9153 36.9743 65.9091 36.9805Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4477 37.0632C64.447 37.0639 64.4463 37.0784 64.4525 37.0722C64.4532 37.0715 64.4539 37.057 64.4477 37.0632Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9228 37.0632C65.9221 37.0639 65.9214 37.0784 65.9276 37.0721C65.9283 37.0715 65.929 37.057 65.9228 37.0632Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4107 37.1962C64.4045 37.2024 64.419 37.2017 64.4197 37.201C64.4259 37.1948 64.4114 37.1955 64.4107 37.1962Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9365 37.2838C65.9358 37.2845 65.9351 37.2989 65.9413 37.2927C65.942 37.292 65.9427 37.2776 65.9365 37.2838Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3784 37.3389C64.3777 37.3396 64.377 37.3541 64.3832 37.3479C64.3839 37.3472 64.3846 37.3327 64.3784 37.3389Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3647 37.4492C64.364 37.4499 64.3633 37.4643 64.3695 37.4581C64.3702 37.4574 64.3709 37.443 64.3647 37.4492Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3647 37.4768C64.364 37.4775 64.3633 37.4919 64.3695 37.4857C64.3702 37.485 64.3709 37.4706 64.3647 37.4768Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.351 37.4906C64.3503 37.4912 64.3496 37.5057 64.3558 37.4995C64.3565 37.4988 64.3572 37.4844 64.351 37.4906Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9916 37.5319C65.991 37.5326 65.9903 37.5471 65.9965 37.5409C65.9972 37.5402 65.9979 37.5257 65.9916 37.5319Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3373 37.5457C64.3367 37.5464 64.336 37.5609 64.3422 37.5547C64.3429 37.554 64.3436 37.5395 64.3373 37.5457Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.978 37.5457C65.9773 37.5464 65.9766 37.5609 65.9828 37.5547C65.9835 37.554 65.9842 37.5395 65.978 37.5457Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3188 37.6191V37.6605H64.3326C64.3292 37.6405 64.3282 37.6364 64.3188 37.6191Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.019 37.6698C66.0183 37.6705 66.0176 37.685 66.0238 37.6788C66.0245 37.6781 66.0252 37.6636 66.019 37.6698Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3095 37.6973C64.3088 37.698 64.3081 37.7125 64.3143 37.7063C64.315 37.7056 64.3157 37.6911 64.3095 37.6973ZM66.0053 37.6973C66.0046 37.698 66.0039 37.7125 66.0101 37.7063C66.0108 37.7056 66.0115 37.6911 66.0053 37.6973Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2958 37.7663C64.2952 37.767 64.2945 37.7815 64.3007 37.7753C64.3014 37.7746 64.3021 37.7601 64.2958 37.7663Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2958 37.7939C64.2952 37.7946 64.2945 37.8091 64.3007 37.8029C64.3014 37.8022 64.3021 37.7877 64.2958 37.7939Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0468 37.8352C66.0461 37.8359 66.0454 37.8504 66.0516 37.8442C66.0523 37.8435 66.053 37.829 66.0468 37.8352Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2685 37.9179C64.2678 37.9186 64.2671 37.9331 64.2733 37.9269C64.274 37.9262 64.2747 37.9117 64.2685 37.9179Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2637 37.9638V38.0052H64.2775C64.274 37.9852 64.2732 37.981 64.2637 37.9638Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2594 38.0234C64.2532 38.0297 64.2676 38.029 64.2683 38.0283C64.2745 38.0221 64.26 38.0228 64.2594 38.0234Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2543 38.111C64.2537 38.1117 64.253 38.1261 64.2592 38.1199C64.2599 38.1193 64.2605 38.1048 64.2543 38.111Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1157 38.1524C66.115 38.153 66.1143 38.1675 66.1205 38.1613C66.1212 38.1606 66.1219 38.1462 66.1157 38.1524Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2407 38.1799C64.24 38.1806 64.2393 38.1951 64.2455 38.1888C64.2462 38.1882 64.2469 38.1737 64.2407 38.1799Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2407 38.2213C64.24 38.222 64.2393 38.2364 64.2455 38.2302C64.2462 38.2295 64.2469 38.2151 64.2407 38.2213Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2407 38.2489C64.24 38.2495 64.2393 38.264 64.2455 38.2578C64.2462 38.2571 64.2469 38.2427 64.2407 38.2489Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.227 38.2627C64.2263 38.2633 64.2256 38.2778 64.2318 38.2716C64.2325 38.2709 64.2332 38.2564 64.227 38.2627Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2227 38.2947V38.336H64.2364C64.233 38.316 64.232 38.3119 64.2227 38.2947Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2227 38.3499V38.3912H64.2364C64.233 38.3712 64.232 38.3671 64.2227 38.3499Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.227 38.4143C64.2263 38.415 64.2256 38.4294 64.2318 38.4232C64.2325 38.4225 64.2332 38.4081 64.227 38.4143Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1938 38.4601V38.5015H66.2076C66.2042 38.4815 66.2033 38.4774 66.1938 38.4601Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2085 38.4877V38.529H64.2223C64.2188 38.509 64.2178 38.5049 64.2085 38.4877Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2085 38.5428V38.6256H64.2223C64.2216 38.5945 64.2206 38.5711 64.2085 38.5428Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.226 38.6073C66.2253 38.608 66.2246 38.6225 66.2308 38.6163C66.2315 38.6156 66.2322 38.6011 66.226 38.6073Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1948 38.6393C64.2024 38.6619 64.2 38.6595 64.2224 38.6669V38.6393H64.1948Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2133 38.6762C64.2126 38.6769 64.2119 38.6914 64.2182 38.6852C64.2188 38.6845 64.2195 38.67 64.2133 38.6762Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1992 38.69C64.1985 38.6907 64.1978 38.7052 64.204 38.699C64.2047 38.6983 64.2054 38.6838 64.1992 38.69Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1992 38.7314C64.1985 38.7321 64.1978 38.7466 64.204 38.7404C64.2047 38.7397 64.2054 38.7252 64.1992 38.7314Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2133 38.7727C64.2126 38.7734 64.2119 38.7879 64.2182 38.7817C64.2188 38.781 64.2195 38.7665 64.2133 38.7727Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3086 38.9244C66.3079 38.9251 66.3072 38.9396 66.3134 38.9334C66.3141 38.9327 66.3148 38.9182 66.3086 38.9244Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1992 38.9658C64.1985 38.9665 64.1978 38.9809 64.204 38.9747C64.2047 38.974 64.2054 38.9596 64.1992 38.9658Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1992 39.0071C64.1985 39.0078 64.1978 39.0223 64.204 39.0161C64.2047 39.0154 64.2054 39.0009 64.1992 39.0071Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3915 39.2002C66.3909 39.2008 66.3902 39.2153 66.3964 39.2091C66.3971 39.2084 66.3978 39.1939 66.3915 39.2002Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1948 39.2046C64.2024 39.2272 64.2 39.2248 64.2224 39.2322V39.2046H64.1948Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2133 39.2691C64.2126 39.2697 64.2119 39.2842 64.2182 39.278C64.2188 39.2773 64.2195 39.2629 64.2133 39.2691Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2133 39.3242C64.2126 39.3249 64.2119 39.3394 64.2182 39.3332C64.2188 39.3325 64.2195 39.318 64.2133 39.3242Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2085 39.3839V39.4114C64.2309 39.404 64.2285 39.4064 64.2361 39.3839H64.2085Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2133 39.4345C64.2126 39.4352 64.2119 39.4497 64.2182 39.4435C64.2188 39.4428 64.2195 39.4283 64.2133 39.4345Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.227 39.4759C64.2263 39.4765 64.2256 39.491 64.2318 39.4848C64.2325 39.4841 64.2332 39.4696 64.227 39.4759Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2133 39.4896C64.2126 39.4903 64.2119 39.5048 64.2182 39.4986C64.2188 39.4979 64.2195 39.4834 64.2133 39.4896Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.227 39.531C64.2263 39.5317 64.2256 39.5462 64.2318 39.54C64.2325 39.5393 64.2332 39.5248 64.227 39.531Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.227 39.5999C64.2263 39.6006 64.2256 39.6151 64.2318 39.6089C64.2325 39.6082 64.2332 39.5937 64.227 39.5999Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5429 39.7378C66.5422 39.7385 66.5415 39.753 66.5477 39.7468C66.5484 39.7461 66.5491 39.7316 66.5429 39.7378Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5571 39.7792C66.5564 39.7799 66.5557 39.7944 66.5619 39.7882C66.5626 39.7875 66.5633 39.773 66.5571 39.7792Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2363 39.8112C64.2439 39.8338 64.2413 39.8312 64.2639 39.8388V39.8112H64.2363Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5707 39.8757C66.5701 39.8764 66.5694 39.8909 66.5756 39.8846C66.5763 39.884 66.577 39.8695 66.5707 39.8757Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.25 39.9491C64.2576 39.9717 64.255 39.9691 64.2776 39.9767V39.9491H64.25Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3095 40.2479C64.3088 40.2486 64.3081 40.2631 64.3143 40.2569C64.315 40.2562 64.3157 40.2417 64.3095 40.2479Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3326 40.3765L64.3188 40.4316H64.3326C64.3392 40.4051 64.3406 40.4014 64.3326 40.3765Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3419 40.505C64.3357 40.5112 64.3501 40.5105 64.3508 40.5099C64.357 40.5037 64.3426 40.5043 64.3419 40.505Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7775 40.5512C66.7768 40.5519 66.7761 40.5664 66.7823 40.5602C66.783 40.5595 66.7837 40.545 66.7775 40.5512Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3925 40.7442C64.3918 40.7449 64.3911 40.7594 64.3974 40.7532C64.398 40.7525 64.3987 40.738 64.3925 40.7442Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4062 40.7994C64.4055 40.8001 64.4048 40.8146 64.411 40.8084C64.4117 40.8077 64.4124 40.7932 64.4062 40.7994Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4199 40.8821C64.4192 40.8828 64.4185 40.8973 64.4247 40.8911C64.4254 40.8904 64.4261 40.8759 64.4199 40.8821Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4614 41.0476C64.4607 41.0483 64.46 41.0627 64.4662 41.0565C64.4669 41.0558 64.4676 41.0414 64.4614 41.0476Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9843 41.2268C66.9836 41.2275 66.9829 41.2419 66.9891 41.2357C66.9898 41.235 66.9905 41.2206 66.9843 41.2268Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5117 41.2451V41.2864H64.5255C64.5221 41.2664 64.5212 41.2623 64.5117 41.2451Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6269 41.7093C64.6262 41.71 64.6255 41.7245 64.6317 41.7183C64.6324 41.7176 64.6331 41.7031 64.6269 41.7093Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1357 41.7231C67.135 41.7238 67.1343 41.7383 67.1405 41.7321C67.1412 41.7314 67.1419 41.7169 67.1357 41.7231Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8334 42.3848C64.8328 42.3855 64.8321 42.4 64.8383 42.3938C64.839 42.3931 64.8396 42.3786 64.8334 42.3848Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3427 42.3986C67.342 42.3993 67.3413 42.4138 67.3475 42.4076C67.3482 42.4069 67.3489 42.3924 67.3427 42.3986Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.555 42.6434C75.312 42.6758 75.0235 42.7045 74.8393 42.8869C74.5051 43.2181 74.5119 43.8628 74.5982 44.2919C74.6328 44.4637 74.6988 44.6335 74.8267 44.7583C75.1497 45.0735 75.8606 45.0328 76.2719 44.9775C76.4889 44.9482 76.7326 44.8947 76.8911 44.7326C77.0174 44.6033 77.0809 44.4386 77.1157 44.2643C77.1987 43.8485 77.2134 43.2517 76.9158 42.9134C76.6312 42.5901 75.9483 42.591 75.555 42.6434Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.569 42.6572C75.326 42.6896 75.0375 42.7183 74.8533 42.9007C74.5201 43.2307 74.5281 43.8649 74.6149 44.2919C74.6489 44.4584 74.7171 44.6238 74.8407 44.7445C75.1592 45.0554 75.8526 45.0181 76.2583 44.9637C76.4753 44.9344 76.719 44.881 76.8775 44.7188C77.0038 44.5895 77.0672 44.4248 77.1021 44.2506C77.1841 43.8404 77.1955 43.2607 76.9021 42.9272C76.6221 42.6091 75.9564 42.6056 75.569 42.6572Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9853 42.8812C64.9846 42.8819 64.9839 42.8963 64.9901 42.8901C64.9908 42.8895 64.9915 42.875 64.9853 42.8812Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4946 42.895C67.4939 42.8957 67.4932 42.9101 67.4994 42.9039C67.5001 42.9032 67.5008 42.8888 67.4946 42.895Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1132 50.0686C47.5598 50.0686 48.0688 50.0143 48.4919 50.1851C48.9823 50.3833 49.2872 50.8253 49.5155 51.2818C49.7945 51.8398 50.014 52.4265 50.2455 53.0052L50.7639 54.2873C50.8494 54.4993 50.9002 54.7144 51.1389 54.7945C51.6457 54.9649 52.2817 54.8614 52.8071 54.8526C52.9739 54.8498 53.2848 54.8285 53.3565 54.6458C53.4139 54.4995 53.3507 54.3035 53.3034 54.1633C53.1875 53.82 53.0371 53.4893 52.8937 53.1568L52.2201 51.5851C51.9696 50.998 51.6969 50.3965 51.2453 49.9331C51.0357 49.7181 50.7852 49.5754 50.5323 49.4206C51.1705 49.2047 51.7839 48.8684 52.1939 48.3177C53.0354 47.1873 53.0091 45.2206 51.9523 44.2242C50.6486 42.9951 48.6528 43.2028 47.0029 43.2028H45.8448C45.6252 43.2028 45.3771 43.179 45.1692 43.2622C44.8474 43.3911 44.8036 43.6422 44.7636 43.9473C44.7347 44.1672 44.7556 44.4012 44.7556 44.6228V45.8636V52.0539V53.8186C44.7556 54.0504 44.694 54.3887 44.7883 54.6044C44.8673 54.7854 45.1219 54.8131 45.2933 54.8371C45.7185 54.8964 46.1927 54.8967 46.6169 54.8309C46.7696 54.8073 46.9753 54.7799 47.0722 54.6434C47.1725 54.5022 47.1132 54.1925 47.1132 54.0254V52.4399V50.0686ZM57.1913 45.1329V51.7644V53.7083C57.1913 53.9713 57.1248 54.3421 57.2185 54.5906C57.2909 54.783 57.568 54.8126 57.7428 54.8371C58.1391 54.8922 58.5869 54.8991 58.9836 54.8426C59.1339 54.8212 59.3086 54.8066 59.4385 54.7201C59.6285 54.5937 59.5626 54.293 59.5626 54.0943V52.3572V45.1329H61.7547H62.3338C62.4182 45.1329 62.5207 45.1496 62.5957 45.1033C62.7367 45.0164 62.7677 44.8279 62.7922 44.678C62.8482 44.3323 62.8475 43.9183 62.7775 43.575C62.7374 43.3768 62.6478 43.219 62.4303 43.204C61.7844 43.1595 61.1202 43.2028 60.4726 43.2028H56.5709H54.9165C54.7022 43.2028 54.3849 43.1447 54.1863 43.2355C54.0413 43.3017 54.0012 43.503 53.9779 43.6439C53.9211 43.9872 53.923 44.3908 53.9848 44.7331C54.0093 44.8684 54.051 45.045 54.1858 45.1128C54.2638 45.152 54.3766 45.1329 54.4615 45.1329H55.0544H57.1913Z",
    fill: "#F37E21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1918 43.5567C65.1912 43.5574 65.1905 43.5719 65.1967 43.5657C65.1974 43.565 65.198 43.5505 65.1918 43.5567Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7011 43.5705C67.7004 43.5712 67.6997 43.5857 67.7059 43.5795C67.7066 43.5788 67.7073 43.5643 67.7011 43.5705Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8388 44.0255C67.8381 44.0262 67.8374 44.0406 67.8436 44.0344C67.8443 44.0337 67.845 44.0193 67.8388 44.0255Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3989 44.2323C65.3982 44.233 65.3975 44.2475 65.4037 44.2413C65.4044 44.2406 65.4051 44.2261 65.3989 44.2323ZM67.9036 44.223V44.2644H67.9174C67.9139 44.2444 67.9131 44.2403 67.9036 44.223Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5502 44.7286C65.5496 44.7293 65.5489 44.7438 65.5551 44.7376C65.5558 44.7369 65.5564 44.7224 65.5502 44.7286Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0595 44.7424C68.0588 44.7431 68.0581 44.7576 68.0643 44.7513C68.065 44.7507 68.0657 44.7362 68.0595 44.7424Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1133 45.0089V48.3039C47.932 48.3039 48.9077 48.4492 49.6363 47.9947C50.5017 47.455 50.623 45.8841 49.7052 45.3187C49.2656 45.0478 48.756 45.0347 48.2576 45.0225C47.8767 45.0132 47.4952 45.0089 47.1133 45.0089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7573 45.4042C65.7566 45.4049 65.7559 45.4194 65.7621 45.4132C65.7628 45.4125 65.7635 45.398 65.7573 45.4042Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2665 45.4179C68.2659 45.4186 68.2652 45.4331 68.2714 45.4269C68.2721 45.4262 68.2728 45.4117 68.2665 45.4179Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9091 45.9005C65.9084 45.9012 65.9077 45.9156 65.914 45.9094C65.9146 45.9087 65.9153 45.8943 65.9091 45.9005Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4457 46.0108C68.4451 46.0115 68.4444 46.026 68.4506 46.0198C68.4513 46.0191 68.452 46.0046 68.4457 46.0108ZM81.1527 47.4215V46.6771C81.1527 46.5607 81.1752 46.4299 81.097 46.3336C81.0077 46.2242 80.8573 46.1988 80.7253 46.1773C80.3968 46.124 79.991 46.1178 79.6637 46.1807C79.5169 46.2088 79.3314 46.2383 79.2565 46.3875C79.181 46.5375 79.2225 46.776 79.2225 46.939V48.1936V52.7019V54.0668C79.2225 54.2367 79.1753 54.4947 79.2678 54.6456C79.3637 54.802 79.5967 54.8213 79.7602 54.8447C80.1154 54.8955 80.5064 54.8826 80.8631 54.8538C81.0267 54.8406 81.2171 54.8249 81.3595 54.7358C81.5208 54.635 81.4835 54.4523 81.4835 54.2874V53.1431V50.3857V49.5723C81.4835 49.4663 81.4558 49.3136 81.4937 49.2138C81.5509 49.0636 81.7329 48.9195 81.838 48.8002C82.2704 48.3098 82.8564 47.8293 83.5516 48.0127C84.2955 48.2091 84.4753 49.0901 84.4753 49.7515V53.3223V54.246C84.4753 54.377 84.4499 54.5455 84.5294 54.6591C84.6311 54.8049 84.8525 54.8216 85.013 54.8447C85.2453 54.8778 85.4821 54.8664 85.7161 54.8664C85.9761 54.8664 86.2694 54.8743 86.5157 54.7773C86.7544 54.6832 86.7225 54.4897 86.7225 54.2736V53.0052V50.3995V49.5999C86.7225 49.4865 86.6968 49.3367 86.7296 49.2276C86.7761 49.0725 86.9836 48.9005 87.0946 48.7864C87.4377 48.4342 87.8382 48.0102 88.3631 47.9742C88.4871 47.9658 88.6142 47.9711 88.7354 47.999C89.4475 48.1629 89.636 48.8886 89.7103 49.5171C89.7578 49.9195 89.7142 50.3526 89.7142 50.7579V53.2396V54.0943C89.7142 54.2513 89.6949 54.4228 89.7298 54.5769C89.7768 54.7849 90.0489 54.8176 90.2244 54.8426C90.589 54.8945 90.9885 54.8833 91.3549 54.8538C91.5198 54.8406 91.7276 54.8226 91.8645 54.7197C91.9667 54.6427 91.9615 54.5407 91.9615 54.4252V53.8875V51.4749V49.6964C91.9615 48.9455 91.941 48.1747 91.6263 47.4767C91.0252 46.1432 89.372 45.6693 88.0598 46.2007C87.385 46.4741 86.8702 46.9568 86.3641 47.4629C86.3124 47.2835 86.1859 47.1165 86.0785 46.9666C85.3795 45.9901 83.8731 45.7689 82.8071 46.2007C82.1594 46.463 81.6399 46.9344 81.1527 47.4215Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1387 47.4353V46.6908C81.1387 46.5745 81.1613 46.4437 81.0831 46.3473C80.9938 46.2379 80.8434 46.2126 80.7113 46.191C80.3848 46.1381 79.9888 46.1349 79.6636 46.1972C79.5205 46.2245 79.3427 46.2565 79.2701 46.4013C79.1946 46.5512 79.2362 46.7897 79.2362 46.9528V48.2074V52.6881V54.0529C79.2362 54.2229 79.1889 54.4808 79.2815 54.6318C79.3749 54.7843 79.6 54.806 79.7601 54.8288C80.112 54.8789 80.4956 54.8684 80.8492 54.84C81.0128 54.8267 81.2032 54.811 81.3455 54.7219C81.5068 54.6211 81.4696 54.4385 81.4696 54.2735V53.1154V50.3719V49.5585C81.4696 49.4525 81.4419 49.2998 81.4798 49.2C81.537 49.0497 81.719 48.9057 81.8241 48.7864C82.2658 48.2854 82.8576 47.8122 83.5652 47.9988C84.3025 48.1934 84.4889 49.0661 84.4889 49.7239V53.2947V54.2322C84.4889 54.3631 84.4636 54.5317 84.543 54.6453C84.6423 54.7874 84.856 54.8064 85.0128 54.8288C85.2456 54.8619 85.4812 54.8526 85.7159 54.8526C85.9713 54.8526 86.2598 54.8589 86.5018 54.7635C86.7358 54.6711 86.7086 54.4864 86.7086 54.2735V53.0189V50.3857V49.586C86.7086 49.4726 86.6829 49.3229 86.7157 49.2138C86.7622 49.0587 86.9697 48.8867 87.0807 48.7726C87.4233 48.4207 87.8343 47.983 88.363 47.9597C88.5367 47.9521 88.7073 47.9635 88.8731 48.0193C89.493 48.2279 89.6869 48.9508 89.7267 49.5309C89.7534 49.9223 89.7279 50.3241 89.7279 50.7165V53.1017V54.0529C89.7279 54.2186 89.7067 54.4007 89.7434 54.5631C89.7892 54.7659 90.0517 54.8028 90.2242 54.8267C90.5861 54.8772 90.9773 54.8693 91.3409 54.84C91.5036 54.8269 91.6977 54.8083 91.8371 54.7151C92.0025 54.6046 91.9476 54.3494 91.9476 54.177V52.7018V50.2616C91.9476 49.6953 91.9701 49.1278 91.8962 48.5658C91.8006 47.8382 91.5412 47.0815 90.9549 46.6007C89.9538 45.7798 88.4826 45.8693 87.4393 46.5488C87.1746 46.7211 86.9233 46.929 86.695 47.147C86.5843 47.2528 86.4918 47.4106 86.3501 47.4767C86.2417 47.1006 85.9016 46.7327 85.5919 46.5116C84.6987 45.8736 83.4267 45.8626 82.4761 46.378C82.1259 46.5678 81.8241 46.8232 81.5248 47.0827C81.4 47.1909 81.289 47.3653 81.1387 47.4353Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4588 46.159C75.2415 46.1875 74.9254 46.1845 74.7748 46.3741C74.6569 46.5225 74.7143 46.8296 74.7143 47.0079V48.6486V53.1155V54.2322C74.7143 54.3758 74.6835 54.569 74.7884 54.6846C74.8958 54.8026 75.0898 54.8214 75.2382 54.8426C75.6465 54.9007 76.1126 54.895 76.5204 54.835C76.67 54.813 76.8752 54.7802 76.9536 54.632C77.0333 54.4818 76.9754 54.1802 76.9754 54.0116V52.4675V48.0006V46.8425C76.9754 46.7091 77.0174 46.4906 76.9343 46.3777C76.8509 46.2643 76.6791 46.2226 76.548 46.1981C76.2085 46.1347 75.8024 46.1139 75.4588 46.159Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4723 46.1728C75.255 46.2012 74.9389 46.1983 74.7883 46.3878C74.6704 46.5362 74.7278 46.8433 74.7278 47.0217V48.6347V53.1016V54.2184C74.7278 54.3619 74.697 54.5551 74.8019 54.6708C74.9093 54.7888 75.1034 54.8076 75.2517 54.8288C75.6519 54.8858 76.1069 54.8801 76.5063 54.8212C76.6559 54.7991 76.8612 54.7664 76.9396 54.6182C77.0192 54.4679 76.9613 54.1663 76.9613 53.9978V52.4812V48.0143V46.8562C76.9613 46.7229 77.0033 46.5043 76.9203 46.3915C76.8369 46.2781 76.665 46.2364 76.5339 46.2119C76.2025 46.15 75.8079 46.1286 75.4723 46.1728Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5146 46.2176C68.514 46.2182 68.5133 46.2327 68.5195 46.2265C68.5202 46.2258 68.5209 46.2114 68.5146 46.2176Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6068 46.5116C68.672 46.5921 68.9324 46.5802 69.0342 46.5943C69.3753 46.6415 69.7177 46.7387 70.0407 46.857C71.1571 47.2662 72.444 48.3587 71.9095 49.6826C71.8119 49.9238 71.6654 50.1346 71.4962 50.3305C71.2444 50.6221 70.9151 50.8472 70.5784 51.0293C70.4448 51.1016 70.1561 51.1624 70.0682 51.2818C71.1236 50.9247 72.2255 49.9819 72.0199 48.7588C71.987 48.5625 71.9122 48.3837 71.8224 48.2074C71.7142 47.9945 71.5522 47.792 71.378 47.6295C70.8276 47.1167 70.1311 46.8196 69.4065 46.6477C69.1442 46.5857 68.8645 46.584 68.6068 46.5116Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1157 46.5761C66.115 46.5768 66.1143 46.5912 66.1205 46.585C66.1212 46.5843 66.1219 46.5699 66.1157 46.5761Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6552 51.5989V51.5851C67.4117 51.585 67.1625 51.5334 66.9245 51.4859C66.1685 51.3346 65.4064 51.0207 64.8427 50.4817C64.1361 49.8059 63.9441 48.8357 64.5218 48.0144C64.6878 47.7784 64.8992 47.5713 65.1322 47.4019C65.4564 47.1665 65.8133 46.9712 66.1938 46.8425C66.1245 46.8221 66.0377 46.8773 65.9732 46.9031C65.7876 46.9774 65.6075 47.0662 65.4355 47.1679C64.7038 47.6009 64.0489 48.3482 64.1573 49.2552C64.3119 50.548 65.7247 51.2651 66.8693 51.4941C67.1266 51.5455 67.392 51.5989 67.6552 51.5989ZM68.7168 46.8701V46.8838C69.7168 46.9628 70.9754 47.4201 71.4836 48.3452C71.9708 49.2321 71.4014 50.131 70.6193 50.6035C70.4339 50.7155 70.1658 50.9018 69.9438 50.9096C69.9958 50.9453 70.0544 50.9115 70.1092 50.8896C70.2411 50.8369 70.3712 50.7734 70.4953 50.7047C71.0066 50.4212 71.5103 49.9866 71.6501 49.393C71.9622 48.0681 70.5108 47.2537 69.4337 46.9924C69.2017 46.9361 68.9565 46.8751 68.7168 46.8701Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7305 46.8839V46.9666C68.7929 47.0379 68.8299 47.1896 68.827 47.2837C68.8714 47.334 68.8842 47.3967 68.8821 47.4629C68.9662 47.5591 69.0377 47.8319 69.0338 47.9592C69.0769 48.0085 69.0894 48.074 69.0889 48.1384C69.173 48.2346 69.2445 48.5074 69.2406 48.6348C69.2837 48.6841 69.2962 48.7495 69.2957 48.814C69.3498 48.8759 69.379 48.9943 69.3784 49.0759C69.4288 49.1335 69.4543 49.2347 69.4474 49.3103C69.5315 49.4065 69.603 49.6793 69.599 49.8066C69.6421 49.8559 69.6547 49.9214 69.6542 49.9859C69.7164 50.0572 69.7536 50.2089 69.7507 50.303C69.7952 50.3533 69.8079 50.416 69.8058 50.4822C69.8915 50.5801 69.9282 50.7965 69.9575 50.9234C70.941 50.6549 71.9812 49.6367 71.5836 48.552C71.5233 48.3876 71.4344 48.2353 71.3269 48.0971C70.7426 47.344 69.6561 46.9569 68.7305 46.8839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7763 47.0861C68.7756 47.0868 68.7749 47.1013 68.7811 47.0951C68.7818 47.0944 68.7825 47.0799 68.7763 47.0861Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5314 51.1991C67.277 51.2589 66.8803 51.1231 66.6353 51.0478C65.807 50.7931 64.8114 50.3164 64.5796 49.393C64.3711 48.5634 64.969 47.8596 65.6426 47.4631C65.8268 47.3547 66.0853 47.181 66.3044 47.1734C66.252 47.1375 66.1941 47.172 66.1389 47.193C66.0114 47.2416 65.8873 47.2997 65.7667 47.3633C65.2526 47.6347 64.7587 48.0481 64.5814 48.621C64.5393 48.7568 64.5259 48.8933 64.5259 49.0346C64.5259 50.0276 65.4189 50.6163 66.2492 50.9454C66.5513 51.0652 66.8796 51.1436 67.2005 51.1933C67.2806 51.2057 67.4723 51.2668 67.5314 51.1991Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5176 51.2129C67.5042 51.0574 67.4318 50.8927 67.3844 50.7441L67.1733 50.0548L66.5839 48.1246C66.4876 47.8044 66.3659 47.4853 66.2906 47.1595C65.9842 47.2433 65.6807 47.4137 65.422 47.595C65.2094 47.7439 65.0179 47.9166 64.8619 48.1246C64.3792 48.7683 64.4656 49.5941 65.0224 50.1651C65.503 50.6576 66.1658 50.9485 66.8283 51.1008C67.0516 51.1524 67.2874 51.2122 67.5176 51.2129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4741 47.7479C66.4734 47.7486 66.4727 47.7631 66.4789 47.7569C66.4796 47.7562 66.4803 47.7417 66.4741 47.7479Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9835 47.7617C68.9835 47.7617 68.9822 47.7768 68.9884 47.7706C68.9884 47.7706 68.9897 47.7555 68.9835 47.7617Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6811 48.4235C66.6804 48.4242 66.6797 48.4386 66.6859 48.4324C66.6866 48.4318 66.6873 48.4173 66.6811 48.4235Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1904 48.4373C69.1897 48.438 69.189 48.4524 69.1952 48.4462C69.1959 48.4455 69.1966 48.4311 69.1904 48.4373Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8325 48.9198C66.8318 48.9205 66.8311 48.935 66.8373 48.9288C66.838 48.9281 66.8387 48.9136 66.8325 48.9198Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3417 48.9335C69.3411 48.9342 69.3404 48.9487 69.3466 48.9425C69.3473 48.9418 69.3479 48.9273 69.3417 48.9335Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4243 49.1955C69.4236 49.1962 69.4229 49.2107 69.4291 49.2045C69.4298 49.2038 69.4305 49.1893 69.4243 49.1955Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.998 49.4575C66.9973 49.4582 66.9966 49.4726 67.0028 49.4664C67.0035 49.4657 67.0042 49.4513 66.998 49.4575Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0395 49.5954C67.0388 49.596 67.0381 49.6105 67.0443 49.6043C67.045 49.6036 67.0457 49.5891 67.0395 49.5954Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5488 49.6091C69.5481 49.6098 69.5474 49.6243 69.5536 49.6181C69.5543 49.6174 69.555 49.6029 69.5488 49.6091Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1909 50.0917C67.1902 50.0924 67.1895 50.1069 67.1957 50.1007C67.1964 50.1 67.1971 50.0855 67.1909 50.0917Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7001 50.1055C69.6995 50.1062 69.6988 50.1207 69.705 50.1144C69.7057 50.1138 69.7063 50.0993 69.7001 50.1055Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3979 50.7672C67.3972 50.7679 67.3965 50.7824 67.4027 50.7762C67.4034 50.7755 67.4041 50.761 67.3979 50.7672Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9072 50.781C69.9065 50.7817 69.9058 50.7962 69.912 50.79C69.9127 50.7893 69.9134 50.7748 69.9072 50.781Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0772 51.3276C70.071 51.3338 70.0855 51.3332 70.0862 51.3325C70.0924 51.3263 70.0779 51.327 70.0772 51.3276Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1415 51.5393C70.1409 51.54 70.1402 51.5544 70.1464 51.5482C70.1471 51.5475 70.1478 51.5331 70.1415 51.5393Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2104 51.7461C70.2097 51.7468 70.209 51.7613 70.2152 51.7551C70.2159 51.7544 70.2166 51.7399 70.2104 51.7461Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7148 51.8012C67.7141 51.8019 67.7134 51.8164 67.7196 51.8102C67.7203 51.8095 67.721 51.795 67.7148 51.8012Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2656 51.9529C70.2649 51.9536 70.2642 51.9681 70.2704 51.9619C70.2711 51.9612 70.2718 51.9467 70.2656 51.9529Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8666 52.2976C67.866 52.2983 67.8653 52.3127 67.8715 52.3065C67.8722 52.3058 67.8729 52.2914 67.8666 52.2976Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9492 52.5733C67.9485 52.574 67.9478 52.5885 67.954 52.5823C67.9547 52.5816 67.9554 52.5671 67.9492 52.5733Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9633 52.6146C67.9626 52.6153 67.9619 52.6298 67.9682 52.6236C67.9688 52.6229 67.9695 52.6084 67.9633 52.6146Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4721 52.6284C70.4714 52.6291 70.4707 52.6436 70.4769 52.6374C70.4776 52.6367 70.4783 52.6222 70.4721 52.6284Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1147 53.111C68.114 53.1117 68.1133 53.1261 68.1195 53.1199C68.1202 53.1193 68.1209 53.1048 68.1147 53.111Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.624 53.1248C70.6233 53.1255 70.6226 53.1399 70.6288 53.1337C70.6295 53.133 70.6302 53.1186 70.624 53.1248Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3217 53.7865C68.321 53.7872 68.3203 53.8017 68.3266 53.7955C68.3272 53.7948 68.3279 53.7803 68.3217 53.7865Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.831 53.8003C70.8303 53.801 70.8296 53.8155 70.8358 53.8093C70.8365 53.8086 70.8372 53.7941 70.831 53.8003Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9824 54.2966C70.9817 54.2973 70.981 54.3118 70.9872 54.3056C70.9879 54.3049 70.9886 54.2904 70.9824 54.2966Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5283 54.4621C68.5276 54.4627 68.5269 54.4772 68.5331 54.471C68.5338 54.4703 68.5345 54.4558 68.5283 54.4621Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6801 54.9584C68.6794 54.9591 68.6787 54.9736 68.6849 54.9674C68.6856 54.9667 68.6863 54.9522 68.6801 54.9584Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1894 54.9722C71.1887 54.9729 71.188 54.9873 71.1942 54.9811C71.1949 54.9805 71.1956 54.966 71.1894 54.9722Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8867 55.6339C68.886 55.6346 68.8853 55.6491 68.8915 55.6429C68.8922 55.6422 68.8929 55.6277 68.8867 55.6339Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3959 55.6477C71.3953 55.6484 71.3946 55.6629 71.4008 55.6567C71.4015 55.656 71.4021 55.6415 71.3959 55.6477Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0385 56.1303C69.0378 56.131 69.0371 56.1454 69.0433 56.1392C69.044 56.1385 69.0447 56.1241 69.0385 56.1303Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5478 56.1441C71.5471 56.1447 71.5464 56.1592 71.5526 56.153C71.5533 56.1523 71.554 56.1379 71.5478 56.1441Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.644 56.4887C71.6433 56.4894 71.6426 56.5039 71.6488 56.4977C71.6495 56.497 71.6502 56.4825 71.644 56.4887Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2451 56.8058C69.2444 56.8065 69.2437 56.821 69.2499 56.8148C69.2506 56.8141 69.2513 56.7996 69.2451 56.8058Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7822 56.9575C71.7815 56.9582 71.7808 56.9726 71.787 56.9664C71.7877 56.9657 71.7884 56.9513 71.7822 56.9575Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3969 57.3021C69.3962 57.3028 69.3955 57.3173 69.4017 57.3111C69.4024 57.3104 69.4031 57.2959 69.3969 57.3021Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9294 57.6375V57.6651H71.957C71.9494 57.6425 71.952 57.6449 71.9294 57.6375Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9338 57.6882C71.9331 57.6889 71.9324 57.7034 71.9386 57.6971C71.9393 57.6965 71.94 57.682 71.9338 57.6882Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9611 57.7847C71.9604 57.7854 71.9597 57.7998 71.9659 57.7936C71.9666 57.793 71.9673 57.7785 71.9611 57.7847Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9615 57.8261C71.9608 57.8268 71.9601 57.8412 71.9663 57.835C71.967 57.8343 71.9677 57.8199 71.9615 57.8261Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9889 57.9088C71.9883 57.9095 71.9876 57.9239 71.9938 57.9177C71.9945 57.9171 71.9951 57.9026 71.9889 57.9088Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0026 57.9915C72.0019 57.9922 72.0012 58.0066 72.0074 58.0004C72.0081 57.9997 72.0088 57.9853 72.0026 57.9915Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0165 58.088C72.0159 58.0887 72.0152 58.1031 72.0214 58.0969C72.0221 58.0962 72.0228 58.0818 72.0165 58.088Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0302 58.1845C72.0295 58.1852 72.0288 58.1997 72.035 58.1935C72.0357 58.1928 72.0364 58.1783 72.0302 58.1845Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.03 58.2396C72.0293 58.2403 72.0286 58.2548 72.0348 58.2486C72.0355 58.2479 72.0362 58.2334 72.03 58.2396Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0439 58.2672C72.0432 58.2679 72.0425 58.2824 72.0487 58.2762C72.0494 58.2755 72.0501 58.261 72.0439 58.2672Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6865 58.2948C69.6858 58.2955 69.6851 58.31 69.6913 58.3038C69.692 58.3031 69.6927 58.2886 69.6865 58.2948Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0533 58.3406L72.0396 58.3682H72.0671C72.0671 58.3427 72.0713 58.3496 72.0533 58.3406Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0576 58.4189C72.0569 58.4196 72.0562 58.4341 72.0624 58.4279C72.0631 58.4272 72.0638 58.4127 72.0576 58.4189Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0626 58.4968C72.0564 58.503 72.0708 58.5023 72.0715 58.5016C72.0777 58.4954 72.0633 58.4961 72.0626 58.4968Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0717 58.5705C72.071 58.5712 72.0703 58.5857 72.0765 58.5795C72.0772 58.5788 72.0779 58.5643 72.0717 58.5705Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0714 58.6119C72.0707 58.6126 72.07 58.6271 72.0762 58.6209C72.0769 58.6202 72.0776 58.6057 72.0714 58.6119Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0811 58.6991V58.7405H72.0948C72.0914 58.7205 72.0904 58.7163 72.0811 58.6991Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0853 58.7498C72.0846 58.7505 72.084 58.765 72.0902 58.7587C72.0908 58.7581 72.0915 58.7436 72.0853 58.7498Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0854 58.7774C72.0847 58.778 72.084 58.7925 72.0902 58.7863C72.0909 58.7856 72.0916 58.7712 72.0854 58.7774Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8383 58.7911C69.8376 58.7918 69.8369 58.8063 69.8432 58.8001C69.8438 58.7994 69.8445 58.7849 69.8383 58.7911Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0991 58.8463C72.0984 58.847 72.0977 58.8614 72.1039 58.8552C72.1046 58.8545 72.1053 58.8401 72.0991 58.8463Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.852 58.8601C69.8513 58.8608 69.8506 58.8752 69.8568 58.869C69.8575 58.8683 69.8582 58.8539 69.852 58.8601Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0991 58.9014C72.0984 58.9021 72.0977 58.9166 72.1039 58.9104C72.1046 58.9097 72.1053 58.8952 72.0991 58.9014Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 58.9566C72.1121 58.9572 72.1114 58.9717 72.1176 58.9655C72.1183 58.9648 72.1189 58.9504 72.1127 58.9566Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0992 58.9842C72.0985 58.9848 72.0978 58.9993 72.104 58.9931C72.1047 58.9924 72.1054 58.978 72.0992 58.9842Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 58.9979C72.1121 58.9986 72.1114 59.0131 72.1176 59.0069C72.1183 59.0062 72.1189 58.9917 72.1127 58.9979Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0991 59.0117C72.0984 59.0124 72.0977 59.0269 72.1039 59.0207C72.1046 59.02 72.1053 59.0055 72.0991 59.0117Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 59.0531C72.1121 59.0537 72.1114 59.0682 72.1176 59.062C72.1183 59.0613 72.1189 59.0469 72.1127 59.0531Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9208 59.1082C69.9202 59.1089 69.9195 59.1234 69.9257 59.1172C69.9264 59.1165 69.9271 59.102 69.9208 59.1082Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 59.1771C72.1121 59.1778 72.1114 59.1923 72.1176 59.1861C72.1183 59.1854 72.1189 59.1709 72.1127 59.1771Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1084 59.2092V59.2506H72.1222C72.1187 59.2306 72.1177 59.2265 72.1084 59.2092Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 59.3288C72.1121 59.3295 72.1114 59.344 72.1176 59.3378C72.1183 59.3371 72.1189 59.3226 72.1127 59.3288Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9717 59.3608C69.9793 59.3834 69.9767 59.381 69.9993 59.3884V59.3608H69.9717Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 59.3977C72.1121 59.3984 72.1114 59.4129 72.1176 59.4067C72.1183 59.406 72.1189 59.3915 72.1127 59.3977Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1083 59.4436V59.485H72.1221C72.1186 59.465 72.1178 59.4608 72.1083 59.4436Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 59.508C72.1121 59.5087 72.1114 59.5232 72.1176 59.517C72.1183 59.5163 72.1189 59.5018 72.1127 59.508Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1087 59.5401V59.5815H72.1224C72.119 59.5615 72.1181 59.5573 72.1087 59.5401Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1084 59.609V59.6504H72.1222C72.1187 59.6304 72.1177 59.6262 72.1084 59.609Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 59.6735C72.1121 59.6742 72.1114 59.6886 72.1176 59.6824C72.1183 59.6818 72.1189 59.6673 72.1127 59.6735Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0727 59.7011C70.072 59.7018 70.0713 59.7162 70.0775 59.71C70.0782 59.7093 70.0789 59.6949 70.0727 59.7011Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0991 59.8114C72.0984 59.812 72.0977 59.8265 72.1039 59.8203C72.1046 59.8196 72.1053 59.8052 72.0991 59.8114Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0947 59.8434V59.8847H72.1085C72.1051 59.8648 72.104 59.8606 72.0947 59.8434Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0991 59.9216C72.0984 59.9223 72.0977 59.9368 72.1039 59.9306C72.1046 59.9299 72.1053 59.9154 72.0991 59.9216Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1415 59.963C70.1409 59.9637 70.1402 59.9782 70.1464 59.972C70.1471 59.9713 70.1478 59.9568 70.1415 59.963Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0904 59.9857C72.0842 59.9919 72.0987 59.9912 72.0994 59.9906C72.1056 59.9843 72.0911 59.985 72.0904 59.9857Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0854 60.0457C72.0847 60.0464 72.084 60.0609 72.0902 60.0547C72.0909 60.054 72.0916 60.0395 72.0854 60.0457Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0811 60.0778V60.1191H72.0948C72.0914 60.0991 72.0904 60.095 72.0811 60.0778Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0762 60.1374C72.07 60.1436 72.0845 60.1429 72.0852 60.1422C72.0914 60.136 72.0769 60.1367 72.0762 60.1374Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0669 60.1605V60.2019H72.0807C72.0772 60.1819 72.0762 60.1778 72.0669 60.1605Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1919 60.2156V60.2432C70.2143 60.2358 70.2121 60.2382 70.2195 60.2156H70.1919Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0717 60.2387C72.071 60.2394 72.0703 60.2539 72.0765 60.2477C72.0772 60.247 72.0779 60.2325 72.0717 60.2387Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0489 60.3304C72.0427 60.3366 72.0572 60.3359 72.0579 60.3352C72.0641 60.329 72.0496 60.3297 72.0489 60.3304Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0396 60.3535V60.3949H72.0533C72.0499 60.3749 72.0489 60.3707 72.0396 60.3535Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0396 60.4086V60.45H72.0533C72.0499 60.43 72.0489 60.4259 72.0396 60.4086Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2792 60.5558C70.2786 60.5565 70.2779 60.571 70.2841 60.5648C70.2848 60.5641 70.2854 60.5496 70.2792 60.5558Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0165 60.5834C72.0159 60.5841 72.0152 60.5986 72.0214 60.5924C72.0221 60.5917 72.0228 60.5772 72.0165 60.5834Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0074 60.6199C72.0012 60.6261 72.0157 60.6255 72.0164 60.6248C72.0226 60.6186 72.0081 60.6193 72.0074 60.6199Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.998 60.643V60.6844H72.0118C72.0084 60.6644 72.0074 60.6602 71.998 60.643Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3071 60.7213C70.3064 60.722 70.3057 60.7364 70.3119 60.7302C70.3126 60.7295 70.3133 60.7151 70.3071 60.7213Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9887 60.7351C71.988 60.7358 71.9873 60.7502 71.9935 60.744C71.9942 60.7433 71.9949 60.7289 71.9887 60.7351Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9801 60.7716C71.9739 60.7778 71.9883 60.7771 71.989 60.7764C71.9952 60.7702 71.9807 60.7709 71.9801 60.7716Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3344 60.7902C70.3337 60.7909 70.333 60.8054 70.3392 60.7992C70.3399 60.7985 70.3406 60.784 70.3344 60.7902Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.975 60.804C71.9744 60.8047 71.9737 60.8191 71.9799 60.8129C71.9806 60.8122 71.9812 60.7978 71.975 60.804Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3344 60.8454C70.3337 60.846 70.333 60.8605 70.3392 60.8543C70.3399 60.8536 70.3406 60.8391 70.3344 60.8454Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9522 60.8681C71.946 60.8743 71.9605 60.8736 71.9612 60.8729C71.9674 60.8667 71.9529 60.8674 71.9522 60.8681Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9429 60.8912V60.9187H71.9704C71.9629 60.8962 71.9654 60.8986 71.9429 60.8912Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3574 60.9188V60.9601H70.3712C70.3678 60.9401 70.3669 60.936 70.3574 60.9188Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9477 60.9418C71.947 60.9425 71.9463 60.957 71.9525 60.9508C71.9532 60.9501 71.9539 60.9356 71.9477 60.9418Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3481 60.9556C70.3474 60.9563 70.3467 60.9708 70.3529 60.9646C70.3536 60.9639 70.3543 60.9494 70.3481 60.9556Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9292 60.9601V61.0015H71.943C71.9395 60.9815 71.9387 60.9774 71.9292 60.9601Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9249 61.006C71.9187 61.0122 71.9332 61.0115 71.9338 61.0108C71.94 61.0046 71.9256 61.0053 71.9249 61.006Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9155 61.0291V61.0704H71.9293C71.9259 61.0504 71.925 61.0463 71.9155 61.0291Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3574 61.0428V61.0704C70.3798 61.063 70.3776 61.0653 70.385 61.0428H70.3574Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9015 61.098L71.8877 61.1256H71.9153C71.9153 61.1001 71.9194 61.107 71.9015 61.098Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3759 61.1348C70.3752 61.1355 70.3745 61.15 70.3807 61.1438C70.3814 61.1431 70.3821 61.1286 70.3759 61.1348Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8784 61.19C71.8777 61.1907 71.877 61.2052 71.8832 61.199C71.8839 61.1983 71.8846 61.1838 71.8784 61.19Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8784 61.2176C71.8777 61.2183 71.877 61.2328 71.8832 61.2266C71.8839 61.2259 71.8846 61.2114 71.8784 61.2176Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8647 61.2314C71.864 61.2321 71.8633 61.2466 71.8695 61.2404C71.8702 61.2397 71.8709 61.2252 71.8647 61.2314Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3896 61.2727C70.3889 61.2734 70.3882 61.2879 70.3944 61.2817C70.3951 61.281 70.3958 61.2665 70.3896 61.2727Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.851 61.2865C71.8503 61.2872 71.8496 61.3017 71.8558 61.2955C71.8565 61.2948 71.8572 61.2803 71.851 61.2865Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4033 61.3141C70.4026 61.3148 70.4019 61.3293 70.4081 61.3231C70.4088 61.3224 70.4095 61.3079 70.4033 61.3141ZM71.8326 61.3048V61.3462H71.8464C71.843 61.3262 71.8421 61.322 71.8326 61.3048Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3896 61.3279C70.3889 61.3286 70.3882 61.3431 70.3944 61.3369C70.3951 61.3362 70.3958 61.3217 70.3896 61.3279Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8282 61.3507C71.822 61.3569 71.8365 61.3562 71.8372 61.3555C71.8434 61.3493 71.8289 61.35 71.8282 61.3507Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4033 61.3692C70.4026 61.3699 70.4019 61.3844 70.4081 61.3782C70.4088 61.3775 70.4095 61.363 70.4033 61.3692Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3853 61.4702C70.3927 61.4928 70.3904 61.4904 70.4128 61.4978V61.4702H70.3853Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7773 61.484V61.5254H71.7911C71.7877 61.5054 71.7868 61.5012 71.7773 61.484Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3853 61.5116L70.399 61.553H70.4128V61.5116H70.3853Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4033 61.6036C70.4026 61.6043 70.4019 61.6188 70.4081 61.6126C70.4088 61.6119 70.4095 61.5974 70.4033 61.6036Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4033 61.645C70.4026 61.6457 70.4019 61.6602 70.4081 61.6539C70.4088 61.6533 70.4095 61.6388 70.4033 61.645Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9669 61.6495L64.9531 61.6771H64.9807C64.9807 61.6515 64.9848 61.6584 64.9669 61.6495Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7315 61.6539C71.7253 61.6601 71.7398 61.6595 71.7405 61.6588C71.7467 61.6526 71.7322 61.6532 71.7315 61.6539Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0313 61.6677C65.0251 61.6739 65.0396 61.6732 65.0403 61.6726C65.0465 61.6664 65.032 61.667 65.0313 61.6677Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0728 61.6677C65.0666 61.6739 65.0811 61.6732 65.0818 61.6726C65.088 61.6664 65.0735 61.667 65.0728 61.6677Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1002 61.6677C65.094 61.6739 65.1084 61.6732 65.1091 61.6726C65.1153 61.6664 65.1009 61.667 65.1002 61.6677Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.128 61.6677C65.1218 61.6739 65.1363 61.6732 65.137 61.6726C65.1432 61.6664 65.1287 61.667 65.128 61.6677Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.727 61.6864C71.7263 61.687 71.7256 61.7015 71.7318 61.6953C71.7325 61.6946 71.7332 61.6802 71.727 61.6864Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3159 61.7002C65.3152 61.7008 65.3145 61.7153 65.3207 61.7091C65.3214 61.7084 65.3221 61.6939 65.3159 61.7002Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4033 61.7002C70.4026 61.7008 70.4019 61.7153 70.4081 61.7091C70.4088 61.7084 70.4095 61.6939 70.4033 61.7002Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3624 61.7091C65.3562 61.7153 65.3707 61.7146 65.3713 61.7139C65.3775 61.7077 65.3631 61.7084 65.3624 61.7091Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4082 61.7184V61.7322H65.4496C65.4323 61.7227 65.4282 61.7218 65.4082 61.7184Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.454 61.7277C65.4534 61.7284 65.4527 61.7429 65.4589 61.7367C65.4596 61.736 65.4603 61.7215 65.454 61.7277Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7042 61.7504C71.698 61.7566 71.7125 61.756 71.7131 61.7553C71.7193 61.7491 71.7049 61.7497 71.7042 61.7504Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6314 61.7642C64.6252 61.7705 64.6397 61.7698 64.6404 61.7691C64.6466 61.7629 64.6321 61.7636 64.6314 61.7642Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5416 61.7642C65.5354 61.7704 65.5499 61.7697 65.5505 61.7691C65.5567 61.7628 65.5423 61.7635 65.5416 61.7642Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3896 61.8242C70.3889 61.8249 70.3882 61.8394 70.3944 61.8332C70.3951 61.8325 70.3958 61.818 70.3896 61.8242Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6582 61.838C71.6575 61.8387 71.6568 61.8531 71.663 61.8469C71.6637 61.8462 71.6644 61.8318 71.6582 61.838Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4614 61.8793C64.4607 61.88 64.46 61.8945 64.4662 61.8883C64.4669 61.8876 64.4676 61.8731 64.4614 61.8793Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6303 61.8931C71.6296 61.8938 71.6289 61.9083 71.6351 61.9021C71.6358 61.9014 71.6365 61.8869 71.6303 61.8931Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4249 61.9021C64.4187 61.9083 64.4332 61.9076 64.4338 61.9069C64.44 61.9007 64.4256 61.9014 64.4249 61.9021Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8448 61.9021C65.8386 61.9083 65.8531 61.9076 65.8538 61.9069C65.86 61.9007 65.8455 61.9014 65.8448 61.9021ZM70.3758 61.9069C70.3751 61.9076 70.3744 61.9221 70.3806 61.9159C70.3813 61.9152 70.382 61.9007 70.3758 61.9069Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6303 61.9345C71.6296 61.9352 71.6289 61.9497 71.6351 61.9435C71.6358 61.9428 71.6365 61.9283 71.6303 61.9345Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3834 61.9572C64.3772 61.9634 64.3917 61.9627 64.3923 61.962C64.3985 61.9558 64.3841 61.9565 64.3834 61.9572Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9638 61.9758C65.9631 61.9765 65.9624 61.991 65.9686 61.9848C65.9693 61.9841 65.97 61.9696 65.9638 61.9758Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3623 61.9896C70.3616 61.9903 70.3609 62.0048 70.3671 61.9986C70.3678 61.9979 70.3685 61.9834 70.3623 61.9896Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5938 61.9986C71.5876 62.0048 71.6021 62.0041 71.6028 62.0034C71.609 61.9972 71.5945 61.9979 71.5938 61.9986Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0515 62.0262C66.0453 62.0324 66.0598 62.0317 66.0605 62.031C66.0667 62.0248 66.0522 62.0255 66.0515 62.0262ZM70.3575 62.0217V62.0631H70.3712C70.3678 62.0431 70.3669 62.039 70.3575 62.0217Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3009 62.0537C64.2947 62.0599 64.3091 62.0593 64.3098 62.0586C64.316 62.0524 64.3015 62.053 64.3009 62.0537Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1065 62.0675C66.1003 62.0737 66.1148 62.073 66.1155 62.0723C66.1217 62.0661 66.1072 62.0668 66.1065 62.0675Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.543 62.0768V62.132H71.5568C71.5543 62.1087 71.5523 62.0977 71.543 62.0768Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1617 62.0951C66.1555 62.1013 66.17 62.1006 66.1707 62.0999C66.1769 62.0937 66.1624 62.0944 66.1617 62.0951Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3481 62.0999C70.3474 62.1006 70.3467 62.1151 70.3529 62.1089C70.3536 62.1082 70.3543 62.0937 70.3481 62.0999Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1802 62.1044C66.1878 62.127 66.1852 62.1246 66.2078 62.132C66.2002 62.1094 66.2028 62.1118 66.1802 62.1044Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2169 62.1365C66.2107 62.1427 66.2251 62.142 66.2258 62.1413C66.232 62.1351 66.2176 62.1358 66.2169 62.1365Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3394 62.1365C70.3332 62.1427 70.3477 62.142 70.3484 62.1413C70.3546 62.1351 70.3401 62.1358 70.3394 62.1365Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2354 62.1458C66.243 62.1684 66.2406 62.166 66.263 62.1734C66.2554 62.1508 66.258 62.1532 66.2354 62.1458Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.525 62.1503C71.5188 62.1565 71.5333 62.1558 71.5339 62.1551C71.5401 62.1489 71.5257 62.1496 71.525 62.1503Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2315 62.164C64.2253 62.1702 64.2398 62.1695 64.2405 62.1689C64.2467 62.1626 64.2322 62.1633 64.2315 62.164Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3344 62.1827C70.3337 62.1834 70.333 62.1979 70.3392 62.1917C70.3399 62.191 70.3406 62.1765 70.3344 62.1827Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2999 62.2054C66.2937 62.2116 66.3082 62.2109 66.3088 62.2102C66.315 62.204 66.3006 62.2047 66.2999 62.2054Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4835 62.2054C71.4773 62.2116 71.4917 62.2109 71.4924 62.2102C71.4986 62.204 71.4842 62.2047 71.4835 62.2054Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1905 62.2192C64.1843 62.2254 64.1988 62.2247 64.1995 62.224C64.2057 62.2178 64.1912 62.2185 64.1905 62.2192Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1855 62.2378C64.1848 62.2385 64.1841 62.253 64.1903 62.2468C64.191 62.2461 64.1917 62.2316 64.1855 62.2378Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3116 62.233C70.3054 62.2392 70.3199 62.2385 70.3206 62.2378C70.3268 62.2316 70.3123 62.2323 70.3116 62.233Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3687 62.2468C66.3625 62.253 66.377 62.2523 66.3777 62.2516C66.3839 62.2454 66.3694 62.2461 66.3687 62.2468Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1582 62.2792C64.1575 62.2799 64.1568 62.2944 64.163 62.2882C64.1637 62.2875 64.1644 62.273 64.1582 62.2792Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4239 62.2882C66.4177 62.2944 66.4322 62.2937 66.4329 62.293C66.4391 62.2868 66.4246 62.2875 66.4239 62.2882ZM70.2932 62.293C70.2925 62.2937 70.2918 62.3081 70.298 62.3019C70.2987 62.3013 70.2994 62.2868 70.2932 62.293Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4791 62.3295C66.4729 62.3357 66.4874 62.335 66.488 62.3343C66.4942 62.3281 66.4798 62.3288 66.4791 62.3295Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4146 62.3571C71.4084 62.3633 71.4229 62.3626 71.4236 62.3619C71.4298 62.3557 71.4153 62.3564 71.4146 62.3571Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1166 62.3895C64.116 62.3902 64.1153 62.4046 64.1215 62.3984C64.1222 62.3978 64.1229 62.3833 64.1166 62.3895Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5571 62.4033C66.5564 62.404 66.5557 62.4184 66.5619 62.4122C66.5626 62.4115 66.5633 62.3971 66.5571 62.4033ZM70.2657 62.4033C70.265 62.404 70.2643 62.4184 70.2705 62.4122C70.2712 62.4115 70.2719 62.3971 70.2657 62.4033Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0888 62.4308C64.0881 62.4315 64.0874 62.446 64.0936 62.4398C64.0943 62.4391 64.095 62.4246 64.0888 62.4308Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6168 62.4536C66.6106 62.4598 66.625 62.4591 66.6257 62.4584C66.6319 62.4522 66.6175 62.4529 66.6168 62.4536Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2154 62.495C70.2092 62.5012 70.2237 62.5005 70.2244 62.4998C70.2306 62.4936 70.2161 62.4943 70.2154 62.495Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0615 62.5136C64.0608 62.5143 64.0601 62.5287 64.0663 62.5225C64.067 62.5218 64.0677 62.5074 64.0615 62.5136Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2061 62.5043V62.5456H70.2198C70.2164 62.5256 70.2154 62.5215 70.2061 62.5043Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7084 62.5274C66.7078 62.528 66.7071 62.5425 66.7133 62.5363C66.714 62.5356 66.7146 62.5212 66.7084 62.5274Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0478 62.5549C64.0471 62.5556 64.0464 62.5701 64.0526 62.5638C64.0533 62.5632 64.054 62.5487 64.0478 62.5549Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2998 62.5549C71.2991 62.5556 71.2984 62.5701 71.3046 62.5638C71.3053 62.5632 71.306 62.5487 71.2998 62.5549Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0341 62.5687C64.0334 62.5694 64.0327 62.5838 64.039 62.5776C64.0396 62.577 64.0403 62.5625 64.0341 62.5687Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7636 62.5687C66.7629 62.5694 66.7622 62.5838 66.7684 62.5776C66.7691 62.577 66.7698 62.5625 66.7636 62.5687Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2719 62.5825C71.2712 62.5832 71.2705 62.5977 71.2767 62.5914C71.2774 62.5908 71.2781 62.5763 71.2719 62.5825Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1739 62.5914C70.1677 62.5976 70.1822 62.597 70.1829 62.5963C70.1891 62.5901 70.1746 62.5908 70.1739 62.5914Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8096 62.6052C66.8034 62.6114 66.8179 62.6107 66.8186 62.6101C66.8248 62.6039 66.8103 62.6045 66.8096 62.6052Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2582 62.6101C71.2576 62.6108 71.2569 62.6252 71.2631 62.619C71.2638 62.6183 71.2645 62.6039 71.2582 62.6101Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0156 62.6146V62.6559H64.0294C64.026 62.6359 64.0251 62.6318 64.0156 62.6146Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2399 62.6283L71.2261 62.6559C71.2435 62.6424 71.2452 62.6464 71.2399 62.6283Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8512 62.6466C66.8449 62.6528 66.8594 62.6521 66.8601 62.6514C66.8663 62.6452 66.8518 62.6459 66.8512 62.6466Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1461 62.6466C70.1399 62.6528 70.1543 62.6521 70.155 62.6514C70.1612 62.6452 70.1468 62.6459 70.1461 62.6466Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1415 62.6652C70.1409 62.6659 70.1402 62.6803 70.1464 62.6741C70.1471 62.6734 70.1478 62.659 70.1415 62.6652Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9063 62.6879C66.9001 62.6941 66.9146 62.6935 66.9153 62.6928C66.9215 62.6866 66.907 62.6872 66.9063 62.6879Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.002 62.6973V62.7524H64.0157C64.0133 62.7291 64.0113 62.7181 64.002 62.6973Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9248 62.6973C66.9322 62.7198 66.9298 62.7174 66.9524 62.7248C66.9448 62.7023 66.9474 62.7047 66.9248 62.6973Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1709 62.7249V62.7386H71.2123C71.195 62.7292 71.1909 62.7283 71.1709 62.7249Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0727 62.7617C70.072 62.7624 70.0713 62.7769 70.0775 62.7707C70.0782 62.77 70.0789 62.7555 70.0727 62.7617Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1529 62.7844C71.1467 62.7906 71.1612 62.7899 71.1619 62.7893C71.1681 62.7831 71.1536 62.7837 71.1529 62.7844Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0445 62.7982C67.0383 62.8044 67.0527 62.8038 67.0534 62.8031C67.0596 62.7969 67.0452 62.7976 67.0445 62.7982Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0582 62.812C67.052 62.8182 67.0665 62.8175 67.0671 62.8168C67.0733 62.8106 67.0589 62.8113 67.0582 62.812Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.979 62.8444C63.9783 62.8451 63.9776 62.8596 63.9838 62.8534C63.9845 62.8527 63.9852 62.8382 63.979 62.8444Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1685 62.8947C67.1623 62.9009 67.1768 62.9002 67.1775 62.8995C67.1837 62.8933 67.1692 62.894 67.1685 62.8947Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0654 62.9133C71.0647 62.914 71.064 62.9285 71.0702 62.9223C71.0709 62.9216 71.0716 62.9071 71.0654 62.9133Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2232 62.9223C67.217 62.9285 67.2315 62.9278 67.2322 62.9271C67.2384 62.9209 67.2239 62.9216 67.2232 62.9223Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9117 62.9637C69.9055 62.9699 69.92 62.9692 69.9207 62.9685C69.9269 62.9623 69.9124 62.963 69.9117 62.9637Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.996 62.9961C70.9954 62.9968 70.9947 63.0113 71.0009 63.0051C71.0016 63.0044 71.0022 62.9899 70.996 62.9961Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3336 63.0051C67.3274 63.0113 67.3418 63.0106 67.3425 63.0099C67.3487 63.0037 67.3343 63.0044 67.3336 63.0051Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8477 63.0005V63.0143H69.889C69.8718 63.0049 69.8676 63.004 69.8477 63.0005Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9824 63.0098C70.9817 63.0105 70.981 63.025 70.9872 63.0188C70.9879 63.0181 70.9886 63.0036 70.9824 63.0098Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3614 63.0326C67.3552 63.0388 67.3697 63.0381 67.3704 63.0374C67.3766 63.0312 67.3621 63.0319 67.3614 63.0326Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9835 63.0464C63.9773 63.0526 63.9917 63.0519 63.9924 63.0512C63.9986 63.045 63.9842 63.0457 63.9835 63.0464Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3887 63.0464C67.3825 63.0526 67.397 63.0519 67.3977 63.0512C67.4039 63.045 67.3894 63.0457 67.3887 63.0464Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9595 63.0464C70.9533 63.0526 70.9678 63.0519 70.9685 63.0512C70.9747 63.045 70.9602 63.0457 70.9595 63.0464Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4166 63.074C67.4104 63.0802 67.4249 63.0795 67.4255 63.0788C67.4317 63.0726 67.4173 63.0733 67.4166 63.074Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.751 63.1109H69.7648C69.7722 63.0885 69.7698 63.0907 69.7923 63.0833C69.7649 63.0737 69.7627 63.0835 69.751 63.1109Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.979 63.0926C63.9783 63.0933 63.9776 63.1078 63.9838 63.1016C63.9845 63.1009 63.9852 63.0864 63.979 63.0926Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5634 63.1477C67.5627 63.1484 67.562 63.1629 67.5683 63.1567C67.5689 63.156 67.5696 63.1415 67.5634 63.1477Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.877 63.1567C70.8708 63.1629 70.8853 63.1622 70.886 63.1615C70.8922 63.1553 70.8777 63.156 70.877 63.1567Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6138 63.1936V63.2074H67.6551C67.6379 63.1981 67.6338 63.1971 67.6138 63.1936Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5624 63.2305C69.5618 63.2312 69.5611 63.2457 69.5673 63.2394C69.568 63.2388 69.5687 63.2243 69.5624 63.2305Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.794 63.2532C70.7878 63.2594 70.8023 63.2587 70.803 63.258C70.8092 63.2518 70.7947 63.2525 70.794 63.2532Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7887 63.267C67.7824 63.2732 67.7969 63.2725 67.7976 63.2718C67.8038 63.2656 67.7893 63.2663 67.7887 63.267Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4936 63.2718C69.4929 63.2725 69.4922 63.287 69.4984 63.2808C69.4991 63.2801 69.4998 63.2656 69.4936 63.2718Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8438 63.2946C67.8376 63.3008 67.8521 63.3001 67.8528 63.2994C67.859 63.2932 67.8445 63.2939 67.8438 63.2946Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4384 63.2994C69.4377 63.3001 69.437 63.3146 69.4433 63.3084C69.4439 63.3077 69.4446 63.2932 69.4384 63.2994Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.753 63.3084C70.7468 63.3146 70.7613 63.3139 70.762 63.3132C70.7682 63.307 70.7537 63.3077 70.753 63.3084Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9033 63.3177V63.3315H67.9447C67.9274 63.3222 67.9233 63.3211 67.9033 63.3177Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0478 63.3407C64.0471 63.3414 64.0464 63.3559 64.0526 63.3497C64.0533 63.349 64.054 63.3345 64.0478 63.3407Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2637 63.3635C69.2575 63.3697 69.272 63.369 69.2727 63.3683C69.2789 63.3621 69.2644 63.3628 69.2637 63.3635Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1377 63.4004V63.4142H68.1791C68.1618 63.4047 68.1577 63.4038 68.1377 63.4004Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1792 63.4004V63.4142H68.2206C68.2033 63.4047 68.1992 63.4038 68.1792 63.4004Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.207 63.4142V63.428H68.2484C68.2312 63.4185 68.227 63.4176 68.207 63.4142Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2529 63.4235C68.2522 63.4242 68.2515 63.4386 68.2577 63.4324C68.2584 63.4318 68.2591 63.4173 68.2529 63.4235Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0157 63.4324C69.0095 63.4386 69.024 63.438 69.0247 63.4373C69.0309 63.4311 69.0164 63.4318 69.0157 63.4324Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2896 63.4418V63.4556H68.3309C68.3137 63.4461 68.3095 63.4452 68.2896 63.4418Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4366 63.46C68.4304 63.4662 68.4449 63.4655 68.4456 63.4649C68.4518 63.4587 68.4373 63.4593 68.4366 63.46Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4961 63.4693V63.4831H68.5375C68.5202 63.4736 68.5161 63.4727 68.4961 63.4693Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5748 63.4738C68.5686 63.48 68.5831 63.4793 68.5837 63.4787C68.5899 63.4724 68.5755 63.4731 68.5748 63.4738Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7398 63.4738C68.7336 63.48 68.7481 63.4793 68.7488 63.4787C68.755 63.4724 68.7405 63.4731 68.7398 63.4738Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.795 63.4738C68.7888 63.48 68.8033 63.4793 68.804 63.4787C68.8102 63.4724 68.7957 63.4731 68.795 63.4738Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8638 63.4738C68.8576 63.48 68.8721 63.4793 68.8728 63.4787C68.879 63.4724 68.8645 63.4731 68.8638 63.4738Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6295 63.4876C68.6233 63.4938 68.6377 63.4931 68.6384 63.4924C68.6446 63.4862 68.6302 63.4869 68.6295 63.4876Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5825 63.5062C70.5818 63.5069 70.5811 63.5213 70.5873 63.5151C70.588 63.5145 70.5887 63.5 70.5825 63.5062Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5366 63.5245V63.5383H70.578C70.5607 63.5288 70.5566 63.5279 70.5366 63.5245Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5048 63.5703C70.4986 63.5765 70.513 63.5758 70.5137 63.5751C70.5199 63.5689 70.5055 63.5696 70.5048 63.5703Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2179 63.7357C64.2116 63.7419 64.2261 63.7413 64.2268 63.7406C64.233 63.7344 64.2185 63.7351 64.2179 63.7357Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2888 63.7726C70.2812 63.7952 70.2838 63.7926 70.2612 63.8002V63.814C70.2886 63.8023 70.2985 63.8 70.2888 63.7726Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2822 63.8233C64.2815 63.824 64.2808 63.8385 64.287 63.8323C64.2877 63.8316 64.2884 63.8171 64.2822 63.8233Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2061 63.8416V63.8691C70.2286 63.8617 70.2262 63.864 70.2336 63.8416H70.2061Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3095 63.8784C64.3088 63.8791 64.3081 63.8936 64.3143 63.8874C64.315 63.8867 64.3157 63.8722 64.3095 63.8784Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.123 63.9105V63.9381C70.1455 63.9307 70.1432 63.9329 70.1506 63.9105H70.123Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1 63.9336C70.0994 63.9343 70.0987 63.9488 70.1049 63.9426C70.1056 63.9419 70.1062 63.9274 70.1 63.9336Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3784 63.9611C64.3777 63.9618 64.377 63.9763 64.3832 63.9701C64.3839 63.9694 64.3846 63.9549 64.3784 63.9611Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0727 63.9749C70.072 63.9756 70.0713 63.9901 70.0775 63.9839C70.0782 63.9832 70.0789 63.9687 70.0727 63.9749Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0034 64.0163C70.0027 64.017 70.002 64.0315 70.0082 64.0253C70.0089 64.0246 70.0096 64.0101 70.0034 64.0163Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4887 64.0852C64.488 64.0859 64.4873 64.1004 64.4935 64.0942C64.4942 64.0935 64.4949 64.079 64.4887 64.0852Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5302 64.1266C64.5295 64.1273 64.5288 64.1418 64.535 64.1356C64.5357 64.1349 64.5364 64.1204 64.5302 64.1266Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6593 64.2459C64.6531 64.2521 64.6675 64.2514 64.6682 64.2507C64.6744 64.2445 64.6599 64.2452 64.6593 64.2459Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7094 64.2783C64.7087 64.279 64.708 64.2934 64.7142 64.2872C64.7149 64.2865 64.7156 64.2721 64.7094 64.2783Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7281 64.2872C64.7219 64.2934 64.7364 64.2928 64.7371 64.2921C64.7433 64.2859 64.7288 64.2866 64.7281 64.2872Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6133 64.2827V64.2965H69.6546C69.6374 64.287 69.6333 64.2862 69.6133 64.2827Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5898 64.3059C69.5891 64.3066 69.5884 64.321 69.5946 64.3148C69.5953 64.3141 69.596 64.2997 69.5898 64.3059Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7646 64.3196C64.7639 64.3203 64.7632 64.3348 64.7694 64.3286C64.7701 64.3279 64.7708 64.3134 64.7646 64.3196Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5396 64.3424C69.5334 64.3486 69.5479 64.3479 69.5486 64.3472C69.5548 64.341 69.5403 64.3417 69.5396 64.3424Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3554 64.4437C69.3547 64.4444 69.354 64.4588 69.3602 64.4526C69.3609 64.452 69.3616 64.4375 69.3554 64.4437Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.004 64.4802C64.9978 64.4864 65.0123 64.4857 65.0129 64.4851C65.0191 64.4789 65.0047 64.4795 65.004 64.4802Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0678 64.5126C65.0671 64.5133 65.0664 64.5278 65.0726 64.5216C65.0733 64.5209 65.074 64.5064 65.0678 64.5126Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1832 64.5767C65.177 64.5829 65.1915 64.5822 65.1921 64.5816C65.1983 64.5754 65.1839 64.576 65.1832 64.5767Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2197 64.5816C65.219 64.5822 65.2183 64.5967 65.2245 64.5905C65.2252 64.5898 65.2259 64.5754 65.2197 64.5816Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0479 64.5723V64.6136H69.0616C69.0582 64.5936 69.0573 64.5895 69.0479 64.5723Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2794 64.6181C65.2732 64.6243 65.2876 64.6236 65.2883 64.623C65.2945 64.6168 65.2801 64.6174 65.2794 64.6181Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3072 64.6319C65.301 64.6381 65.3155 64.6374 65.3162 64.6367C65.3224 64.6305 65.3079 64.6312 65.3072 64.6319Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3345 64.6457C65.3283 64.6519 65.3428 64.6512 65.3435 64.6505C65.3497 64.6443 65.3352 64.645 65.3345 64.6457Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9282 64.6505C68.9275 64.6512 68.9268 64.6656 68.933 64.6594C68.9337 64.6587 68.9344 64.6443 68.9282 64.6505Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4312 64.687C65.425 64.6932 65.4395 64.6925 65.4402 64.6918C65.4464 64.6856 65.4319 64.6863 65.4312 64.687Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4677 64.6918C65.467 64.6925 65.4663 64.707 65.4725 64.7008C65.4732 64.7001 65.4739 64.6856 65.4677 64.6918Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5322 64.7101C65.5398 64.7327 65.5374 64.7303 65.5598 64.7377C65.5522 64.7151 65.5548 64.7176 65.5322 64.7101Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6426 64.7653V64.779H65.6839C65.6667 64.7696 65.6626 64.7687 65.6426 64.7653Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7388 64.7928V64.8066H65.7801C65.7629 64.7972 65.7588 64.7963 65.7388 64.7928Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7896 64.8249C65.7834 64.8311 65.7979 64.8304 65.7986 64.8297C65.8048 64.8235 65.7903 64.8242 65.7896 64.8249Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8261 64.8297C65.8254 64.8304 65.8247 64.8449 65.8309 64.8387C65.8316 64.838 65.8323 64.8235 65.8261 64.8297Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9273 64.8525C65.9211 64.8587 65.9356 64.858 65.9363 64.8573C65.9425 64.8511 65.928 64.8518 65.9273 64.8525Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9458 64.8618V64.8755H65.9872C65.9699 64.8661 65.9658 64.8652 65.9458 64.8618Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.024 64.8801C66.0178 64.8863 66.0323 64.8856 66.033 64.8849C66.0392 64.8787 66.0247 64.8794 66.024 64.8801Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0283 64.8893V64.9031H66.0697C66.0524 64.8937 66.0483 64.8928 66.0283 64.8893Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0562 64.9031V64.9169H66.0975C66.0803 64.9074 66.0761 64.9066 66.0562 64.9031Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2075 64.9307V64.9445H66.2489C66.2316 64.935 66.2275 64.9342 66.2075 64.9307Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2675 64.94C66.2668 64.9407 66.2661 64.9552 66.2724 64.949C66.273 64.9483 66.2737 64.9338 66.2675 64.94Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4419 64.9858V64.9996H66.4833C66.466 64.9901 66.4619 64.9893 66.4419 64.9858Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4971 64.9858V64.9996H66.5384C66.5212 64.9901 66.5171 64.9893 66.4971 64.9858Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5522 64.9858V65.0134C66.5748 65.006 66.5722 65.0084 66.5798 64.9858H66.5522Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5981 64.9952C66.5974 64.9959 66.5967 65.0104 66.6029 65.0042C66.6036 65.0035 66.6043 64.989 66.5981 64.9952Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7335 64.9904C67.7273 64.9966 67.7417 64.9959 67.7424 64.9952C67.7486 64.989 67.7342 64.9897 67.7335 64.9904Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8575 64.9904C67.8513 64.9966 67.8658 64.9959 67.8665 64.9952C67.8727 64.989 67.8582 64.9897 67.8575 64.9904Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6304 65.0041C66.6242 65.0103 66.6387 65.0096 66.6394 65.0089C66.6456 65.0027 66.6311 65.0034 66.6304 65.0041Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6583 65.0041C66.6521 65.0103 66.6666 65.0096 66.6672 65.0089C66.6734 65.0027 66.659 65.0034 66.6583 65.0041Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7135 65.0179C66.7073 65.0241 66.7217 65.0234 66.7224 65.0227C66.7286 65.0165 66.7141 65.0172 66.7135 65.0179Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4854 65.0179C67.4792 65.0241 67.4937 65.0234 67.4944 65.0227C67.5006 65.0165 67.4861 65.0172 67.4854 65.0179Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5406 65.0179C67.5344 65.0241 67.5489 65.0234 67.5496 65.0227C67.5558 65.0165 67.5413 65.0172 67.5406 65.0179Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7823 65.0317C66.7761 65.0379 66.7906 65.0372 66.7913 65.0365C66.7975 65.0303 66.783 65.031 66.7823 65.0317Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8375 65.0317C66.8313 65.0379 66.8458 65.0372 66.8464 65.0365C66.8526 65.0303 66.8382 65.031 66.8375 65.0317Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9063 65.0317C66.9001 65.0379 66.9146 65.0372 66.9153 65.0365C66.9215 65.0303 66.907 65.031 66.9063 65.0317Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9478 65.0317C66.9416 65.0379 66.9561 65.0372 66.9568 65.0365C66.963 65.0303 66.9485 65.031 66.9478 65.0317Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.003 65.0317C66.9968 65.0379 67.0113 65.0372 67.012 65.0365C67.0182 65.0303 67.0037 65.031 67.003 65.0317Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0719 65.0317C67.0657 65.0379 67.0801 65.0372 67.0808 65.0365C67.087 65.0303 67.0725 65.031 67.0719 65.0317Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3477 65.0317C67.3415 65.0379 67.356 65.0372 67.3567 65.0365C67.3629 65.0303 67.3484 65.031 67.3477 65.0317Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4166 65.0317C67.4104 65.0379 67.4249 65.0372 67.4255 65.0365C67.4317 65.0303 67.4173 65.031 67.4166 65.0317Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1407 65.0455C67.1345 65.0517 67.149 65.051 67.1497 65.0503C67.1559 65.0441 67.1414 65.0448 67.1407 65.0455Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1959 65.0455C67.1897 65.0517 67.2042 65.051 67.2048 65.0503C67.211 65.0441 67.1966 65.0448 67.1959 65.0455Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3062 65.0455C67.3 65.0517 67.3145 65.051 67.3152 65.0503C67.3214 65.0441 67.3069 65.0448 67.3062 65.0455Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3614 65.0455C67.3552 65.0517 67.3697 65.051 67.3704 65.0503C67.3766 65.0441 67.3621 65.0448 67.3614 65.0455Z",
    fill: "#DAEBDA"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M34.543 74.6891C35.2799 74.6891 35.8177 74.8479 36.1562 75.1656C36.4948 75.4808 36.6641 75.9156 36.6641 76.4703C36.6641 76.7203 36.6263 76.9599 36.5508 77.1891C36.4753 77.4156 36.3516 77.6175 36.1797 77.7946C36.0104 77.9716 35.7839 78.1123 35.5 78.2164C35.2161 78.318 34.8659 78.3688 34.4492 78.3688H33.9297V80.4H32.7188V74.6891H34.543ZM34.4805 75.6813H33.9297V77.3766H34.3281C34.5547 77.3766 34.7513 77.3466 34.918 77.2867C35.0846 77.2268 35.2135 77.1331 35.3047 77.0055C35.3958 76.8779 35.4414 76.7138 35.4414 76.5133C35.4414 76.2321 35.3633 76.0237 35.207 75.8883C35.0508 75.7503 34.8086 75.6813 34.4805 75.6813ZM40.2653 80.4H39.0544V75.6969H37.5036V74.6891H41.8161V75.6969H40.2653V80.4ZM45.4408 75.6149C45.209 75.6149 45.0033 75.6604 44.8236 75.7516C44.6465 75.8401 44.4968 75.969 44.3744 76.1383C44.2546 76.3076 44.1634 76.512 44.1009 76.7516C44.0384 76.9912 44.0072 77.2607 44.0072 77.5602C44.0072 77.9638 44.0567 78.3089 44.1556 78.5953C44.2572 78.8792 44.4134 79.0966 44.6244 79.2477C44.8353 79.3961 45.1074 79.4703 45.4408 79.4703C45.6726 79.4703 45.9043 79.4443 46.1361 79.3922C46.3705 79.3401 46.6244 79.2659 46.8978 79.1696V80.1852C46.6452 80.2893 46.3965 80.3636 46.1517 80.4078C45.9069 80.4547 45.6322 80.4781 45.3275 80.4781C44.739 80.4781 44.2546 80.3571 43.8744 80.1149C43.4968 79.8701 43.2168 79.5289 43.0345 79.0914C42.8522 78.6513 42.7611 78.1383 42.7611 77.5524C42.7611 77.1201 42.8197 76.7242 42.9369 76.3649C43.0541 76.0055 43.2259 75.6943 43.4525 75.4313C43.6791 75.1683 43.959 74.9651 44.2923 74.8219C44.6257 74.6787 45.0085 74.6071 45.4408 74.6071C45.7246 74.6071 46.0085 74.6435 46.2923 74.7164C46.5788 74.7867 46.8522 74.8844 47.1127 75.0094L46.722 75.9938C46.5085 75.8922 46.2936 75.8037 46.0775 75.7281C45.8614 75.6526 45.6491 75.6149 45.4408 75.6149ZM48.4366 74.6891H49.5264V77.4469C49.5264 77.5823 49.5238 77.7321 49.5186 77.8961C49.516 78.0602 49.5108 78.2216 49.503 78.3805C49.4978 78.5367 49.4926 78.6735 49.4873 78.7906C49.4821 78.9078 49.4769 78.986 49.4717 79.025H49.4952L52.1319 74.6891H53.5811V80.4H52.503V77.6578C52.503 77.512 52.5056 77.3531 52.5108 77.1813C52.516 77.0094 52.5225 76.8427 52.5303 76.6813C52.5407 76.5198 52.5498 76.3805 52.5577 76.2633C52.5655 76.1435 52.5707 76.0641 52.5733 76.025H52.542L49.8936 80.4H48.4366V74.6891ZM57.7605 80.4L56.3855 75.9196H56.3503C56.3555 76.0263 56.3633 76.1878 56.3738 76.4039C56.3868 76.6175 56.3985 76.8453 56.4089 77.0875C56.4193 77.3297 56.4245 77.5485 56.4245 77.7438V80.4H55.3425V74.6891H56.9909L58.3425 79.0563H58.3659L59.7995 74.6891H61.448V80.4H60.3191V77.6969C60.3191 77.5172 60.3217 77.3102 60.3269 77.0758C60.3347 76.8414 60.3438 76.6188 60.3542 76.4078C60.3646 76.1943 60.3724 76.0341 60.3777 75.9274H60.3425L58.8698 80.4H57.7605ZM62.9477 79.8414C62.9477 79.5966 63.0141 79.4248 63.1469 79.3258C63.2823 79.2268 63.4451 79.1774 63.6352 79.1774C63.8201 79.1774 63.9789 79.2268 64.1117 79.3258C64.2471 79.4248 64.3148 79.5966 64.3148 79.8414C64.3148 80.0758 64.2471 80.2451 64.1117 80.3492C63.9789 80.4534 63.8201 80.5055 63.6352 80.5055C63.4451 80.5055 63.2823 80.4534 63.1469 80.3492C63.0141 80.2451 62.9477 80.0758 62.9477 79.8414ZM70.4669 80.4H69.0919L67.0216 77.5055V80.4H65.8106V74.6891H67.0216V77.4547L69.0684 74.6891H70.3575L68.2755 77.4313L70.4669 80.4ZM75.0017 80.4L74.5877 79.0406H72.5056L72.0916 80.4H70.7869L72.8025 74.6656H74.283L76.3064 80.4H75.0017ZM74.2986 78.025L73.8845 76.6969C73.8585 76.6084 73.8233 76.4951 73.7791 76.3571C73.7374 76.2164 73.6944 76.0745 73.6502 75.9313C73.6085 75.7854 73.5746 75.6591 73.5486 75.5524C73.5226 75.6591 73.4861 75.792 73.4392 75.9508C73.3949 76.1071 73.352 76.2555 73.3103 76.3961C73.2686 76.5367 73.2387 76.637 73.2205 76.6969L72.8103 78.025H74.2986ZM79.1733 74.6891C79.9103 74.6891 80.448 74.8479 80.7866 75.1656C81.1251 75.4808 81.2944 75.9156 81.2944 76.4703C81.2944 76.7203 81.2566 76.9599 81.1811 77.1891C81.1056 77.4156 80.9819 77.6175 80.81 77.7946C80.6407 77.9716 80.4142 78.1123 80.1303 78.2164C79.8465 78.318 79.4962 78.3688 79.0795 78.3688H78.56V80.4H77.3491V74.6891H79.1733ZM79.1108 75.6813H78.56V77.3766H78.9584C79.185 77.3766 79.3816 77.3466 79.5483 77.2867C79.7149 77.2268 79.8439 77.1331 79.935 77.0055C80.0261 76.8779 80.0717 76.7138 80.0717 76.5133C80.0717 76.2321 79.9936 76.0237 79.8373 75.8883C79.6811 75.7503 79.4389 75.6813 79.1108 75.6813ZM82.6925 80.4V74.6891H83.9034V76.8805H84.38C84.9165 76.8805 85.3566 76.9547 85.7003 77.1031C86.0467 77.2516 86.3019 77.4573 86.4659 77.7203C86.6326 77.9808 86.7159 78.2789 86.7159 78.6149C86.7159 79.18 86.5271 79.6188 86.1495 79.9313C85.7745 80.2438 85.1769 80.4 84.3566 80.4H82.6925ZM83.9034 79.4078H84.3097C84.6769 79.4078 84.9659 79.3492 85.1769 79.2321C85.3878 79.1123 85.4933 78.9065 85.4933 78.6149C85.4933 78.4117 85.4412 78.2568 85.337 78.15C85.2355 78.0433 85.0883 77.9703 84.8956 77.9313C84.7055 77.8922 84.4777 77.8727 84.212 77.8727H83.9034V79.4078ZM91.4109 80.4H88.1219V74.6891H91.4109V75.6813H89.3328V76.9352H91.2664V77.9274H89.3328V79.4H91.4109V80.4ZM94.7505 74.6891C95.4874 74.6891 96.0252 74.8479 96.3638 75.1656C96.7023 75.4808 96.8716 75.9156 96.8716 76.4703C96.8716 76.7203 96.8338 76.9599 96.7583 77.1891C96.6828 77.4156 96.5591 77.6175 96.3872 77.7946C96.2179 77.9716 95.9914 78.1123 95.7075 78.2164C95.4236 78.318 95.0734 78.3688 94.6567 78.3688H94.1372V80.4H92.9263V74.6891H94.7505ZM94.688 75.6813H94.1372V77.3766H94.5356C94.7622 77.3766 94.9588 77.3466 95.1255 77.2867C95.2921 77.2268 95.421 77.1331 95.5122 77.0055C95.6033 76.8779 95.6489 76.7138 95.6489 76.5133C95.6489 76.2321 95.5708 76.0237 95.4145 75.8883C95.2583 75.7503 95.0161 75.6813 94.688 75.6813ZM101.766 80.4L101.352 79.0406H99.2697L98.8556 80.4H97.5509L99.5666 74.6656H101.047L103.07 80.4H101.766ZM101.063 78.025L100.649 76.6969C100.623 76.6084 100.587 76.4951 100.543 76.3571C100.501 76.2164 100.458 76.0745 100.414 75.9313C100.373 75.7854 100.339 75.6591 100.313 75.5524C100.287 75.6591 100.25 75.792 100.203 75.9508C100.159 76.1071 100.116 76.2555 100.074 76.3961C100.033 76.5367 100.003 76.637 99.9845 76.6969L99.5744 78.025H101.063Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2266 180.258C40.2266 181.034 39.987 181.648 39.5078 182.102C39.0286 182.549 38.388 182.841 37.5859 182.977V183.031C38.5234 183.167 39.237 183.469 39.7266 183.938C40.2161 184.406 40.4609 185.021 40.4609 185.781C40.4609 186.453 40.2917 187.044 39.9531 187.555C39.6198 188.06 39.1172 188.453 38.4453 188.734C37.7734 189.016 36.9375 189.156 35.9375 189.156C35.3177 189.156 34.7266 189.107 34.1641 189.008C33.6016 188.914 33.0859 188.755 32.6172 188.531V187.305C32.9401 187.461 33.2891 187.596 33.6641 187.711C34.0391 187.826 34.4193 187.914 34.8047 187.977C35.1953 188.034 35.5677 188.062 35.9219 188.062C36.9531 188.062 37.7344 187.865 38.2656 187.469C38.8021 187.068 39.0703 186.505 39.0703 185.781C39.0703 185.036 38.7604 184.495 38.1406 184.156C37.526 183.812 36.6615 183.641 35.5469 183.641H33.9062V182.523H35.4922C36.2422 182.523 36.8646 182.438 37.3594 182.266C37.8542 182.089 38.224 181.841 38.4688 181.523C38.7188 181.201 38.8438 180.82 38.8438 180.383C38.8438 179.784 38.625 179.323 38.1875 179C37.7552 178.677 37.1901 178.516 36.4922 178.516C35.7682 178.516 35.1693 178.609 34.6953 178.797C34.2214 178.979 33.7604 179.216 33.3125 179.508L32.6719 178.602C32.974 178.383 33.3177 178.185 33.7031 178.008C34.0885 177.826 34.5156 177.682 34.9844 177.578C35.4531 177.469 35.9583 177.414 36.5 177.414C37.3073 177.414 37.987 177.536 38.5391 177.781C39.0911 178.021 39.5104 178.354 39.7969 178.781C40.0833 179.208 40.2266 179.701 40.2266 180.258ZM45.8984 180.297C46.9193 180.297 47.6771 180.526 48.1719 180.984C48.6667 181.443 48.9141 182.174 48.9141 183.18V189H47.9688L47.7188 187.734H47.6562C47.4167 188.047 47.1667 188.31 46.9062 188.523C46.6458 188.732 46.3438 188.891 46 189C45.6615 189.104 45.2448 189.156 44.75 189.156C44.2292 189.156 43.7656 189.065 43.3594 188.883C42.9583 188.701 42.6406 188.424 42.4062 188.055C42.1771 187.685 42.0625 187.216 42.0625 186.648C42.0625 185.794 42.401 185.138 43.0781 184.68C43.7552 184.221 44.7865 183.971 46.1719 183.93L47.6484 183.867V183.344C47.6484 182.604 47.4896 182.086 47.1719 181.789C46.8542 181.492 46.4062 181.344 45.8281 181.344C45.3802 181.344 44.9531 181.409 44.5469 181.539C44.1406 181.669 43.7552 181.823 43.3906 182L42.9922 181.016C43.3776 180.818 43.8203 180.648 44.3203 180.508C44.8203 180.367 45.3464 180.297 45.8984 180.297ZM47.6328 184.781L46.3281 184.836C45.2604 184.878 44.5078 185.052 44.0703 185.359C43.6328 185.667 43.4141 186.102 43.4141 186.664C43.4141 187.154 43.5625 187.516 43.8594 187.75C44.1562 187.984 44.5495 188.102 45.0391 188.102C45.7995 188.102 46.4219 187.891 46.9062 187.469C47.3906 187.047 47.6328 186.414 47.6328 185.57V184.781ZM58.7578 180.438V189H57.4531V181.555H52.8906V189H51.5859V180.438H58.7578ZM68.8906 184.703C68.8906 185.406 68.7995 186.034 68.6172 186.586C68.4349 187.138 68.1719 187.604 67.8281 187.984C67.4844 188.365 67.0677 188.656 66.5781 188.859C66.0938 189.057 65.5443 189.156 64.9297 189.156C64.3568 189.156 63.8307 189.057 63.3516 188.859C62.8776 188.656 62.4661 188.365 62.1172 187.984C61.7734 187.604 61.5052 187.138 61.3125 186.586C61.125 186.034 61.0312 185.406 61.0312 184.703C61.0312 183.766 61.1901 182.969 61.5078 182.312C61.8255 181.651 62.2786 181.148 62.8672 180.805C63.4609 180.456 64.1667 180.281 64.9844 180.281C65.7656 180.281 66.4479 180.456 67.0312 180.805C67.6198 181.154 68.0755 181.659 68.3984 182.32C68.7266 182.977 68.8906 183.771 68.8906 184.703ZM62.375 184.703C62.375 185.391 62.4661 185.987 62.6484 186.492C62.8307 186.997 63.112 187.388 63.4922 187.664C63.8724 187.94 64.362 188.078 64.9609 188.078C65.5547 188.078 66.0417 187.94 66.4219 187.664C66.8073 187.388 67.0911 186.997 67.2734 186.492C67.4557 185.987 67.5469 185.391 67.5469 184.703C67.5469 184.021 67.4557 183.432 67.2734 182.938C67.0911 182.438 66.8099 182.052 66.4297 181.781C66.0495 181.51 65.5573 181.375 64.9531 181.375C64.0625 181.375 63.4089 181.669 62.9922 182.258C62.5807 182.846 62.375 183.661 62.375 184.703ZM77.5547 189H76.2344V181.523H73.6328C73.5286 182.872 73.3958 184.029 73.2344 184.992C73.0781 185.951 72.8802 186.734 72.6406 187.344C72.4062 187.948 72.1198 188.393 71.7812 188.68C71.4479 188.961 71.0495 189.102 70.5859 189.102C70.4453 189.102 70.3125 189.094 70.1875 189.078C70.0625 189.062 69.9557 189.036 69.8672 189V188.016C69.9349 188.036 70.0052 188.052 70.0781 188.062C70.1562 188.073 70.237 188.078 70.3203 188.078C70.5547 188.078 70.7682 187.982 70.9609 187.789C71.1589 187.591 71.3359 187.294 71.4922 186.898C71.6536 186.503 71.7969 186.003 71.9219 185.398C72.0469 184.789 72.1562 184.073 72.25 183.25C72.349 182.422 72.4349 181.484 72.5078 180.438H77.5547V189ZM81.5938 180.438V184.031H86.3672V180.438H87.6641V189H86.3672V185.133H81.5938V189H80.2891V180.438H81.5938ZM91.6484 180.438V185.82C91.6484 185.924 91.6458 186.06 91.6406 186.227C91.6354 186.388 91.6276 186.562 91.6172 186.75C91.6068 186.932 91.5964 187.109 91.5859 187.281C91.5807 187.448 91.5729 187.586 91.5625 187.695L96.2344 180.438H97.8281V189H96.6172V183.75C96.6172 183.583 96.6198 183.37 96.625 183.109C96.6302 182.849 96.638 182.594 96.6484 182.344C96.6589 182.089 96.6667 181.891 96.6719 181.75L92.0156 189H90.4141V180.438H91.6484ZM106.422 181.539H103.602V189H102.32V181.539H99.5391V180.438H106.422V181.539ZM111.414 180.281C112.143 180.281 112.768 180.443 113.289 180.766C113.81 181.089 114.208 181.542 114.484 182.125C114.76 182.703 114.898 183.38 114.898 184.156V184.961H108.984C109 185.966 109.25 186.732 109.734 187.258C110.219 187.784 110.901 188.047 111.781 188.047C112.323 188.047 112.802 187.997 113.219 187.898C113.635 187.799 114.068 187.654 114.516 187.461V188.602C114.083 188.794 113.654 188.935 113.227 189.023C112.805 189.112 112.305 189.156 111.727 189.156C110.904 189.156 110.185 188.99 109.57 188.656C108.961 188.318 108.487 187.823 108.148 187.172C107.81 186.521 107.641 185.724 107.641 184.781C107.641 183.859 107.794 183.062 108.102 182.391C108.414 181.714 108.852 181.193 109.414 180.828C109.982 180.464 110.648 180.281 111.414 180.281ZM111.398 181.344C110.706 181.344 110.154 181.57 109.742 182.023C109.331 182.477 109.086 183.109 109.008 183.922H113.539C113.534 183.411 113.453 182.964 113.297 182.578C113.146 182.188 112.914 181.885 112.602 181.672C112.289 181.453 111.888 181.344 111.398 181.344ZM122.492 180.438V185.82C122.492 185.924 122.49 186.06 122.484 186.227C122.479 186.388 122.471 186.562 122.461 186.75C122.451 186.932 122.44 187.109 122.43 187.281C122.424 187.448 122.417 187.586 122.406 187.695L127.078 180.438H128.672V189H127.461V183.75C127.461 183.583 127.464 183.37 127.469 183.109C127.474 182.849 127.482 182.594 127.492 182.344C127.503 182.089 127.51 181.891 127.516 181.75L122.859 189H121.258V180.438H122.492ZM132.734 180.438V184.031H137.508V180.438H138.805V189H137.508V185.133H132.734V189H131.43V180.438H132.734ZM146.531 176.844V180.312C147.38 180.385 148.12 180.607 148.75 180.977C149.38 181.341 149.87 181.839 150.219 182.469C150.568 183.099 150.742 183.849 150.742 184.719C150.742 185.573 150.573 186.318 150.234 186.953C149.901 187.589 149.419 188.091 148.789 188.461C148.164 188.831 147.411 189.052 146.531 189.125V192.844H145.266V189.125C144.417 189.062 143.677 188.849 143.047 188.484C142.422 188.115 141.935 187.612 141.586 186.977C141.237 186.341 141.062 185.589 141.062 184.719C141.062 183.849 141.229 183.099 141.562 182.469C141.901 181.833 142.385 181.333 143.016 180.969C143.646 180.599 144.409 180.38 145.305 180.312V176.844H146.531ZM145.305 181.391C144.643 181.448 144.099 181.615 143.672 181.891C143.245 182.167 142.927 182.542 142.719 183.016C142.516 183.49 142.414 184.057 142.414 184.719C142.414 185.38 142.518 185.951 142.727 186.43C142.935 186.904 143.253 187.279 143.68 187.555C144.107 187.831 144.648 188 145.305 188.062V181.391ZM146.531 181.406V188.062C147.188 187.995 147.727 187.82 148.148 187.539C148.576 187.258 148.891 186.88 149.094 186.406C149.302 185.932 149.406 185.37 149.406 184.719C149.406 183.729 149.169 182.956 148.695 182.398C148.221 181.836 147.5 181.505 146.531 181.406ZM160.391 184.703C160.391 185.406 160.299 186.034 160.117 186.586C159.935 187.138 159.672 187.604 159.328 187.984C158.984 188.365 158.568 188.656 158.078 188.859C157.594 189.057 157.044 189.156 156.43 189.156C155.857 189.156 155.331 189.057 154.852 188.859C154.378 188.656 153.966 188.365 153.617 187.984C153.273 187.604 153.005 187.138 152.812 186.586C152.625 186.034 152.531 185.406 152.531 184.703C152.531 183.766 152.69 182.969 153.008 182.312C153.326 181.651 153.779 181.148 154.367 180.805C154.961 180.456 155.667 180.281 156.484 180.281C157.266 180.281 157.948 180.456 158.531 180.805C159.12 181.154 159.576 181.659 159.898 182.32C160.227 182.977 160.391 183.771 160.391 184.703ZM153.875 184.703C153.875 185.391 153.966 185.987 154.148 186.492C154.331 186.997 154.612 187.388 154.992 187.664C155.372 187.94 155.862 188.078 156.461 188.078C157.055 188.078 157.542 187.94 157.922 187.664C158.307 187.388 158.591 186.997 158.773 186.492C158.956 185.987 159.047 185.391 159.047 184.703C159.047 184.021 158.956 183.432 158.773 182.938C158.591 182.438 158.31 182.052 157.93 181.781C157.549 181.51 157.057 181.375 156.453 181.375C155.562 181.375 154.909 181.669 154.492 182.258C154.081 182.846 153.875 183.661 153.875 184.703ZM166.656 180.281C167.724 180.281 168.576 180.648 169.211 181.383C169.846 182.117 170.164 183.221 170.164 184.695C170.164 185.669 170.018 186.487 169.727 187.148C169.435 187.81 169.023 188.31 168.492 188.648C167.966 188.987 167.344 189.156 166.625 189.156C166.172 189.156 165.773 189.096 165.43 188.977C165.086 188.857 164.792 188.695 164.547 188.492C164.302 188.289 164.099 188.068 163.938 187.828H163.844C163.859 188.031 163.878 188.276 163.898 188.562C163.924 188.849 163.938 189.099 163.938 189.312V192.828H162.633V180.438H163.703L163.875 181.703H163.938C164.104 181.443 164.307 181.206 164.547 180.992C164.786 180.773 165.078 180.602 165.422 180.477C165.771 180.346 166.182 180.281 166.656 180.281ZM166.43 181.375C165.836 181.375 165.357 181.49 164.992 181.719C164.633 181.948 164.37 182.292 164.203 182.75C164.036 183.203 163.948 183.773 163.938 184.461V184.711C163.938 185.435 164.016 186.047 164.172 186.547C164.333 187.047 164.596 187.427 164.961 187.688C165.331 187.948 165.826 188.078 166.445 188.078C166.977 188.078 167.419 187.935 167.773 187.648C168.128 187.362 168.391 186.964 168.562 186.453C168.74 185.938 168.828 185.346 168.828 184.68C168.828 183.669 168.63 182.867 168.234 182.273C167.844 181.674 167.242 181.375 166.43 181.375ZM181.469 180.438V189H180.297V183.422C180.297 183.193 180.302 182.961 180.312 182.727C180.328 182.487 180.346 182.247 180.367 182.008H180.32L177.477 189H176.375L173.602 182.008H173.555C173.57 182.247 173.581 182.487 173.586 182.727C173.596 182.961 173.602 183.208 173.602 183.469V189H172.422V180.438H174.164L176.93 187.438L179.734 180.438H181.469ZM187.367 180.297C188.388 180.297 189.146 180.526 189.641 180.984C190.135 181.443 190.383 182.174 190.383 183.18V189H189.438L189.188 187.734H189.125C188.885 188.047 188.635 188.31 188.375 188.523C188.115 188.732 187.812 188.891 187.469 189C187.13 189.104 186.714 189.156 186.219 189.156C185.698 189.156 185.234 189.065 184.828 188.883C184.427 188.701 184.109 188.424 183.875 188.055C183.646 187.685 183.531 187.216 183.531 186.648C183.531 185.794 183.87 185.138 184.547 184.68C185.224 184.221 186.255 183.971 187.641 183.93L189.117 183.867V183.344C189.117 182.604 188.958 182.086 188.641 181.789C188.323 181.492 187.875 181.344 187.297 181.344C186.849 181.344 186.422 181.409 186.016 181.539C185.609 181.669 185.224 181.823 184.859 182L184.461 181.016C184.846 180.818 185.289 180.648 185.789 180.508C186.289 180.367 186.815 180.297 187.367 180.297ZM189.102 184.781L187.797 184.836C186.729 184.878 185.977 185.052 185.539 185.359C185.102 185.667 184.883 186.102 184.883 186.664C184.883 187.154 185.031 187.516 185.328 187.75C185.625 187.984 186.018 188.102 186.508 188.102C187.268 188.102 187.891 187.891 188.375 187.469C188.859 187.047 189.102 186.414 189.102 185.57V184.781ZM201.391 191.961H200.125V189H193.055V180.438H194.359V187.898H198.898V180.438H200.195V187.914H201.391V191.961ZM204.305 180.438V185.82C204.305 185.924 204.302 186.06 204.297 186.227C204.292 186.388 204.284 186.562 204.273 186.75C204.263 186.932 204.253 187.109 204.242 187.281C204.237 187.448 204.229 187.586 204.219 187.695L208.891 180.438H210.484V189H209.273V183.75C209.273 183.583 209.276 183.37 209.281 183.109C209.286 182.849 209.294 182.594 209.305 182.344C209.315 182.089 209.323 181.891 209.328 181.75L204.672 189H203.07V180.438H204.305ZM224.25 184.703C224.25 185.635 224.099 186.435 223.797 187.102C223.5 187.768 223.073 188.279 222.516 188.633C221.958 188.982 221.292 189.156 220.516 189.156C219.792 189.156 219.159 189 218.617 188.688C218.081 188.375 217.656 187.919 217.344 187.32C217.036 186.721 216.859 185.992 216.812 185.133H214.539V189H213.242V180.438H214.539V184.031H216.828C216.901 183.24 217.094 182.565 217.406 182.008C217.719 181.451 218.141 181.023 218.672 180.727C219.203 180.43 219.828 180.281 220.547 180.281C221.297 180.281 221.948 180.458 222.5 180.812C223.057 181.161 223.487 181.667 223.789 182.328C224.096 182.984 224.25 183.776 224.25 184.703ZM218.141 184.703C218.141 185.422 218.221 186.034 218.383 186.539C218.549 187.039 218.807 187.422 219.156 187.688C219.51 187.948 219.969 188.078 220.531 188.078C221.089 188.078 221.542 187.948 221.891 187.688C222.245 187.427 222.503 187.047 222.664 186.547C222.831 186.042 222.914 185.427 222.914 184.703C222.914 183.99 222.831 183.385 222.664 182.891C222.497 182.396 222.24 182.021 221.891 181.766C221.542 181.505 221.089 181.375 220.531 181.375C219.974 181.375 219.518 181.505 219.164 181.766C218.815 182.021 218.557 182.396 218.391 182.891C218.224 183.385 218.141 183.99 218.141 184.703ZM238.047 184.703C238.047 185.406 237.956 186.034 237.773 186.586C237.591 187.138 237.328 187.604 236.984 187.984C236.641 188.365 236.224 188.656 235.734 188.859C235.25 189.057 234.701 189.156 234.086 189.156C233.513 189.156 232.987 189.057 232.508 188.859C232.034 188.656 231.622 188.365 231.273 187.984C230.93 187.604 230.661 187.138 230.469 186.586C230.281 186.034 230.188 185.406 230.188 184.703C230.188 183.766 230.346 182.969 230.664 182.312C230.982 181.651 231.435 181.148 232.023 180.805C232.617 180.456 233.323 180.281 234.141 180.281C234.922 180.281 235.604 180.456 236.188 180.805C236.776 181.154 237.232 181.659 237.555 182.32C237.883 182.977 238.047 183.771 238.047 184.703ZM231.531 184.703C231.531 185.391 231.622 185.987 231.805 186.492C231.987 186.997 232.268 187.388 232.648 187.664C233.029 187.94 233.518 188.078 234.117 188.078C234.711 188.078 235.198 187.94 235.578 187.664C235.964 187.388 236.247 186.997 236.43 186.492C236.612 185.987 236.703 185.391 236.703 184.703C236.703 184.021 236.612 183.432 236.43 182.938C236.247 182.438 235.966 182.052 235.586 181.781C235.206 181.51 234.714 181.375 234.109 181.375C233.219 181.375 232.565 181.669 232.148 182.258C231.737 182.846 231.531 183.661 231.531 184.703ZM247.875 189.156C247.104 189.156 246.424 188.997 245.836 188.68C245.247 188.362 244.789 187.878 244.461 187.227C244.133 186.576 243.969 185.755 243.969 184.766C243.969 183.729 244.141 182.883 244.484 182.227C244.833 181.565 245.312 181.076 245.922 180.758C246.531 180.44 247.224 180.281 248 180.281C248.427 180.281 248.839 180.326 249.234 180.414C249.635 180.497 249.964 180.604 250.219 180.734L249.828 181.82C249.568 181.716 249.266 181.622 248.922 181.539C248.583 181.456 248.266 181.414 247.969 181.414C247.375 181.414 246.88 181.542 246.484 181.797C246.094 182.052 245.799 182.427 245.602 182.922C245.409 183.417 245.312 184.026 245.312 184.75C245.312 185.443 245.406 186.034 245.594 186.523C245.786 187.013 246.07 187.388 246.445 187.648C246.826 187.904 247.299 188.031 247.867 188.031C248.32 188.031 248.729 187.984 249.094 187.891C249.458 187.792 249.789 187.677 250.086 187.547V188.703C249.799 188.849 249.479 188.961 249.125 189.039C248.776 189.117 248.359 189.156 247.875 189.156ZM255.414 180.281C256.143 180.281 256.768 180.443 257.289 180.766C257.81 181.089 258.208 181.542 258.484 182.125C258.76 182.703 258.898 183.38 258.898 184.156V184.961H252.984C253 185.966 253.25 186.732 253.734 187.258C254.219 187.784 254.901 188.047 255.781 188.047C256.323 188.047 256.802 187.997 257.219 187.898C257.635 187.799 258.068 187.654 258.516 187.461V188.602C258.083 188.794 257.654 188.935 257.227 189.023C256.805 189.112 256.305 189.156 255.727 189.156C254.904 189.156 254.185 188.99 253.57 188.656C252.961 188.318 252.487 187.823 252.148 187.172C251.81 186.521 251.641 185.724 251.641 184.781C251.641 183.859 251.794 183.062 252.102 182.391C252.414 181.714 252.852 181.193 253.414 180.828C253.982 180.464 254.648 180.281 255.414 180.281ZM255.398 181.344C254.706 181.344 254.154 181.57 253.742 182.023C253.331 182.477 253.086 183.109 253.008 183.922H257.539C257.534 183.411 257.453 182.964 257.297 182.578C257.146 182.188 256.914 181.885 256.602 181.672C256.289 181.453 255.888 181.344 255.398 181.344ZM260.656 183.859C260.656 182.641 260.773 181.602 261.008 180.742C261.242 179.878 261.604 179.185 262.094 178.664C262.589 178.138 263.224 177.779 264 177.586C264.667 177.404 265.344 177.247 266.031 177.117C266.719 176.982 267.388 176.865 268.039 176.766L268.266 177.906C267.938 177.953 267.594 178.008 267.234 178.07C266.875 178.128 266.516 178.19 266.156 178.258C265.797 178.32 265.458 178.388 265.141 178.461C264.823 178.529 264.542 178.599 264.297 178.672C263.854 178.792 263.471 179 263.148 179.297C262.831 179.594 262.578 180.003 262.391 180.523C262.208 181.044 262.099 181.701 262.062 182.492H262.156C262.312 182.263 262.526 182.036 262.797 181.812C263.068 181.589 263.391 181.404 263.766 181.258C264.141 181.107 264.562 181.031 265.031 181.031C265.771 181.031 266.388 181.193 266.883 181.516C267.378 181.833 267.75 182.281 268 182.859C268.25 183.438 268.375 184.115 268.375 184.891C268.375 185.823 268.214 186.607 267.891 187.242C267.573 187.878 267.125 188.357 266.547 188.68C265.969 188.997 265.289 189.156 264.508 189.156C263.904 189.156 263.362 189.039 262.883 188.805C262.409 188.57 262.005 188.227 261.672 187.773C261.344 187.32 261.091 186.766 260.914 186.109C260.742 185.453 260.656 184.703 260.656 183.859ZM264.609 188.078C265.104 188.078 265.529 187.974 265.883 187.766C266.242 187.557 266.518 187.229 266.711 186.781C266.909 186.328 267.008 185.74 267.008 185.016C267.008 184.109 266.833 183.401 266.484 182.891C266.141 182.375 265.589 182.117 264.828 182.117C264.354 182.117 263.924 182.219 263.539 182.422C263.154 182.62 262.828 182.857 262.562 183.133C262.297 183.409 262.104 183.656 261.984 183.875C261.984 184.406 262.023 184.922 262.102 185.422C262.18 185.922 262.315 186.372 262.508 186.773C262.701 187.174 262.966 187.492 263.305 187.727C263.648 187.961 264.083 188.078 264.609 188.078ZM273.914 180.281C274.643 180.281 275.268 180.443 275.789 180.766C276.31 181.089 276.708 181.542 276.984 182.125C277.26 182.703 277.398 183.38 277.398 184.156V184.961H271.484C271.5 185.966 271.75 186.732 272.234 187.258C272.719 187.784 273.401 188.047 274.281 188.047C274.823 188.047 275.302 187.997 275.719 187.898C276.135 187.799 276.568 187.654 277.016 187.461V188.602C276.583 188.794 276.154 188.935 275.727 189.023C275.305 189.112 274.805 189.156 274.227 189.156C273.404 189.156 272.685 188.99 272.07 188.656C271.461 188.318 270.987 187.823 270.648 187.172C270.31 186.521 270.141 185.724 270.141 184.781C270.141 183.859 270.294 183.062 270.602 182.391C270.914 181.714 271.352 181.193 271.914 180.828C272.482 180.464 273.148 180.281 273.914 180.281ZM273.898 181.344C273.206 181.344 272.654 181.57 272.242 182.023C271.831 182.477 271.586 183.109 271.508 183.922H276.039C276.034 183.411 275.953 182.964 275.797 182.578C275.646 182.188 275.414 181.885 275.102 181.672C274.789 181.453 274.388 181.344 273.898 181.344ZM284.992 180.438V185.82C284.992 185.924 284.99 186.06 284.984 186.227C284.979 186.388 284.971 186.562 284.961 186.75C284.951 186.932 284.94 187.109 284.93 187.281C284.924 187.448 284.917 187.586 284.906 187.695L289.578 180.438H291.172V189H289.961V183.75C289.961 183.583 289.964 183.37 289.969 183.109C289.974 182.849 289.982 182.594 289.992 182.344C290.003 182.089 290.01 181.891 290.016 181.75L285.359 189H283.758V180.438H284.992ZM303.078 180.438H304.508L300.812 184.57L304.805 189H303.281L299.391 184.656V189H298.086V180.438H299.391V184.594L303.078 180.438ZM313.734 184.703C313.734 185.406 313.643 186.034 313.461 186.586C313.279 187.138 313.016 187.604 312.672 187.984C312.328 188.365 311.911 188.656 311.422 188.859C310.938 189.057 310.388 189.156 309.773 189.156C309.201 189.156 308.674 189.057 308.195 188.859C307.721 188.656 307.31 188.365 306.961 187.984C306.617 187.604 306.349 187.138 306.156 186.586C305.969 186.034 305.875 185.406 305.875 184.703C305.875 183.766 306.034 182.969 306.352 182.312C306.669 181.651 307.122 181.148 307.711 180.805C308.305 180.456 309.01 180.281 309.828 180.281C310.609 180.281 311.292 180.456 311.875 180.805C312.464 181.154 312.919 181.659 313.242 182.32C313.57 182.977 313.734 183.771 313.734 184.703ZM307.219 184.703C307.219 185.391 307.31 185.987 307.492 186.492C307.674 186.997 307.956 187.388 308.336 187.664C308.716 187.94 309.206 188.078 309.805 188.078C310.398 188.078 310.885 187.94 311.266 187.664C311.651 187.388 311.935 186.997 312.117 186.492C312.299 185.987 312.391 185.391 312.391 184.703C312.391 184.021 312.299 183.432 312.117 182.938C311.935 182.438 311.654 182.052 311.273 181.781C310.893 181.51 310.401 181.375 309.797 181.375C308.906 181.375 308.253 181.669 307.836 182.258C307.424 182.846 307.219 183.661 307.219 184.703ZM325.016 180.438V189H323.844V183.422C323.844 183.193 323.849 182.961 323.859 182.727C323.875 182.487 323.893 182.247 323.914 182.008H323.867L321.023 189H319.922L317.148 182.008H317.102C317.117 182.247 317.128 182.487 317.133 182.727C317.143 182.961 317.148 183.208 317.148 183.469V189H315.969V180.438H317.711L320.477 187.438L323.281 180.438H325.016ZM334.883 180.438V189H333.578V181.555H329.016V189H327.711V180.438H334.883ZM340.836 180.297C341.857 180.297 342.615 180.526 343.109 180.984C343.604 181.443 343.852 182.174 343.852 183.18V189H342.906L342.656 187.734H342.594C342.354 188.047 342.104 188.31 341.844 188.523C341.583 188.732 341.281 188.891 340.938 189C340.599 189.104 340.182 189.156 339.688 189.156C339.167 189.156 338.703 189.065 338.297 188.883C337.896 188.701 337.578 188.424 337.344 188.055C337.115 187.685 337 187.216 337 186.648C337 185.794 337.339 185.138 338.016 184.68C338.693 184.221 339.724 183.971 341.109 183.93L342.586 183.867V183.344C342.586 182.604 342.427 182.086 342.109 181.789C341.792 181.492 341.344 181.344 340.766 181.344C340.318 181.344 339.891 181.409 339.484 181.539C339.078 181.669 338.693 181.823 338.328 182L337.93 181.016C338.315 180.818 338.758 180.648 339.258 180.508C339.758 180.367 340.284 180.297 340.836 180.297ZM342.57 184.781L341.266 184.836C340.198 184.878 339.445 185.052 339.008 185.359C338.57 185.667 338.352 186.102 338.352 186.664C338.352 187.154 338.5 187.516 338.797 187.75C339.094 187.984 339.487 188.102 339.977 188.102C340.737 188.102 341.359 187.891 341.844 187.469C342.328 187.047 342.57 186.414 342.57 185.57V184.781ZM347.828 180.438V184.031H352.602V180.438H353.898V189H352.602V185.133H347.828V189H346.523V180.438H347.828ZM357.883 180.438V185.82C357.883 185.924 357.88 186.06 357.875 186.227C357.87 186.388 357.862 186.562 357.852 186.75C357.841 186.932 357.831 187.109 357.82 187.281C357.815 187.448 357.807 187.586 357.797 187.695L362.469 180.438H364.062V189H362.852V183.75C362.852 183.583 362.854 183.37 362.859 183.109C362.865 182.849 362.872 182.594 362.883 182.344C362.893 182.089 362.901 181.891 362.906 181.75L358.25 189H356.648V180.438H357.883ZM368.055 180.438V185.82C368.055 185.924 368.052 186.06 368.047 186.227C368.042 186.388 368.034 186.562 368.023 186.75C368.013 186.932 368.003 187.109 367.992 187.281C367.987 187.448 367.979 187.586 367.969 187.695L372.641 180.438H374.234V189H373.023V183.75C373.023 183.583 373.026 183.37 373.031 183.109C373.036 182.849 373.044 182.594 373.055 182.344C373.065 182.089 373.073 181.891 373.078 181.75L368.422 189H366.82V180.438H368.055ZM378.477 187.141L378.578 187.32C378.484 187.701 378.365 188.107 378.219 188.539C378.078 188.971 377.922 189.404 377.75 189.836C377.583 190.273 377.414 190.682 377.242 191.062H376.273C376.383 190.646 376.49 190.206 376.594 189.742C376.698 189.284 376.792 188.831 376.875 188.383C376.964 187.93 377.034 187.516 377.086 187.141H378.477ZM386.422 180.438V183.516C386.422 184.052 386.568 184.448 386.859 184.703C387.156 184.958 387.586 185.086 388.148 185.086C388.69 185.086 389.182 185.003 389.625 184.836C390.068 184.669 390.516 184.443 390.969 184.156V180.438H392.266V189H390.969V185.164C390.49 185.471 390.018 185.714 389.555 185.891C389.091 186.068 388.536 186.156 387.891 186.156C387.01 186.156 386.328 185.927 385.844 185.469C385.365 185.01 385.125 184.391 385.125 183.609V180.438H386.422ZM400.844 181.539H398.023V189H396.742V181.539H393.961V180.438H400.844V181.539ZM409.922 184.703C409.922 185.406 409.831 186.034 409.648 186.586C409.466 187.138 409.203 187.604 408.859 187.984C408.516 188.365 408.099 188.656 407.609 188.859C407.125 189.057 406.576 189.156 405.961 189.156C405.388 189.156 404.862 189.057 404.383 188.859C403.909 188.656 403.497 188.365 403.148 187.984C402.805 187.604 402.536 187.138 402.344 186.586C402.156 186.034 402.062 185.406 402.062 184.703C402.062 183.766 402.221 182.969 402.539 182.312C402.857 181.651 403.31 181.148 403.898 180.805C404.492 180.456 405.198 180.281 406.016 180.281C406.797 180.281 407.479 180.456 408.062 180.805C408.651 181.154 409.107 181.659 409.43 182.32C409.758 182.977 409.922 183.771 409.922 184.703ZM403.406 184.703C403.406 185.391 403.497 185.987 403.68 186.492C403.862 186.997 404.143 187.388 404.523 187.664C404.904 187.94 405.393 188.078 405.992 188.078C406.586 188.078 407.073 187.94 407.453 187.664C407.839 187.388 408.122 186.997 408.305 186.492C408.487 185.987 408.578 185.391 408.578 184.703C408.578 184.021 408.487 183.432 408.305 182.938C408.122 182.438 407.841 182.052 407.461 181.781C407.081 181.51 406.589 181.375 405.984 181.375C405.094 181.375 404.44 181.669 404.023 182.258C403.612 182.846 403.406 183.661 403.406 184.703ZM411.719 183.859C411.719 182.641 411.836 181.602 412.07 180.742C412.305 179.878 412.667 179.185 413.156 178.664C413.651 178.138 414.286 177.779 415.062 177.586C415.729 177.404 416.406 177.247 417.094 177.117C417.781 176.982 418.451 176.865 419.102 176.766L419.328 177.906C419 177.953 418.656 178.008 418.297 178.07C417.938 178.128 417.578 178.19 417.219 178.258C416.859 178.32 416.521 178.388 416.203 178.461C415.885 178.529 415.604 178.599 415.359 178.672C414.917 178.792 414.534 179 414.211 179.297C413.893 179.594 413.641 180.003 413.453 180.523C413.271 181.044 413.161 181.701 413.125 182.492H413.219C413.375 182.263 413.589 182.036 413.859 181.812C414.13 181.589 414.453 181.404 414.828 181.258C415.203 181.107 415.625 181.031 416.094 181.031C416.833 181.031 417.451 181.193 417.945 181.516C418.44 181.833 418.812 182.281 419.062 182.859C419.312 183.438 419.438 184.115 419.438 184.891C419.438 185.823 419.276 186.607 418.953 187.242C418.635 187.878 418.188 188.357 417.609 188.68C417.031 188.997 416.352 189.156 415.57 189.156C414.966 189.156 414.424 189.039 413.945 188.805C413.471 188.57 413.068 188.227 412.734 187.773C412.406 187.32 412.154 186.766 411.977 186.109C411.805 185.453 411.719 184.703 411.719 183.859ZM415.672 188.078C416.167 188.078 416.591 187.974 416.945 187.766C417.305 187.557 417.581 187.229 417.773 186.781C417.971 186.328 418.07 185.74 418.07 185.016C418.07 184.109 417.896 183.401 417.547 182.891C417.203 182.375 416.651 182.117 415.891 182.117C415.417 182.117 414.987 182.219 414.602 182.422C414.216 182.62 413.891 182.857 413.625 183.133C413.359 183.409 413.167 183.656 413.047 183.875C413.047 184.406 413.086 184.922 413.164 185.422C413.242 185.922 413.378 186.372 413.57 186.773C413.763 187.174 414.029 187.492 414.367 187.727C414.711 187.961 415.146 188.078 415.672 188.078ZM421.68 189V180.438H422.984V183.969H425.328C426.057 183.969 426.656 184.06 427.125 184.242C427.599 184.424 427.951 184.695 428.18 185.055C428.409 185.414 428.523 185.859 428.523 186.391C428.523 186.922 428.409 187.383 428.18 187.773C427.956 188.164 427.602 188.466 427.117 188.68C426.638 188.893 426.013 189 425.242 189H421.68ZM422.984 187.945H425.117C425.763 187.945 426.279 187.831 426.664 187.602C427.049 187.372 427.242 186.99 427.242 186.453C427.242 185.927 427.062 185.562 426.703 185.359C426.344 185.151 425.828 185.047 425.156 185.047H422.984V187.945ZM429.938 189V180.438H431.234V189H429.938ZM445.305 180.438V189H444V181.555H439.438V189H438.133V180.438H445.305ZM452.078 180.281C453.146 180.281 453.997 180.648 454.633 181.383C455.268 182.117 455.586 183.221 455.586 184.695C455.586 185.669 455.44 186.487 455.148 187.148C454.857 187.81 454.445 188.31 453.914 188.648C453.388 188.987 452.766 189.156 452.047 189.156C451.594 189.156 451.195 189.096 450.852 188.977C450.508 188.857 450.214 188.695 449.969 188.492C449.724 188.289 449.521 188.068 449.359 187.828H449.266C449.281 188.031 449.299 188.276 449.32 188.562C449.346 188.849 449.359 189.099 449.359 189.312V192.828H448.055V180.438H449.125L449.297 181.703H449.359C449.526 181.443 449.729 181.206 449.969 180.992C450.208 180.773 450.5 180.602 450.844 180.477C451.193 180.346 451.604 180.281 452.078 180.281ZM451.852 181.375C451.258 181.375 450.779 181.49 450.414 181.719C450.055 181.948 449.792 182.292 449.625 182.75C449.458 183.203 449.37 183.773 449.359 184.461V184.711C449.359 185.435 449.438 186.047 449.594 186.547C449.755 187.047 450.018 187.427 450.383 187.688C450.753 187.948 451.247 188.078 451.867 188.078C452.398 188.078 452.841 187.935 453.195 187.648C453.549 187.362 453.812 186.964 453.984 186.453C454.161 185.938 454.25 185.346 454.25 184.68C454.25 183.669 454.052 182.867 453.656 182.273C453.266 181.674 452.664 181.375 451.852 181.375ZM459.086 180.438V185.82C459.086 185.924 459.083 186.06 459.078 186.227C459.073 186.388 459.065 186.562 459.055 186.75C459.044 186.932 459.034 187.109 459.023 187.281C459.018 187.448 459.01 187.586 459 187.695L463.672 180.438H465.266V189H464.055V183.75C464.055 183.583 464.057 183.37 464.062 183.109C464.068 182.849 464.076 182.594 464.086 182.344C464.096 182.089 464.104 181.891 464.109 181.75L459.453 189H457.852V180.438H459.086ZM471.453 189.156C470.682 189.156 470.003 188.997 469.414 188.68C468.826 188.362 468.367 187.878 468.039 187.227C467.711 186.576 467.547 185.755 467.547 184.766C467.547 183.729 467.719 182.883 468.062 182.227C468.411 181.565 468.891 181.076 469.5 180.758C470.109 180.44 470.802 180.281 471.578 180.281C472.005 180.281 472.417 180.326 472.812 180.414C473.214 180.497 473.542 180.604 473.797 180.734L473.406 181.82C473.146 181.716 472.844 181.622 472.5 181.539C472.161 181.456 471.844 181.414 471.547 181.414C470.953 181.414 470.458 181.542 470.062 181.797C469.672 182.052 469.378 182.427 469.18 182.922C468.987 183.417 468.891 184.026 468.891 184.75C468.891 185.443 468.984 186.034 469.172 186.523C469.365 187.013 469.648 187.388 470.023 187.648C470.404 187.904 470.878 188.031 471.445 188.031C471.898 188.031 472.307 187.984 472.672 187.891C473.036 187.792 473.367 187.677 473.664 187.547V188.703C473.378 188.849 473.057 188.961 472.703 189.039C472.354 189.117 471.938 189.156 471.453 189.156ZM481.531 181.539H478.711V189H477.43V181.539H474.648V180.438H481.531V181.539ZM481.875 180.438H483.266L485.156 185.406C485.266 185.698 485.367 185.979 485.461 186.25C485.555 186.516 485.638 186.771 485.711 187.016C485.784 187.26 485.841 187.497 485.883 187.727H485.938C486.01 187.466 486.115 187.125 486.25 186.703C486.385 186.276 486.531 185.841 486.688 185.398L488.477 180.438H489.875L486.148 190.258C485.951 190.784 485.719 191.242 485.453 191.633C485.193 192.023 484.875 192.323 484.5 192.531C484.125 192.745 483.672 192.852 483.141 192.852C482.896 192.852 482.68 192.836 482.492 192.805C482.305 192.779 482.143 192.747 482.008 192.711V191.672C482.122 191.698 482.26 191.721 482.422 191.742C482.589 191.763 482.76 191.773 482.938 191.773C483.26 191.773 483.539 191.711 483.773 191.586C484.013 191.466 484.219 191.289 484.391 191.055C484.562 190.82 484.711 190.542 484.836 190.219L485.305 189.016L481.875 180.438ZM498.414 180.438V189H497.109V181.555H492.547V189H491.242V180.438H498.414ZM502.398 180.438V185.82C502.398 185.924 502.396 186.06 502.391 186.227C502.385 186.388 502.378 186.562 502.367 186.75C502.357 186.932 502.346 187.109 502.336 187.281C502.331 187.448 502.323 187.586 502.312 187.695L506.984 180.438H508.578V189H507.367V183.75C507.367 183.583 507.37 183.37 507.375 183.109C507.38 182.849 507.388 182.594 507.398 182.344C507.409 182.089 507.417 181.891 507.422 181.75L502.766 189H501.164V180.438H502.398ZM517.172 181.539H514.352V189H513.07V181.539H510.289V180.438H517.172V181.539ZM520.172 183.969H522.797C523.526 183.969 524.133 184.06 524.617 184.242C525.102 184.424 525.464 184.695 525.703 185.055C525.948 185.414 526.07 185.859 526.07 186.391C526.07 186.922 525.951 187.383 525.711 187.773C525.477 188.164 525.112 188.466 524.617 188.68C524.128 188.893 523.495 189 522.719 189H518.867V180.438H520.172V183.969ZM524.766 186.453C524.766 185.927 524.578 185.562 524.203 185.359C523.833 185.151 523.315 185.047 522.648 185.047H520.172V187.945H522.656C523.281 187.945 523.789 187.831 524.18 187.602C524.57 187.367 524.766 186.984 524.766 186.453ZM537.453 180.438H538.883L535.188 184.57L539.18 189H537.656L533.766 184.656V189H532.461V180.438H533.766V184.594L537.453 180.438ZM548.906 180.281C549.974 180.281 550.826 180.648 551.461 181.383C552.096 182.117 552.414 183.221 552.414 184.695C552.414 185.669 552.268 186.487 551.977 187.148C551.685 187.81 551.273 188.31 550.742 188.648C550.216 188.987 549.594 189.156 548.875 189.156C548.422 189.156 548.023 189.096 547.68 188.977C547.336 188.857 547.042 188.695 546.797 188.492C546.552 188.289 546.349 188.068 546.188 187.828H546.094C546.109 188.031 546.128 188.276 546.148 188.562C546.174 188.849 546.188 189.099 546.188 189.312V192.828H544.883V180.438H545.953L546.125 181.703H546.188C546.354 181.443 546.557 181.206 546.797 180.992C547.036 180.773 547.328 180.602 547.672 180.477C548.021 180.346 548.432 180.281 548.906 180.281ZM548.68 181.375C548.086 181.375 547.607 181.49 547.242 181.719C546.883 181.948 546.62 182.292 546.453 182.75C546.286 183.203 546.198 183.773 546.188 184.461V184.711C546.188 185.435 546.266 186.047 546.422 186.547C546.583 187.047 546.846 187.427 547.211 187.688C547.581 187.948 548.076 188.078 548.695 188.078C549.227 188.078 549.669 187.935 550.023 187.648C550.378 187.362 550.641 186.964 550.812 186.453C550.99 185.938 551.078 185.346 551.078 184.68C551.078 183.669 550.88 182.867 550.484 182.273C550.094 181.674 549.492 181.375 548.68 181.375ZM557.883 180.297C558.904 180.297 559.661 180.526 560.156 180.984C560.651 181.443 560.898 182.174 560.898 183.18V189H559.953L559.703 187.734H559.641C559.401 188.047 559.151 188.31 558.891 188.523C558.63 188.732 558.328 188.891 557.984 189C557.646 189.104 557.229 189.156 556.734 189.156C556.214 189.156 555.75 189.065 555.344 188.883C554.943 188.701 554.625 188.424 554.391 188.055C554.161 187.685 554.047 187.216 554.047 186.648C554.047 185.794 554.385 185.138 555.062 184.68C555.74 184.221 556.771 183.971 558.156 183.93L559.633 183.867V183.344C559.633 182.604 559.474 182.086 559.156 181.789C558.839 181.492 558.391 181.344 557.812 181.344C557.365 181.344 556.938 181.409 556.531 181.539C556.125 181.669 555.74 181.823 555.375 182L554.977 181.016C555.362 180.818 555.805 180.648 556.305 180.508C556.805 180.367 557.331 180.297 557.883 180.297ZM559.617 184.781L558.312 184.836C557.245 184.878 556.492 185.052 556.055 185.359C555.617 185.667 555.398 186.102 555.398 186.664C555.398 187.154 555.547 187.516 555.844 187.75C556.141 187.984 556.534 188.102 557.023 188.102C557.784 188.102 558.406 187.891 558.891 187.469C559.375 187.047 559.617 186.414 559.617 185.57V184.781ZM563.125 183.859C563.125 182.641 563.242 181.602 563.477 180.742C563.711 179.878 564.073 179.185 564.562 178.664C565.057 178.138 565.693 177.779 566.469 177.586C567.135 177.404 567.812 177.247 568.5 177.117C569.188 176.982 569.857 176.865 570.508 176.766L570.734 177.906C570.406 177.953 570.062 178.008 569.703 178.07C569.344 178.128 568.984 178.19 568.625 178.258C568.266 178.32 567.927 178.388 567.609 178.461C567.292 178.529 567.01 178.599 566.766 178.672C566.323 178.792 565.94 179 565.617 179.297C565.299 179.594 565.047 180.003 564.859 180.523C564.677 181.044 564.568 181.701 564.531 182.492H564.625C564.781 182.263 564.995 182.036 565.266 181.812C565.536 181.589 565.859 181.404 566.234 181.258C566.609 181.107 567.031 181.031 567.5 181.031C568.24 181.031 568.857 181.193 569.352 181.516C569.846 181.833 570.219 182.281 570.469 182.859C570.719 183.438 570.844 184.115 570.844 184.891C570.844 185.823 570.682 186.607 570.359 187.242C570.042 187.878 569.594 188.357 569.016 188.68C568.438 188.997 567.758 189.156 566.977 189.156C566.372 189.156 565.831 189.039 565.352 188.805C564.878 188.57 564.474 188.227 564.141 187.773C563.812 187.32 563.56 186.766 563.383 186.109C563.211 185.453 563.125 184.703 563.125 183.859ZM567.078 188.078C567.573 188.078 567.997 187.974 568.352 187.766C568.711 187.557 568.987 187.229 569.18 186.781C569.378 186.328 569.477 185.74 569.477 185.016C569.477 184.109 569.302 183.401 568.953 182.891C568.609 182.375 568.057 182.117 567.297 182.117C566.823 182.117 566.393 182.219 566.008 182.422C565.622 182.62 565.297 182.857 565.031 183.133C564.766 183.409 564.573 183.656 564.453 183.875C564.453 184.406 564.492 184.922 564.57 185.422C564.648 185.922 564.784 186.372 564.977 186.773C565.169 187.174 565.435 187.492 565.773 187.727C566.117 187.961 566.552 188.078 567.078 188.078ZM580.469 184.703C580.469 185.406 580.378 186.034 580.195 186.586C580.013 187.138 579.75 187.604 579.406 187.984C579.062 188.365 578.646 188.656 578.156 188.859C577.672 189.057 577.122 189.156 576.508 189.156C575.935 189.156 575.409 189.057 574.93 188.859C574.456 188.656 574.044 188.365 573.695 187.984C573.352 187.604 573.083 187.138 572.891 186.586C572.703 186.034 572.609 185.406 572.609 184.703C572.609 183.766 572.768 182.969 573.086 182.312C573.404 181.651 573.857 181.148 574.445 180.805C575.039 180.456 575.745 180.281 576.562 180.281C577.344 180.281 578.026 180.456 578.609 180.805C579.198 181.154 579.654 181.659 579.977 182.32C580.305 182.977 580.469 183.771 580.469 184.703ZM573.953 184.703C573.953 185.391 574.044 185.987 574.227 186.492C574.409 186.997 574.69 187.388 575.07 187.664C575.451 187.94 575.94 188.078 576.539 188.078C577.133 188.078 577.62 187.94 578 187.664C578.385 187.388 578.669 186.997 578.852 186.492C579.034 185.987 579.125 185.391 579.125 184.703C579.125 184.021 579.034 183.432 578.852 182.938C578.669 182.438 578.388 182.052 578.008 181.781C577.628 181.51 577.135 181.375 576.531 181.375C575.641 181.375 574.987 181.669 574.57 182.258C574.159 182.846 573.953 183.661 573.953 184.703ZM588.547 181.539H585.727V189H584.445V181.539H581.664V180.438H588.547V181.539ZM593.539 180.281C594.268 180.281 594.893 180.443 595.414 180.766C595.935 181.089 596.333 181.542 596.609 182.125C596.885 182.703 597.023 183.38 597.023 184.156V184.961H591.109C591.125 185.966 591.375 186.732 591.859 187.258C592.344 187.784 593.026 188.047 593.906 188.047C594.448 188.047 594.927 187.997 595.344 187.898C595.76 187.799 596.193 187.654 596.641 187.461V188.602C596.208 188.794 595.779 188.935 595.352 189.023C594.93 189.112 594.43 189.156 593.852 189.156C593.029 189.156 592.31 188.99 591.695 188.656C591.086 188.318 590.612 187.823 590.273 187.172C589.935 186.521 589.766 185.724 589.766 184.781C589.766 183.859 589.919 183.062 590.227 182.391C590.539 181.714 590.977 181.193 591.539 180.828C592.107 180.464 592.773 180.281 593.539 180.281ZM593.523 181.344C592.831 181.344 592.279 181.57 591.867 182.023C591.456 182.477 591.211 183.109 591.133 183.922H595.664C595.659 183.411 595.578 182.964 595.422 182.578C595.271 182.188 595.039 181.885 594.727 181.672C594.414 181.453 594.013 181.344 593.523 181.344ZM599.031 188.188C599.031 187.823 599.12 187.565 599.297 187.414C599.474 187.258 599.69 187.18 599.945 187.18C600.211 187.18 600.435 187.258 600.617 187.414C600.799 187.565 600.891 187.823 600.891 188.188C600.891 188.547 600.799 188.81 600.617 188.977C600.435 189.138 600.211 189.219 599.945 189.219C599.69 189.219 599.474 189.138 599.297 188.977C599.12 188.81 599.031 188.547 599.031 188.188Z",
    fill: "#717171"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_241_232257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 682,
    height: 770,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_241_232257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 682,
    height: 770,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_241_232257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 38.4,
    fill: "white",
    transform: "translate(38 30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_241_232257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 38.4,
    fill: "white",
    transform: "translate(38 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillProfile);
export default __webpack_public_path__ + "static/media/fill_profile.e4c29379610d62dfaf9e87e980ea3366.svg";
export { ForwardRef as ReactComponent };